import { defineMessages } from 'react-intl';
export default defineMessages({
  statisticsStopAddTitle: {
    id: 'app.globalMessages.statisticsStopAddTitle',
    defaultMessage: 'Add stop · {area}'
  },
  statisticsStopEditTitle: {
    id: 'app.globalMessages.statisticsStopEditTitle',
    defaultMessage: 'Edit stop · {area}'
  },
  statisticsStopStartTime: {
    id: 'app.globalMessages.statisticsStopStartTime',
    defaultMessage: 'Start time ({timezone})'
  },
  statisticsStopSiteTime: {
    id: 'app.globalMessages.statisticsStopSiteTime',
    defaultMessage: 'Site time: {time} ({timezone})'
  },
  statisticsStopDuration: {
    id: 'app.globalMessages.statisticsStopDuration',
    defaultMessage: 'Duration (minutes)'
  },
  statisticsStopReasonLabel: {
    id: 'app.globalMessages.statisticsStopReasonLabel',
    defaultMessage: 'Reason'
  },
  statisticsStopLocationLabel: {
    id: 'app.globalMessages.statisticsStopLocationLabel',
    defaultMessage: 'Location / machine (optional)'
  },
  statisticsStopIssueLabel: {
    id: 'app.globalMessages.statisticsStopIssueLabel',
    defaultMessage: 'Issue'
  },
  statisticsStopIssueFournier: {
    id: 'app.globalMessages.statisticsStopIssueFournier',
    defaultMessage: 'Fournier'
  },
  statisticsStopIssueLedinek: {
    id: 'app.globalMessages.statisticsStopIssueLedinek',
    defaultMessage: 'Ledinek'
  },
  statisticsStopIssueOther: {
    id: 'app.globalMessages.statisticsStopIssueOther',
    defaultMessage: 'Other'
  },
  statisticsStopSelectGraph: {
    id: 'app.globalMessages.statisticsStopSelectGraph',
    defaultMessage: 'Select on graph'
  },
  statisticsStopSave: {
    id: 'app.globalMessages.statisticsStopSave',
    defaultMessage: 'Save stop'
  },
  statisticsStopSaving: {
    id: 'app.globalMessages.statisticsStopSaving',
    defaultMessage: 'Saving stop'
  },
  statisticsStopInvalidFields: {
    id: 'app.globalMessages.statisticsStopInvalidFields',
    defaultMessage: 'Enter a valid start time, a positive duration and a reason.'
  },
  statisticsStopSaveFailed: {
    id: 'app.globalMessages.statisticsStopSaveFailed',
    defaultMessage: 'Could not save the stop. Please try again.'
  },
  statisticsStopDeleteReason: {
    id: 'app.globalMessages.statisticsStopDeleteReason',
    defaultMessage: 'Delete reason: {name}'
  },
  statisticsStopDeleteReasonConfirmation: {
    id: 'app.globalMessages.statisticsStopDeleteReasonConfirmation',
    defaultMessage: 'Delete this saved reason? Existing stops will keep their recorded text.\n{name}'
  },
  statisticsStopReasonDeleteFailed: {
    id: 'app.globalMessages.statisticsStopReasonDeleteFailed',
    defaultMessage: 'Could not delete the reason. Please try again.'
  },
  statisticsStopDeleteLocation: {
    id: 'app.globalMessages.statisticsStopDeleteLocation',
    defaultMessage: 'Delete location: {name}'
  },
  statisticsStopDeleteLocationConfirmation: {
    id: 'app.globalMessages.statisticsStopDeleteLocationConfirmation',
    defaultMessage: 'Delete this saved location? Existing stops will keep their recorded location.\n{name}'
  },
  statisticsStopLocationDeleteFailed: {
    id: 'app.globalMessages.statisticsStopLocationDeleteFailed',
    defaultMessage: 'Could not delete the location. Please try again.'
  },
  statisticsStopReasonLanguagesHint: {
    id: 'app.globalMessages.statisticsStopReasonLanguagesHint',
    defaultMessage: 'Enter English, French or both. A missing translation uses the supplied text.'
  },
  statisticsStopLocations: {
    id: 'app.globalMessages.statisticsStopLocations',
    defaultMessage: 'Locations'
  },
  statisticsStopNoLocations: {
    id: 'app.globalMessages.statisticsStopNoLocations',
    defaultMessage: 'No saved locations yet.'
  },
  statisticsStopAddReason: {
    id: 'app.globalMessages.statisticsStopAddReason',
    defaultMessage: 'Add a new reason'
  },
  statisticsStopAddLocation: {
    id: 'app.globalMessages.statisticsStopAddLocation',
    defaultMessage: 'Add a location'
  },
  statisticsStopSaveReason: {
    id: 'app.globalMessages.statisticsStopSaveReason',
    defaultMessage: 'Save reason'
  },
  statisticsStopSaveLocation: {
    id: 'app.globalMessages.statisticsStopSaveLocation',
    defaultMessage: 'Save location'
  },
  statisticsStopReasonEnglish: {
    id: 'app.globalMessages.statisticsStopReasonEnglish',
    defaultMessage: 'English reason (optional)'
  },
  statisticsStopReasonFrench: {
    id: 'app.globalMessages.statisticsStopReasonFrench',
    defaultMessage: 'French reason (optional)'
  },
  statisticsStopNewLocation: {
    id: 'app.globalMessages.statisticsStopNewLocation',
    defaultMessage: 'New location'
  },
  statisticsStopNoReasons: {
    id: 'app.globalMessages.statisticsStopNoReasons',
    defaultMessage: 'No saved reasons yet.'
  },
  statisticsStopPresetsLoading: {
    id: 'app.globalMessages.statisticsStopPresetsLoading',
    defaultMessage: 'Loading reasons and locations'
  },
  statisticsStopPresetsLoadFailed: {
    id: 'app.globalMessages.statisticsStopPresetsLoadFailed',
    defaultMessage: 'Could not load reasons and locations. Close and reopen the form to retry.'
  },
  statisticsStopPresetSaveFailed: {
    id: 'app.globalMessages.statisticsStopPresetSaveFailed',
    defaultMessage: 'Could not save this option. Please try again.'
  },
  statisticsStopReasonPresets: {
    id: 'app.globalMessages.statisticsStopReasonPresets',
    defaultMessage: 'Common reasons'
  },
  statisticsStopNoLocation: {
    id: 'app.globalMessages.statisticsStopNoLocation',
    defaultMessage: 'No location'
  },
  paused: {
    id: 'app.globalMessages.paused',
    defaultMessage: 'Paused'
  },
  enableStatisticsCameras: {
    id: 'app.globalMessages.enableStatisticsCameras',
    defaultMessage: 'Enable cameras'
  },
  disableStatisticsCameras: {
    id: 'app.globalMessages.disableStatisticsCameras',
    defaultMessage: 'Disable cameras'
  },
  statisticsCameraMissing: {
    id: 'app.globalMessages.statisticsCameraMissing',
    defaultMessage: 'Camera "{name}" was not found or has no recording address.'
  },
  statisticsCameraAmbiguous: {
    id: 'app.globalMessages.statisticsCameraAmbiguous',
    defaultMessage: 'More than one camera is named "{name}". Camera names must be unique for statistics playback.'
  },
  statisticsCameraLoadFailed: {
    id: 'app.globalMessages.statisticsCameraLoadFailed',
    defaultMessage: 'Could not load camera "{name}". Disable and enable cameras to retry.'
  },
  expandPanel: {
    id: 'app.globalMessages.expandPanel',
    defaultMessage: 'Expand panel'
  },
  collapsePanel: {
    id: 'app.globalMessages.collapsePanel',
    defaultMessage: 'Collapse panel'
  },
  batchGroup: {
    id: 'app.globalMessages.batchGroup',
    defaultMessage: 'Batch group (0 = unassigned)'
  },
  snapToEdges: {
    id: 'app.globalMessages.snapToEdges',
    defaultMessage: 'Snap to edges'
  },
  stopSnapSelectionHint: {
    id: 'app.globalMessages.stopSnapSelectionHint',
    defaultMessage: 'Click a zero-output gap to select the stop start and end.'
  },
  stopDragSelectionHint: {
    id: 'app.globalMessages.stopDragSelectionHint',
    defaultMessage: 'Drag across the graph to select the stop start and end.'
  },
  'app.components.filters.toggleFilter': {
    id: 'app.components.filters.toggleFilter',
    defaultMessage: 'Show Filter Row'
  },
  identified: {
    id: 'app.containers.Terminal.identified',
    defaultMessage: 'Identified'
  },
  unidentified: {
    id: 'app.containers.Terminal.unidentified',
    defaultMessage: 'Unidentified'
  },
  pressOrders: {
    id: 'app.containers.Press.pressOrders',
    defaultMessage: 'Press Orders'
  },
  infeedPackagesOrder: {
    id: 'app.containers.Press.infeedPackagesOrder',
    defaultMessage: 'Infeed Packages Order'
  },
  db2javaMessage: {
    id: 'app.containers.Db2Java',
    defaultMessage: 'DB to Java'
  },
  orderForSorting: {
    id: 'app.containers.Press.orderForSorting',
    defaultMessage: 'Order for sorting?'
  },
  selectedProcess: {
    id: 'app.containers.Press.selectedProcess',
    defaultMessage: 'Process'
  },
  beamTitle: {
    id: 'app.containers.Press.beamTitle',
    defaultMessage: 'Beam'
  },
  produceBetterQualityFirst: {
    id: 'app.containers.globalSettings.produceBetterQualityFirst',
    defaultMessage: 'Produce Better Quality First'
  },
  manageServer: {
    id: 'app.containers.ManageServerModal.manageServer',
    defaultMessage: 'Manage Server'
  },
  statisticSettings: {
    id: 'app.components.Statistics.settings',
    defaultMessage: 'Statistic Settings'
  },
  unitSystem: {
    id: 'app.components.unitSystem',
    defaultMessage: 'Unit System'
  },
  zPressTitle: {
    id: 'app.containers.DashboardXLAM.zPressTitle',
    defaultMessage: 'ZPress'
  },
  zpressLongLamellas: {
    id: 'app.components.SideMenu.zpressLongLamellas',
    defaultMessage: 'Long Lamellas'
  },
  zpressShortLamellas: {
    id: 'app.components.SideMenu.zpressShortLamellas',
    defaultMessage: 'Short Lamellas'
  },
  allowanceNewPanelToSanding: {
    id: 'app.containers.Sanding.allowanceNewPanelToSanding',
    defaultMessage: 'allowanceNewPanelToSanding'
  },
  allowanceNewDataBeforeBypass: {
    id: 'app.containers.Sanding.allowanceNewDataBeforeBypass',
    defaultMessage: 'allowanceNewDataBeforeBypass'
  },
  flipCLTready: {
    id: 'app.containers.Sanding.flipCLTready',
    defaultMessage: 'flipCLTready'
  },
  flipCLTrunning: {
    id: 'app.containers.Sanding.flipCLTrunning',
    defaultMessage: 'flipCLTrunning'
  },
  flipCLTdone: {
    id: 'app.containers.Sanding.flipCLTdone',
    defaultMessage: 'flipCLTdone'
  },
  turningAllowancePC: {
    id: 'app.containers.Sanding.turningAllowancePC',
    defaultMessage: 'turningAllowancePC'
  },
  selectLinestatusTime: {
    id: 'app.containers.Sidebar.selectLinestatusTime',
    defaultMessage: 'Select linestatus time'
  },
  loadStatus: {
    id: 'app.containers.Sidebar.loadStatus',
    defaultMessage: 'Load Status'
  },
  confirmLoadStatus: {
    id: 'app.containers.Sidebar.confirmLoadStatus',
    defaultMessage: 'Confirm Load Status'
  },
  selectProcess: {
    id: 'app.containers.Sidebar.selectProcess',
    defaultMessage: 'Select process'
  },
  loadStatusQuestion: {
    id: 'app.containers.Sidebar.loadStatusQuestion',
    defaultMessage: 'Are you sure you want to load the line status for the following date and time?'
  },
  downloadStatus: {
    id: 'app.containers.Sidebar.downloadStatus',
    defaultMessage: 'Download Status'
  },
  incomingPackagesFullName: {
    id: 'app.containers.Sidebar.incomingPackages',
    defaultMessage: 'Incoming Packages'
  },
  sortedPackagesFullName: {
    id: 'app.containers.Sidebar.sortedPackages',
    defaultMessage: 'Sorted Packages'
  },
  allowanceNewDataBeforeSanding: {
    id: 'app.containers.Sanding.allowanceNewDataBeforeSanding',
    defaultMessage: 'allowanceNewDataBeforeSanding'
  },
  allowanceNewDataAfterBypass: {
    id: 'app.containers.Sanding.allowanceNewDataAfterBypass',
    defaultMessage: 'allowanceNewDataAfterBypass'
  },
  allowanceNewDataAfterSanding: {
    id: 'app.containers.Sanding.allowanceNewDataAfterSanding',
    defaultMessage: 'allowanceNewDataAfterSanding'
  },
  allowanceNewDataAfterSandingMiddle: {
    id: 'app.containers.Sanding.allowanceNewDataAfterSandingMiddle',
    defaultMessage: 'allowanceNewDataAfterSandingMiddle'
  },
  turnTable: {
    id: 'app.components.SideMenu.turnTable',
    defaultMessage: 'Turn Table'
  },
  schneiderProducing: {
    id: 'app.components.SideMenu.schneiderProducing',
    defaultMessage: 'Producing'
  },
  schneiderReady: {
    id: 'app.components.SideMenu.schneiderReady',
    defaultMessage: 'Ready'
  },
  schneiderTodo: {
    id: 'app.components.SideMenu.schneiderTodo',
    defaultMessage: 'Todo'
  },
  brokenLayer: {
    id: 'app.components.confirmation.brokenLayer',
    defaultMessage: 'Broken'
  },
  shitPlate: {
    id: 'app.components.confirmation.shitPlate',
    defaultMessage: 'Defect'
  },
  cutAtSaw: {
    id: 'app.components.confirmation.cutAtSaw',
    defaultMessage: 'Cut at Saw'
  },
  seeEverywhere: {
    id: 'app.components.confirmation.seeEverywhere',
    defaultMessage: 'See Everywhere'
  },
  noGroupAvailable: {
    id: 'app.components.customModal.noGroupAvailable',
    defaultMessage: 'No Group Available'
  },
  timeDistribution: {
    id: 'app.containers.Insights.timeDistribution',
    defaultMessage: 'Time Distribution'
  },
  active: {
    id: 'app.containers.Insights.active',
    defaultMessage: 'Active'
  },
  passive: {
    id: 'app.containers.Insights.passive',
    defaultMessage: 'Passive'
  },
  lineHealth: {
    id: 'app.containers.Insights.lineHealth',
    defaultMessage: 'Line Health'
  },
  startDate: {
    id: 'app.containers.Insights.startDate',
    defaultMessage: 'Start Date'
  },
  endDate: {
    id: 'app.containers.Insights.endDate',
    defaultMessage: 'End Date'
  },
  windowLength: {
    id: 'app.containers.Insights.windowLength',
    defaultMessage: 'Window Length'
  },
  zinkCycle: {
    id: 'app.containers.Insights.zinkCycle',
    defaultMessage: 'Zink Cycle'
  },
  zinkCycleAverage: {
    id: 'app.containers.Insights.zinkCycleAverage',
    defaultMessage: 'Zink Cycle Average'
  },
  zinkCycleCumulative: {
    id: 'app.containers.Insights.zinkCycleCumulative',
    defaultMessage: 'Zink Cycle Cumulative'
  },
  sumMainChain: {
    id: 'app.containers.Insights.sumMainChain',
    defaultMessage: 'Main chain'
  },
  sumMainChainAverage: {
    id: 'app.containers.Insights.sumMainChainAverage',
    defaultMessage: 'Main Chain Average'
  },
  sumMainChainCumulative: {
    id: 'app.containers.Insights.sumMainChainCumulative',
    defaultMessage: 'Main Chain Cumulative'
  },
  sumEntryChain: {
    id: 'app.containers.Insights.sumEntryChain',
    defaultMessage: 'Entry chain'
  },
  sumEntryChainAverage: {
    id: 'app.containers.Insights.sumEntryChainAverage',
    defaultMessage: 'Entry Chain Average'
  },
  sumEntryChainCumulative: {
    id: 'app.containers.Insights.sumEntryChainCumulative',
    defaultMessage: 'Entry Chain Cumulative'
  },
  sumWoodInMeas: {
    id: 'app.containers.Insights.sumWoodInMeas',
    defaultMessage: 'Wood Meas'
  },
  wood: {
    id: 'app.containers.Insights.wood',
    defaultMessage: 'Wood'
  },
  sumWoodInMeasAverage: {
    id: 'app.containers.Insights.sumWoodInMeasAverage',
    defaultMessage: 'Wood Meas Average'
  },
  sumWoodInMeasCumulative: {
    id: 'app.containers.Insights.sumWoodInMeasCumulative',
    defaultMessage: 'Wood Meas Cumulative'
  },
  sumPow: {
    id: 'app.containers.Insights.sumPow',
    defaultMessage: 'Pow'
  },
  sumPowAverage: {
    id: 'app.containers.Insights.sumPowAverage',
    defaultMessage: 'Pow Average'
  },
  sumPowCumulative: {
    id: 'app.containers.Insights.sumPowCumulative',
    defaultMessage: 'Pow Cumulative'
  },
  sumWoodInInfeed: {
    id: 'app.containers.Insights.sumWoodInInfeed',
    defaultMessage: 'In infeed'
  },
  sumWoodInInfeedAverage: {
    id: 'app.containers.Insights.sumWoodInInfeedAverage',
    defaultMessage: 'In Infeed Average'
  },
  sumWoodInInfeedCumulative: {
    id: 'app.containers.Insights.sumWoodInInfeedCumulative',
    defaultMessage: 'InInfeed Cumulative'
  },
  together: {
    id: 'app.containers.Insights.together',
    defaultMessage: 'Together'
  },
  togetherAverage: {
    id: 'app.containers.Insights.togetherAverage',
    defaultMessage: 'Together Average'
  },
  togetherCumulative: {
    id: 'app.containers.Insights.togetherCumulative',
    defaultMessage: 'Together Cumulative'
  },
  zpressCycle: {
    id: 'app.containers.Insights.zpressCycle',
    defaultMessage: 'Zpress Cycle'
  },
  zpressCycleAverage: {
    id: 'app.containers.Insights.zpressCycleAverage',
    defaultMessage: 'Zpress Cycle Average'
  },
  zpressCycleCumulative: {
    id: 'app.containers.Insights.zpressCycleCumulative',
    defaultMessage: 'Zpress Cycle Cumulative'
  },
  lamellaLengthAverage: {
    id: 'app.containers.Insights.lamellaLengthAverage',
    defaultMessage: 'Lamella Length Average'
  },
  lamellaLengthCumulative: {
    id: 'app.containers.Insights.lamellaLengthCumulative',
    defaultMessage: 'Lamella Length Cumulative'
  },
  sendMessageToAllClients: {
    id: 'app.containers.WebsocketMessageModal.sendMessageToAllClients',
    defaultMessage: 'Send message to all clients'
  },
  newMessageFromAdmin: {
    id: 'app.containers.WebsocketMessageModal.newMessageFromAdmin',
    defaultMessage: 'New message from admin'
  },
  assignedPackage: {
    id: 'app.containers.RawInfeedLoadingBox.assignedPackage',
    defaultMessage: 'Assigned Package'
  },
  assignedPackageA: {
    id: 'app.containers.RawInfeedLoadingBox.assignedPackageA',
    defaultMessage: 'Assigned Package A'
  },
  assignedPackageB: {
    id: 'app.containers.RawInfeedLoadingBox.assignedPackageB',
    defaultMessage: 'Assigned Package B'
  },
  boardPlanned: {
    id: 'app.containers.RawInfeedLoadingBox.boardPlanned',
    defaultMessage: 'Board Planed'
  },
  vacuumAlowance: {
    id: 'app.containers.RawInfeedLoadingBox.vacuumAlowance',
    defaultMessage: 'Vacuum Allowance'
  },
  packageOnLineConfirmed: {
    id: 'app.containers.RawInfeedLoadingBox.packageOnLineConfirmed',
    defaultMessage: 'Package Confirmed'
  },
  lineEmptybetweenVacuumAndSPL: {
    id: 'app.containers.RawInfeedLoadingBox.lineEmptybetweenVacuumAndSPL',
    defaultMessage: 'Line Before SPL Empty'
  },
  signlingEmpty: {
    id: 'app.containers.RawInfeedLoadingBox.signlingEmpty',
    defaultMessage: 'Signling empty'
  },
  infeed: {
    id: 'app.containers.RawInfeedLoadingBox.infeed',
    defaultMessage: 'Infeed'
  },
  sortingLine1Empty: {
    id: 'app.containers.RawInfeedLoadingBox.sortingLine1Empty',
    defaultMessage: 'Sorting Line 1 Empty'
  },
  sortingLine2Empty: {
    id: 'app.containers.RawInfeedLoadingBox.sortingLine2Empty',
    defaultMessage: 'Sorting Line 2 Empty'
  },
  carousel: {
    id: 'app.containers.Machines.carousel',
    defaultMessage: 'Carousel'
  },
  noSettings: {
    id: 'app.containers.PlanerSettingsBox.noSettings',
    defaultMessage: 'No settings...'
  },
  noMovementOrders: {
    id: 'app.components.ListViewConf.noMovementOrders',
    defaultMessage: 'No Movement Orders'
  },
  noPackagesOrdered: {
    id: 'app.components.ListViewConf.noPackagesOrdered',
    defaultMessage: 'No Packages Ordered'
  },
  noPackage: {
    id: 'app.components.ListViewConf.noPackage',
    defaultMessage: 'No Package'
  },
  noHistoryStatus: {
    id: 'app.components.ListViewConf.noHistoryStatus',
    defaultMessage: 'No History Status'
  },
  planerSetup: {
    id: 'app.containers.planerSetup',
    defaultMessage: 'Planer Setup'
  },
  schneiderPlanerSetup: {
    id: 'app.containers.schneiderPlanerSetup',
    defaultMessage: 'Planer Setup'
  },
  taskManager: {
    id: 'app.containers.taskManager',
    defaultMessage: 'Task Manager'
  },
  addPlanerSetup: {
    id: 'app.containers.planerSetup.addPlanerSetup',
    defaultMessage: 'Add New Setup'
  },
  getOrdersQueueCSV: {
    id: 'app.containers.planerSetup.getOrdersQueueCSV',
    defaultMessage: 'Get Orders Queue CSV'
  },
  getJDQueueCSV: {
    id: 'app.containers.planerSetup.getJDQueueCSV',
    defaultMessage: 'Get JD Queue CSV'
  },
  xmPressCompartments: {
    id: 'app.containers.Machines.xmPressCompartments',
    defaultMessage: 'XMPress'
  },
  xmPressFreigabe: {
    id: 'app.containers.Machines.xmPressCompartments',
    defaultMessage: 'XmPress Available To Receive Data'
  },
  xmPressActive: {
    id: 'app.containers.Machines.xmPressActive',
    defaultMessage: 'Panel in Press'
  },
  lamellaBreak: {
    id: 'app.containers.lamellaBreak',
    defaultMessage: 'Carpet'
  },
  lamellaBreakZpress: {
    id: 'app.containers.lamellaBreakZpress',
    defaultMessage: 'Carpet - ZP'
  },
  lamellaBreakUnipress: {
    id: 'app.containers.lamellaBreakUnipress',
    defaultMessage: 'Carpet - Uni'
  },
  enoughForCurrentCarpet: {
    id: 'app.containers.LamellaBreak.enoughForCurrentCarpet',
    defaultMessage: 'Enough For Current Carpet'
  },
  allowanceNewData: {
    id: 'app.containers.LamellaBreak.allowanceNewData',
    defaultMessage: 'Allow New Data'
  },
  sawDataAllowance: {
    id: 'app.containers.LamellaBreak.sawDataAllowance',
    defaultMessage: 'Allow Saw Data'
  },
  allowance: {
    id: 'app.containers.LamellaBreak.allowance',
    defaultMessage: 'Allowance'
  },
  willFinishAndDataOk: {
    id: 'app.containers.LamellaBreak.willFinishAndDataOk',
    defaultMessage: 'Will Finish & OK'
  },
  weWillFinish: {
    id: 'app.containers.LamellaBreak.weWillFinish',
    defaultMessage: 'Will Finish'
  },
  nextOrder: {
    id: 'app.containers.LamellaBreak.nextOrder',
    defaultMessage: 'Next Order'
  },
  pressEmpty: {
    id: 'app.containers.LamellaBreak.pressEmpty',
    defaultMessage: 'Press Empty'
  },
  ktzInPos: {
    id: 'app.globalMessages.errors.ktzInPos',
    defaultMessage: 'KTZ in position'
  },
  autoInfeed: {
    id: 'app.globalMessages.errors.autoInfeed',
    defaultMessage: 'Infeed automatic mode'
  },
  autoKtz: {
    id: 'app.globalMessages.errors.autoKtz',
    defaultMessage: 'KTZ automatic mode'
  },
  autoPressSaw: {
    id: 'app.globalMessages.errors.autoPressSaw',
    defaultMessage: 'Press saw automatic mode'
  },
  extractionOk: {
    id: 'app.globalMessages.errors.extractionOk',
    defaultMessage: 'Extraction OK'
  },
  oestOk: {
    id: 'app.globalMessages.errors.oestOk',
    defaultMessage: 'OEST OK'
  },
  b31Error: {
    id: 'app.globalMessages.errors.b31Error',
    defaultMessage: 'B31 error'
  },
  b32Error: {
    id: 'app.globalMessages.errors.b32Error',
    defaultMessage: 'B32 error'
  },
  b33Error: {
    id: 'app.globalMessages.errors.b33Error',
    defaultMessage: 'B33 error'
  },
  dimensionChangeStarted: {
    id: 'app.globalMessages.errors.dimensionChangeStarted',
    defaultMessage: 'Dimension change started'
  },
  newDimNotAtInfeed: {
    id: 'app.globalMessages.errors.newDimNotAtInfeed',
    defaultMessage: 'New dimension not at infeed'
  },
  operatorDisabledFeeding: {
    id: 'app.globalMessages.errors.operatorDisabledFeeding',
    defaultMessage: 'Feeding disabled by operator'
  },
  dataOk: {
    id: 'app.containers.LamellaBreak.dataOk',
    defaultMessage: 'Data OK'
  },
  waitForWoodToZinc: {
    id: 'app.containers.LamellaBreak.waitForWoodToZinc',
    defaultMessage: 'Please wait for wood to come to zinc'
  },
  vacuumTitle: {
    id: 'app.containers.DashboardXLAM.vacuumTitle',
    defaultMessage: 'Vacuum'
  },
  vacuum1Title: {
    id: 'app.containers.DashboardXLAM.vacuum1Title',
    defaultMessage: 'Vacuum 1'
  },
  vacuum2Title: {
    id: 'app.containers.DashboardXLAM.vacuum2Title',
    defaultMessage: 'Vacuum 2'
  },
  vacuumInsulationTitle: {
    id: 'app.containers.DashboardXLAM.vacuumInsulationTitle',
    defaultMessage: 'Vacuum Insulation'
  },
  xcutTitle: {
    id: 'app.containers.DashboardXLAM.xcutTitle',
    defaultMessage: 'XCUT'
  },
  xcutBoxSubtitle: {
    id: 'app.containers.DashboardXLAM.xcutBoxSubtitle',
    defaultMessage: 'Scan report | Lamellas before XCut'
  },
  cameraMonitoring: {
    id: 'app.containers.cameras.cameraMonitoring',
    defaultMessage: 'Camera Monitoring'
  },
  topOffsetFirstPage: {
    id: 'app.containers.DBUploadModal.topOffsetFirstPage',
    defaultMessage: 'Top Offset First Page'
  },
  topOffsetAllPages: {
    id: 'app.containers.DBUploadModal.topOffsetAllPages',
    defaultMessage: 'Top Offset All Pages'
  },
  pleaseWait: {
    id: 'app.containers.DBUploadModal.pleaseWait',
    defaultMessage: 'Please wait while the file is being processed'
  },
  accuTitle: {
    id: 'app.containers.DashboardXLAM.accuTitle',
    defaultMessage: 'Accumulator'
  },
  zincTitle: {
    id: 'app.containers.DashboardXLAM.zincTitle',
    defaultMessage: 'Zinc'
  },
  zinc1Title: {
    id: 'app.containers.DashboardXLAM.zinc1Title',
    defaultMessage: 'Zinc'
  },
  zinc2Title: {
    id: 'app.containers.DashboardXLAM.zinc2Title',
    defaultMessage: 'Zinc'
  },
  liftSettings: {
    id: 'app.containers.DashboardXLAM.liftSettings',
    defaultMessage: 'Lift settings'
  },
  shuttle: {
    id: 'app.containers.DashboardXLAM.shuttle',
    defaultMessage: 'Shuttle'
  },
  etageLagerTitle: {
    id: 'app.containers.DashboardXLAM.etageLagerTitle',
    defaultMessage: 'Etage Lager'
  },
  etageLagerSubtitle: {
    id: 'app.containers.DashboardXLAM.etageLagerSubtitle',
    defaultMessage: 'Etage Lager Subtitle'
  },
  wraworSawZincTitle: {
    id: 'app.containers.DashboardXLAM.wraworSawZincTitle',
    defaultMessage: 'WRAWOR Saw'
  },
  xFormTitle: {
    id: 'app.containers.DashboardXLAM.xFormTitle',
    defaultMessage: 'XForm'
  },
  BrookhuisTitle: {
    id: 'app.containers.DashboardXLAM.BrookhuisTitle',
    defaultMessage: 'Wood moisture'
  },
  miniZincTitle: {
    id: 'app.containers.DashboardXLAM.miniZincTitle',
    defaultMessage: 'Mini Zinc'
  },
  xmPressTitle: {
    id: 'app.containers.DashboardXLAM.xmPressTitle',
    defaultMessage: 'XM Press '
  },
  emptyFromChainPossible: {
    id: 'app.containers.editview.emptyFromChainPossible',
    defaultMessage: 'Empty From Chain Available'
  },
  emptyFromVacuumPossible: {
    id: 'app.containers.editview.emptyFromVacuumPossible',
    defaultMessage: 'Empty From Vacuum Available'
  },
  emptyComplete: {
    id: 'app.containers.editview.emptyComplete',
    defaultMessage: 'Batch Processing'
  },
  batchProcess: {
    id: 'app.containers.editview.batchProcess',
    defaultMessage: 'Batch Process'
  },
  chainEmptying: {
    id: 'app.containers.editview.chainEmptying',
    defaultMessage: 'Emptying Chain'
  },
  forkliftTitle: {
    id: 'app.containers.DashboardXLAM.forkliftTitle',
    defaultMessage: 'Forklift'
  },
  wraworSaw: {
    id: 'app.containers.DashboardXLAM.wraworSaw',
    defaultMessage: 'Wrawor Saw'
  },
  wraworSawZinc: {
    id: 'app.containers.DashboardXLAM.wraworSawZinc',
    defaultMessage: 'Wrawor Saw / xForm'
  },
  loadedPackagesTitle: {
    id: 'app.containers.DashboardXLAM.loadedPackagesTitle',
    defaultMessage: 'Loaded Packages'
  },
  beforeLagerTitle: {
    id: 'app.containers.DashboardXLAM.beforeLagerTitle',
    defaultMessage: 'Before Storage'
  },
  smartyTitle: {
    id: 'app.containers.DashboardXLAM.smartyTitle',
    defaultMessage: 'Smarty'
  },
  markedLamella: {
    id: 'app.containers.DashboardXLAM.markedLamella',
    defaultMessage: 'Marked Lamella'
  },
  multiplanTitle: {
    id: 'app.containers.DashboardXLAM.multiplanTitle',
    defaultMessage: 'Multiplan'
  },
  etageLagerSolisTitle: {
    id: 'app.containers.DashboardXLAM.etageLagerSolisTitle',
    defaultMessage: 'Lamella Lager'
  },
  scannedLast: {
    id: 'app.containers.DashboardXLAM.scannedLast',
    defaultMessage: 'Scanned Last'
  },
  planerTitle: {
    id: 'app.containers.DashboardXLAM.planerTitle',
    defaultMessage: 'Planer'
  },
  europlan: {
    id: 'app.containers.DashboardXLAM.EuroplanSubTitle',
    defaultMessage: 'Europlan'
  },
  zPressShortTitle: {
    id: 'app.containers.DashboardXLAM.zPressShortTitle',
    defaultMessage: 'ZPress Short'
  },
  zPressLongTitle: {
    id: 'app.containers.DashboardXLAM.zPressLongTitle',
    defaultMessage: 'ZPress Long'
  },
  ZPressShortInfo: {
    id: 'app.containers.DashboardXLAM.ZPressShortInfo',
    defaultMessage: 'ZPress Short Info'
  },
  ZPressLongInfo: {
    id: 'app.containers.DashboardXLAM.ZPressLongInfo',
    defaultMessage: 'ZPress Short Info'
  },
  holdersTitle: {
    id: 'app.containers.DashboardXLAM.holdersTitle',
    defaultMessage: 'Holders'
  },
  platesTitle: {
    id: 'app.containers.DashboardXLAM.platesTitle',
    defaultMessage: 'Plates'
  },
  afterLKSTitle: {
    id: 'app.containers.DashboardXLAM.afterLKSTitle',
    defaultMessage: 'CC vacuum'
  },
  LKSTitle: {
    id: 'app.containers.DashboardXLAM.LKSTitle',
    defaultMessage: 'LKS'
  },
  SPLTitle: {
    id: 'app.containers.DashboardXLAM.SPLTitle',
    defaultMessage: 'SPL'
  },
  pressTitle: {
    id: 'app.containers.DashboardXLAM.pressTitle',
    defaultMessage: 'Press'
  },
  pressDataTitle: {
    id: 'app.containers.DashboardXLAM.pressDataTitle',
    defaultMessage: 'Press Data'
  },
  xpressSubtitle: {
    id: 'app.containers.DashboardXLAM.xpressSubtitle',
    defaultMessage: 'Xpress Info'
  },
  b11pressSubtitle: {
    id: 'app.containers.DashboardXLAM.b11pressSubtitle',
    defaultMessage: 'B11 | Press'
  },
  pressTitle1: {
    id: 'app.containers.DashboardXLAM.pressTitle1',
    defaultMessage: 'Press 1'
  },
  pressTitle2: {
    id: 'app.containers.DashboardXLAM.pressTitle2',
    defaultMessage: 'Press 2'
  },
  liftStatusTitle: {
    id: 'app.containers.DashboardXLAM.liftStatusTitle',
    defaultMessage: 'Lift status'
  },
  rcstackStatusTitle: {
    id: 'app.containers.DashboardXLAM.rcstackStatusTitle',
    defaultMessage: 'RC Stack'
  },
  lastSendCncStackToErpTitle: {
    id: 'app.containers.DashboardXLAM.lastSendCncStackToErpTitle',
    defaultMessage: 'Last CNC Stack Sent to ERP'
  },
  resendErpSignalOnCnc: {
    id: 'app.containers.DashboardXLAM.resendErpSignalOnCnc',
    defaultMessage: 'Resend ERP signal on CNC'
  },
  exitTitle: {
    id: 'app.containers.DashboardXLAM.exitTitle',
    defaultMessage: 'Exit'
  },
  rotopressTitle: {
    id: 'app.containers.DashboardXLAM.rotopressTitle',
    defaultMessage: 'Rotopress'
  },
  emptyingOrder: {
    id: 'app.containers.DashboardXLAM.emptyingOrder',
    defaultMessage: 'Emptying Order'
  },
  beamOrder: {
    id: 'app.containers.DashboardXLAM.beamOrder',
    defaultMessage: 'Beam Order'
  },
  'roto-order1': {
    id: 'app.containers.DashboardXLAM.roto-order1',
    defaultMessage: 'Roto Order 1'
  },
  'roto-order2': {
    id: 'app.containers.DashboardXLAM.roto-order2',
    defaultMessage: 'Roto Order 2'
  },
  'flexi-order1': {
    id: 'app.containers.DashboardXLAM.flexi-order1',
    defaultMessage: 'Flexi Order 1'
  },
  'flexi-order2': {
    id: 'app.containers.DashboardXLAM.flexi-order2',
    defaultMessage: 'Flexi Order 2'
  },
  'hyper-order1': {
    id: 'app.containers.DashboardXLAM.hyper-order1',
    defaultMessage: 'Hyper Order 1'
  },
  'hyper-order2': {
    id: 'app.containers.DashboardXLAM.hyper-order2',
    defaultMessage: 'Hyper Order 2'
  },
  pressTimesTitle: {
    id: 'app.containers.DashboardXLAM.pressTimesTitle',
    defaultMessage: 'Pressing Times'
  },
  extraLamStorageTitle: {
    id: 'app.containers.DashboardXLAM.extraLamStorageTitle',
    defaultMessage: 'Extra lamella storage'
  },
  MaxipressTitle: {
    id: 'app.containers.DashboardXLAM.MaxipressTitle',
    defaultMessage: 'Maxipress'
  },
  lineTitle: {
    id: 'app.containers.DashboardXLAM.lineTitle',
    defaultMessage: 'Line Status'
  },
  XpressTitle: {
    id: 'app.containers.DashboardXLAM.XpressTitle',
    defaultMessage: 'Xpress'
  },
  Xpress1Title: {
    id: 'app.containers.DashboardXLAM.Xpress1Title',
    defaultMessage: 'Xpress 1'
  },
  Xpress2Title: {
    id: 'app.containers.DashboardXLAM.Xpress2Title',
    defaultMessage: 'Xpress 2'
  },
  etageLagerShortTitle: {
    id: 'app.containers.DashboardXLAM.etageLagerShortTitle',
    defaultMessage: 'Shortlager'
  },
  shortlagerInfo: {
    id: 'app.containers.DashboardXLAM.shortlagerInfo',
    defaultMessage: 'Shortlager Info'
  },
  etageLagerLongTitle: {
    id: 'app.containers.DashboardXLAM.etageLagerLongTitle',
    defaultMessage: 'Longlager'
  },
  etageLagerLongSubtitle: {
    id: 'app.containers.DashboardXLAM.etageLagerLongSubtitle',
    defaultMessage: 'Longlager info'
  },
  chartTitle: {
    id: 'app.containers.DashboardXLAM.chartTitle',
    defaultMessage: 'Zinc Chart'
  },
  XCUT2: {
    id: 'app.containers.DashboardXLAM.XCUT2',
    defaultMessage: 'XCUT2'
  },
  crossXCutBoxTitle: {
    id: 'app.containers.DashboardXLAM.crossXCutBoxTitle',
    defaultMessage: 'cross XCut Box Title'
  },
  productStacking: {
    id: 'app.containers.DashboardXLAM.productStacking',
    defaultMessage: 'Product Stacking'
  },
  header: {
    id: 'app.containers.Sidebar.header',
    defaultMessage: 'This is the Sidebar container!'
  },
  pressing: {
    id: 'app.status.pressing',
    defaultMessage: 'pressing'
  },
  waiting_for_press: {
    id: 'app.status.waiting_for_press',
    defaultMessage: 'waiting for press'
  },
  lamellasInTransporter: {
    id: 'app.components.Compartment.header',
    defaultMessage: 'lamellas in transporter'
  },

  frozen: {
    id: 'app.containers.editview.frozen',
    defaultMessage: 'Frozen'
  },
  isWaste: {
    id: 'app.containers.editview.isWaste',
    defaultMessage: 'Is Waste'
  },
  isTest: {
    id: 'app.containers.editview.isTest',
    defaultMessage: 'Is Test'
  },
  FJmachine: {
    id: 'app.containers.editview.FJmachine',
    defaultMessage: 'FJ Machine'
  },
  ZPmachine: {
    id: 'app.containers.editview.ZPmachine',
    defaultMessage: 'ZP Machine'
  },
  machine: {
    id: 'app.containers.editview.machine',
    defaultMessage: 'Machine'
  },
  activeOrders: {
    id: 'app.containers.editview.activeOrders',
    defaultMessage: 'Active Orders'
  },
  clt: {
    id: 'app.containers.editview.clt',
    defaultMessage: 'CLT'
  },
  finishedOrders: {
    id: 'app.containers.editview.finishedOrders',
    defaultMessage: 'Finished Orders'
  },
  hyperOrderFields: {
    id: 'app.containers.editview.hyperOrderFields',
    defaultMessage: 'Hyper Press Orders'
  },
  scannedBeamsFields: {
    id: 'app.containers.editview.scannedBeamsFields',
    defaultMessage: 'Scanned Beams'
  },
  abfZincSent: {
    id: 'app.containers.editview.abfZincSent',
    defaultMessage: 'ABF sent for Zinc'
  },
  abfPlanerSent: {
    id: 'app.containers.editview.abfPlanerSent',
    defaultMessage: 'ABF sent for Planner'
  },
  abfZPressSent: {
    id: 'app.containers.editview.abfZPressSent',
    defaultMessage: 'ABF sent for Zpress'
  },
  fingerJointerId: {
    id: 'app.containers.editview.fingerJointerId',
    defaultMessage: 'FingerJointer id'
  },
  firmness: {
    id: 'app.containers.editview.firmness',
    defaultMessage: 'Firmness'
  },
  dimChangeOffset: {
    id: 'app.containers.editview.dimChangeOffset',
    defaultMessage: 'Dimension change offset'
  },
  outputPosition: {
    id: 'app.containers.editview.outputPosition',
    defaultMessage: 'Output position'
  },
  emptied: {
    id: 'app.containers.editview.emptied',
    defaultMessage: 'Emptied'
  },
  forceDry: {
    id: 'app.containers.editview.forceDry',
    defaultMessage: 'Force Dry'
  },
  seenOnDryingStorage: {
    id: 'app.containers.editview.seenOnDryingStorage',
    defaultMessage: 'Seen On Drying Storage'
  },
  forceEmpty: {
    id: 'app.containers.editview.forceEmpty',
    defaultMessage: 'Force Empty'
  },
  zPressCompletionSent: {
    id: 'app.containers.editview.zPressCompletionSent',
    defaultMessage: 'ZPress Completion Sent'
  },
  crossCutSawCompletionSent: {
    id: 'app.containers.editview.crossCutSawCompletionSent',
    defaultMessage: 'CrossCut Saw Completion Sent'
  },
  planeCompletionSent: {
    id: 'app.containers.editview.planeCompletionSent',
    defaultMessage: 'Plane Completion Sent'
  },
  fragmentId: {
    id: 'app.containers.editview.fragmentId',
    defaultMessage: 'Fragment Id'
  },
  extraLamella: {
    id: 'app.containers.editview.extraLamella',
    defaultMessage: 'Extra Lamella'
  },
  groupAge: {
    id: 'app.containers.editview.groupAge',
    defaultMessage: 'Group Age'
  },
  groupWidth: {
    id: 'app.containers.editview.groupWidth',
    defaultMessage: 'Group Width'
  },
  compartment: {
    id: 'app.containers.editview.compartment',
    defaultMessage: 'Compartment'
  },
  compartmentDetails: {
    id: 'app.containers.LagerLong.CompartmentModal.compartmentDetails',
    defaultMessage: 'Compartment details'
  },
  orderId: {
    id: 'app.containers.editview.orderId',
    defaultMessage: 'Order Id'
  },
  layerId: {
    id: 'app.containers.editview.layerId',
    defaultMessage: 'Layer Id'
  },
  noOfLamellas: {
    id: 'app.containers.LagerLong.CompartmentModal.noOfLamellas',
    defaultMessage: 'Number of lamellas'
  },
  noOfLamellasShouldBe: {
    id: 'app.containers.LagerLong.CompartmentModal.noOfLamellasShouldBeb',
    defaultMessage: 'Number of lamellas that should be'
  },
  rawDimensions: {
    id: 'app.components.RawInfeedLoadingBox.rawDimensions',
    defaultMessage: 'Raw Dimensions'
  },
  transferData: {
    id: 'app.components.RawInfeedLoadingBox.transferData',
    defaultMessage: 'Transfer Data'
  },
  paket: {
    id: 'app.components.RawInfeedLoadingBox.paket',
    defaultMessage: 'Paket - '
  },
  transferRawData: {
    id: 'app.components.RawInfeedLoadingBox.transferRawData',
    defaultMessage: 'Transfer Raw Data'
  },
  dimensions: {
    id: 'app.containers.Zinc.dimensions',
    defaultMessage: 'Dimensions'
  },
  lamellaDimensions: {
    id: 'app.containers.Zinc.lamellaDimensions',
    defaultMessage: 'Lamella Dimensions'
  },
  packageDimensions: {
    id: 'app.containers.Zinc.packageDimensions',
    defaultMessage: 'Package Dimensions'
  },
  moscaDimensions: {
    id: 'app.containers.Zinc.moscaDimensions',
    defaultMessage: 'Mosca (Layers x Lamellas/Layer)'
  },
  type: {
    id: 'app.containers.Zinc.type',
    defaultMessage: 'Type'
  },
  save: {
    id: 'app.components.modals.SetPackageModal.save',
    defaultMessage: 'Save'
  },
  close: {
    id: 'app.components.modals.PackageLoading.close',
    defaultMessage: 'Close'
  },
  showJSON: {
    id: 'app.containers.LagerLong.CompartmentModal.showJSON',
    defaultMessage: 'Show JSON'
  },
  pressId: {
    id: 'app.containers.editview.pressId',
    defaultMessage: 'Press Id'
  },
  masterpanel: {
    id: 'app.containers.editview.masterpanel',
    defaultMessage: 'Masterpanel'
  },
  confirm: {
    id: 'app.containers.editView.confirm',
    defaultMessage: 'Confirm'
  },
  cancel: {
    id: 'app.containers.OrdersQueue.cancel',
    defaultMessage: 'Cancel'
  },
  noaction: {
    id: 'app.containers.Tableview.noaction',
    defaultMessage: 'No action!'
  },
  action: {
    id: 'app.containers.Tableview.action',
    defaultMessage: 'Action'
  },
  moveTo: {
    id: 'app.containers.Tableview.moveTo',
    defaultMessage: 'Move to'
  },
  selectFile: {
    id: 'app.containers.Tableview.selectFile',
    defaultMessage: 'Select FILE'
  },
  addErp: {
    id: 'app.containers.Tableview.addErp',
    defaultMessage: 'Add New'
  },
  uploadFile: {
    id: 'app.containers.Tableview.uploadFile',
    defaultMessage: 'Upload new File'
  },
  shoePositions: {
    id: 'app.containers.Tableview.shoePositions',
    defaultMessage: 'Shoe pos.'
  },
  addComment: {
    id: 'app.containers.Tableview.addComment',
    defaultMessage: 'ADD COMMENT'
  },
  itemWithNoWidthSelected: {
    id: 'app.containers.TableView.itenWithNoWidthSelected',
    defaultMessage: 'Item with 0 width selected'
  },
  title: {
    id: 'app.components.TabelaricModal.title',
    defaultMessage: 'Title'
  },
  manualfill: {
    id: 'app.components.EtageLagerBox.manualfill',
    defaultMessage: 'Manual filling'
  },
  manualSorting: {
    id: 'app.components.EtageLagerBox.manualSorting',
    defaultMessage: 'Manual Sorting'
  },
  goesThrough: {
    id: 'app.components.LiftStatus.goesThrough',
    defaultMessage: 'Goes Through'
  },
  checkIfUnfinishedCross: {
    id: 'app.components.LiftStatus.checkIfUnfinishedCross',
    defaultMessage: 'Check if unifinished cross'
  },
  liftId: {
    id: 'app.components.LiftStatus.liftId',
    defaultMessage: 'Lift ID '
  },
  assignedID: {
    id: 'app.components.LiftStatus.assignedID',
    defaultMessage: 'Assigned ID '
  },
  goesToEtage: {
    id: 'app.components.LiftStatus.goesToEtage',
    defaultMessage: 'Goes to etage'
  },
  manualempty: {
    id: 'app.components.EtageLagerBox.manualempty',
    defaultMessage: 'Manual emptying'
  },
  modalTitle: {
    id: 'app.components.PressBox.modalTitle',
    defaultMessage: 'Press'
  },
  platesOnHolder: {
    id: 'app.components.PressBox.platesOnHolder',
    defaultMessage: 'Plates on holder'
  },
  vacuumAllowance: {
    id: 'app.components.PackageInfeedBox.vacuumAllowance',
    defaultMessage: 'Vacuum Allowance'
  },
  PLCVacuumAllowance: {
    id: 'app.components.PackageInfeedBox.PLCVacuumAllowance',
    defaultMessage: 'PLC Vacuum Allowance'
  },
  allowanceFromMode: {
    id: 'app.components.PackageInfeedBox.allowanceFromMode',
    defaultMessage: 'Mode Allowance'
  },
  splitCut: {
    id: 'app.components.PackageInfeedBox.splitCut',
    defaultMessage: 'Split Cut'
  },
  zincVacuumAllowance: {
    id: 'app.components.PackageInfeedBox.zincVacuumAllowance',
    defaultMessage: 'Zink Allowance'
  },
  zincActive: {
    id: 'app.components.PackageInfeedBox.zincActive',
    defaultMessage: 'Zinc Active'
  },
  emptyAllowance: {
    id: 'app.components.PackageInfeedBox.emptyAllowance',
    defaultMessage: 'Empty from vacuum to zink'
  },
  more: {
    id: 'app.containers.ZincBox.more',
    defaultMessage: 'more'
  },
  rawInfeedAllowance: {
    id: 'app.containers.RawInfeedLoadingBox.rawInfeedAllowance',
    defaultMessage: 'Raw Infeed Allowance'
  },
  allowanceMultiplan: {
    id: 'app.containers.editview.allowanceMultiplan',
    defaultMessage: 'Allowance Multiplan'
  },
  multiplanAllowance: {
    id: 'app.containers.editview.multiplanAllowance',
    defaultMessage: 'Multiplan Allowance'
  },
  boardsBeforePlaner: {
    id: 'app.containers.RawInfeedLoadingBox.boardsBeforePlaner',
    defaultMessage: 'Boards before planer'
  },
  stackingTitle: {
    id: 'app.containers.Stacking.stackingTitle',
    defaultMessage: 'Stacking'
  },
  stackingNo: {
    id: 'app.containers.Stacking.stackingNo',
    defaultMessage: 'Stacking No'
  },
  stackingid: {
    id: 'app.containers.Stacking.stackingid',
    defaultMessage: 'Current stacking ID'
  },
  superplan: {
    id: 'app.containers.Stacking.superplan',
    defaultMessage: 'Superplan'
  },
  superplanDataRequest: {
    id: 'app.containers.Stacking.superplanDataRequest',
    defaultMessage: 'Superplan Data Request'
  },
  xFormDataRequest: {
    id: 'app.containers.Stacking.xFormDataRequest',
    defaultMessage: 'xForm Data Request'
  },
  lksDataRequest: {
    id: 'app.containers.Stacking.lksDataRequest',
    defaultMessage: 'Lks Data Request'
  },
  schoberlDataRequest: {
    id: 'app.containers.Stacking.schoberlDataRequest',
    defaultMessage: 'Schoberl Data Request'
  },
  superles: {
    id: 'app.containers.Stacking.superles',
    defaultMessage: 'Superles'
  },
  rawWidthSuperplan: {
    id: 'app.components.StorageBox.rawWidthSuperplan',
    defaultMessage: 'Raw width (±offset)'
  },
  rawThicknessSuperplan: {
    id: 'app.components.StorageBox.rawThicknessSuperplan',
    defaultMessage: 'Raw thickness (±offset)'
  },
  planedWidthSuperplan: {
    id: 'app.components.StorageBox.planedWidthSuperplan',
    defaultMessage: 'Planed width (±offset)'
  },
  planedThicknessSuperplan: {
    id: 'app.components.StorageBox.planedThicknessSuperplan',
    defaultMessage: 'Planed thickness (±offset)'
  },
  confirmMaterial: {
    id: 'app.components.RawInfeedLoadingBox.confirmMaterial',
    defaultMessage: 'Confirm Material'
  },
  totalNumberOfLamellas: {
    id: 'app.components.RawInfeedLoadingBox.totalNumberOfLamellas',
    defaultMessage: 'Number Of Lamellas in Storage '
  },
  resetMaterial: {
    id: 'app.components.RawInfeedLoadingBox.resetMaterial',
    defaultMessage: 'Reset Material'
  },
  order: {
    id: 'app.containers.DashboardXLAM.order',
    defaultMessage: 'Order'
  },
  completePackage: {
    id: 'app.containers.DashboardXLAM.completePackage',
    defaultMessage: 'Complete Package'
  },
  numberOfLamellasAfterSaws: {
    id: 'app.containers.DashboardXLAM.numberOfLamellasAfterSaws',
    defaultMessage: 'Number of Lamellas out of multiplan'
  },
  incomingMaterial: {
    id: 'app.containers.DashboardXLAM.incomingMaterial',
    defaultMessage: 'Incoming Material'
  },
  actual: {
    id: 'app.components.ZincBox.done',
    defaultMessage: 'done'
  },
  left: {
    id: 'app.components.ZincBox.left',
    defaultMessage: 'left'
  },
  nextPressDimension: {
    id: 'app.components.ZincBox.nextPressDimension',
    defaultMessage: 'next press len.'
  },
  nextPressOrderId: {
    id: 'app.components.ZincBox.nextPressOrderId',
    defaultMessage: 'Next Press order ID'
  },
  outgoingLength: {
    id: 'app.components.ZincBox.outgoingLength',
    defaultMessage: 'out len.'
  },
  extra: {
    id: 'app.containers.ZincBox.extra',
    defaultMessage: '(extra)'
  },
  playVideo: {
    id: 'app.containers.PlayVideoModal.playVideo',
    defaultMessage: 'Play Video'
  },
  plates: {
    id: 'app.components.ZPressBox.plates',
    defaultMessage: 'Plates done'
  },
  planedLamellas: {
    id: 'app.components.ZPressBox.planedLamellas',
    defaultMessage: 'Planed lamellas'
  },
  lamellasInZPress: {
    id: 'app.components.ZPressBox.lamellasInZPress',
    defaultMessage: 'Lamellas In ZPress'
  },
  materialNeededText: {
    id: 'app.components.MicrotecBox.materialNeededText',
    defaultMessage: 'Material needed last 2 hours'
  },
  subTitle: {
    id: 'app.components.MicrotecBox.subTitle',
    defaultMessage: 'Scan report | Lamellas before XCut'
  },
  beforeStorageSubTitle: {
    id: 'app.components.MicrotecBox.beforeStorageSubTitle',
    defaultMessage: 'Lamellas Before Storage'
  },
  exitSubTitle: {
    id: 'app.components.MicrotecBox.exitSubTitle',
    defaultMessage: 'Creating Package'
  },
  scannedPackagesTitle: {
    id: 'app.components.MicrotecBox.scannedPackagesTitle',
    defaultMessage: 'Scanned Packages'
  },
  smartyBoxSubTitle: {
    id: 'app.components.MicrotecBox.smartyBoxSubTitle',
    defaultMessage: 'Scaner Settings'
  },
  zincBoxSubTitle: {
    id: 'app.components.ZincBox.zincBoxSubTitle',
    defaultMessage: 'Zink Info'
  },
  etageLagerBoxSubTitle: {
    id: 'app.components.EtageLagerBox.etageLagerBoxSubTitle',
    defaultMessage: 'Storage Info'
  },
  etageLagerBoxId: {
    id: 'app.components.EtageLagerBox.etageLagerBoxId',
    defaultMessage: 'ID '
  },
  etageLagerBoxNumBoards: {
    id: 'app.components.EtageLagerBox.etageLagerBoxNumBoards',
    defaultMessage: 'Num of Boards '
  },
  firstStorageComp: {
    id: 'app.components.EtageLagerBox.firstStorageComp',
    defaultMessage: 'First storage compartment'
  },
  secondStorageComp: {
    id: 'app.components.EtageLagerBox.secondStorageComp',
    defaultMessage: 'Second storage compartment'
  },
  thirdStorageComp: {
    id: 'app.components.EtageLagerBox.thirdStorageComp',
    defaultMessage: 'Third storage compartment'
  },
  fourthStorageComp: {
    id: 'app.components.EtageLagerBox.fourthStorageComp',
    defaultMessage: 'Fourth storage compartment'
  },
  fifthStorageComp: {
    id: 'app.components.EtageLagerBox.fifthStorageComp',
    defaultMessage: 'Fifth storage compartment'
  },
  stackingBoxSubTitle: {
    id: 'app.components.StackingBox.stackingBoxSubTitle',
    defaultMessage: 'Stacking Info'
  },
  stackingBoxId: {
    id: 'app.components.StackingBox.stackingBoxId',
    defaultMessage: 'ID '
  },
  stackingBoxStacking: {
    id: 'app.components.StackingBox.stackingBoxStacking',
    defaultMessage: 'Stacking '
  },
  stackingBoxResendData: {
    id: 'app.components.StackingBox.stackingBoxResendData',
    defaultMessage: 'Resend Stacker Data'
  },
  xcutSubTitle: {
    id: 'app.components.XCutBox.subTitle',
    defaultMessage: 'XCUT Status'
  },
  lastCutLamella: {
    id: 'app.components.MicrotecBox.lastCutLamella',
    defaultMessage: 'Letzte geschnittene Lamelle'
  },
  lamellaId: {
    id: 'app.components.MicrotecBox.lamellaId',
    defaultMessage: 'Lamelle Id'
  },
  woodType: {
    id: 'app.containers.editview.woodType',
    defaultMessage: 'Wood Type'
  },
  splitLamella: {
    id: 'app.containers.editview.splitLamella',
    defaultMessage: 'Split Lamella'
  },
  finishedLamellaWidth: {
    id: 'app.containers.editview.finishedLamellaWidth',
    defaultMessage: 'Finished Lamella Width'
  },
  finishedLfinishedLamellaThicknessamellaWidth: {
    id: 'app.containers.editview.finishedLamellaThickness',
    defaultMessage: 'Finished Lamella Thickness'
  },
  quality: {
    id: 'app.components.modals.PackageLoading.quality',
    defaultMessage: 'QUALITY'
  },
  qualityLowercase: {
    id: 'app.components.modals.PackageLoading.qualityLowercase',
    defaultMessage: 'Quality'
  },
  currentRawMaterial: {
    id: 'app.components.MicrotecBox.currentRawMaterial',
    defaultMessage: 'Rohware'
  },
  nextRawMaterial: {
    id: 'app.components.MicrotecBox.nextRawMaterial',
    defaultMessage: 'Nächstes Rohware'
  },
  orderDimensSent: {
    id: 'app.components.MicrotecBox.orderDimensSent',
    defaultMessage: 'A daten bestätigt'
  },
  orderDimensAck: {
    id: 'app.components.MicrotecBox.orderDimensAck',
    defaultMessage: 'O. dimen. ack'
  },
  lamellaDimensSent: {
    id: 'app.components.MicrotecBox.lamellaDimensSent',
    defaultMessage: 'L daten bestätigt'
  },
  lamellaDimensAck: {
    id: 'app.components.MicrotecBox.lamellaDimensAck',
    defaultMessage: 'L. dimen. ack'
  },
  forcecut: {
    id: 'app.components.MicrotecBox.forcecut',
    defaultMessage: 'Zwangkappung'
  },
  strName: {
    id: 'app.components.MicrotecBox.strName',
    defaultMessage: 'Str. name'
  },
  planedDimensions: {
    id: 'app.containers.ZincBox.planedDimensions',
    defaultMessage: 'Planed Dimensions'
  },
  stacking: {
    id: 'app.components.RawInfeedLoadingBox.stacking',
    defaultMessage: 'Stacking'
  },
  progress: {
    id: 'app.components.XcutBox.progress',
    defaultMessage: 'Progress'
  },
  repair: {
    id: 'app.components.OutputConveyorBeltBox.repair',
    defaultMessage: 'Reparatur'
  },
  sendToFirstSector: {
    id: 'app.components.MicrotecBox.sendToFirstSector',
    defaultMessage: 'First sec.'
  },
  sendToSecondSector: {
    id: 'app.components.MicrotecBox.sendToSecondSector',
    defaultMessage: 'Second sec.'
  },
  clearPlanerOrder: {
    id: 'app.components.OutputConveyorBeltBox.clearPlanerOrder',
    defaultMessage: 'Clear Planer Order'
  },
  goodLength: {
    id: 'app.components.SystemTMBox.goodLength',
    defaultMessage: 'Gutlängen'
  },
  takenOut: {
    id: 'app.components.SystemTMBox.takenOut',
    defaultMessage: '-4m (ausnehmen)'
  },
  lengthOffset: {
    id: 'app.components.SystemTMBox.lengthOffset',
    defaultMessage: 'Längenversatz'
  },
  EZFreigabe: {
    id: 'app.components.SystemTMBox.AZFreigabe',
    defaultMessage: 'EZFreigabe'
  },
  microtecLength: {
    id: 'app.components.SystemTMBox.microtecLength',
    defaultMessage: 'Mikroteclänge'
  },
  lastLabel: {
    id: 'app.components.UnloadingBox.lastLabel',
    defaultMessage: 'Last label'
  },
  printed: {
    id: 'app.components.UnloadingBox.printed',
    defaultMessage: 'printed'
  },
  print: {
    id: 'app.components.UnloadingBox.print',
    defaultMessage: 'Print'
  },
  pieces: {
    id: 'app.containers.editview.pieces',
    defaultMessage: 'Pieces'
  },
  noboards: {
    id: 'app.containers.ModelFieldMessages.identifierNumBoards',
    defaultMessage: 'No. boards'
  },
  turningBeforePressError1: {
    id: 'app.containers.ModelFieldMessages.turningBeforePressError1',
    defaultMessage: 'Either turningEverySecond or turningEveryFirst must be checked, but not both.'
  },
  turningBeforePressError2: {
    id: 'app.containers.ModelFieldMessages.turningBeforePressError2',
    defaultMessage: 'turningEverySecond and turningEveryFirst should not be checked when turningBeforePress is unchecked.'
  },
  widthTooBig: {
    id: 'app.containers.ModelFieldMessages.widthTooBig',
    defaultMessage: 'Planned Width Too Big'
  },
  total: {
    id: 'app.components.XcutBox.total',
    defaultMessage: 'Total'
  },
  totalForDimension: {
    id: 'app.components.XcutBox.totalForDimension',
    defaultMessage: 'Total for Dimension'
  },
  totalMadeForDimension: {
    id: 'app.components.XcutBox.totalMadeForDimension',
    defaultMessage: 'Total Made for Dimension'
  },
  totalLoadedForDimension: {
    id: 'app.components.XcutBox.totalLoadedForDimension',
    defaultMessage: 'Total loaded for Dimension'
  },
  totalForAllOrders: {
    id: 'app.components.XcutBox.totalForAllOrders',
    defaultMessage: 'Total made for all orders'
  },
  xcut: {
    id: 'app.components.XcutBox.xcut',
    defaultMessage: 'XCut'
  },
  package: {
    id: 'app.components.XcutBox.package',
    defaultMessage: 'Package'
  },
  waitingForEmptyBeforeXcut: {
    id: 'app.containers.Status.waitingForEmptyBeforeXcuta',
    defaultMessage: 'Waiting for empty before XCut1'
  },
  halterDisabled: {
    id: 'app.containers.Status.halterDisableda',
    defaultMessage: 'Enough boards for current order'
  },
  emptyingXcut1: {
    id: 'app.containers.Status.emptyingXcut1a',
    defaultMessage: 'Emptying before XCut1'
  },
  planerAllowance: {
    id: 'app.components.EtageLagerBox.planerAllowance',
    defaultMessage: 'Planer allowance'
  },
  reqPackageData: {
    id: 'app.components.EtageLagerBox.reqPackageData',
    defaultMessage: 'Request PackageData'
  },
  lamellaInMachine: {
    id: 'app.components.EtageLagerBox.lamellaInMachine',
    defaultMessage: 'Lamella In Planner'
  },
  entryAllowance: {
    id: 'app.components.EtageLagerBox.entryAllowance',
    defaultMessage: 'Entry Allowance'
  },
  vacuumAllows: {
    id: 'app.components.EtageLagerBox.vacuumAllows',
    defaultMessage: 'Vacuum Allows'
  },
  unloadMaterial: {
    id: 'app.components.EtageLagerBox.unloadMaterial',
    defaultMessage: 'Unload Material'
  },
  xCutAllowance: {
    id: 'app.components.EtageLagerBox.xCutAllowance',
    defaultMessage: 'xCut Allowance'
  },
  sequenceError: {
    id: 'app.components.EtageLagerBox.sequenceError',
    defaultMessage: 'Sequence error'
  },
  dataError: {
    id: 'app.components.EtageLagerBox.dataError',
    defaultMessage: 'Data Error'
  },
  waitingForPress: {
    id: 'app.components.PressBox.sentToPress',
    defaultMessage: 'waiting for Press'
  },
  openTime: {
    id: 'app.components.PressBox.openTime',
    defaultMessage: 'Open time'
  },
  pressTime: {
    id: 'app.components.PressBox.pressTime',
    defaultMessage: 'Press time'
  },
  currentTimerString: {
    id: 'app.components.PressBox.currentTimerString',
    defaultMessage: 'Current time for order'
  },
  currentOrderStacking: {
    id: 'app.components.PressBox.currentOrderStacking',
    defaultMessage: 'Current order stacking'
  },
  no: {
    id: 'app.components.PressBox.no',
    defaultMessage: 'No'
  },
  orderPress1: {
    id: 'app.components.PressBox.orderPress1',
    defaultMessage: 'order in press 1'
  },
  orderPress2: {
    id: 'app.components.PressBox.orderPress2',
    defaultMessage: 'order in press 2'
  },
  orderPress: {
    id: 'app.components.PressBox.press1',
    defaultMessage: 'order in press'
  },
  noMaxiOrders: {
    id: 'app.components.PressBox.noMaxiOrders',
    defaultMessage: 'No order in press'
  },
  inMaxiPressEtages: {
    id: 'app.components.PressBox.inMaxiPressEtages',
    defaultMessage: 'Orders in etages'
  },
  packageInfo: {
    id: 'app.components.ProductionLine.packageInfo',
    defaultMessage: 'Package information'
  },
  zincLager: {
    id: 'app.components.ProductionLine.zincLager',
    defaultMessage: 'Zinc Storage'
  },
  loader: {
    id: 'app.components.ProductionLine.loader',
    defaultMessage: 'Loader'
  },
  lamellaLager: {
    id: 'app.components.ProductionLine.lamellaLager',
    defaultMessage: 'Lamella storage'
  },
  multiplanSub: {
    id: 'app.components.ProductionLine.multiplanSub',
    defaultMessage: 'Multiplan Dimensions'
  },
  layerData: {
    id: 'app.components.ProductionLine.layerData',
    defaultMessage: 'Layer Data'
  },
  brookuhuisSub: {
    id: 'app.components.ProductionLine.brookuhuisSub',
    defaultMessage: 'Brookhuis'
  },
  inMaxipress: {
    id: 'app.components.PressBox.inMaxipress',
    defaultMessage: 'Orders in press'
  },
  order2: {
    id: 'app.components.PressBox.press2',
    defaultMessage: 'order on table'
  },
  panelInfo: {
    id: 'app.containers.LagerLong.CompartmentModal.panelInfo',
    defaultMessage: 'Panel Info'
  },
  panelDimensions: {
    id: 'app.containers.LagerLong.CompartmentModal.panelDimensions',
    defaultMessage: 'Panel Dimensions'
  },
  numberOfLayersInPress: {
    id: 'app.containers.LagerLong.CompartmentModal.numberOfLayers',
    defaultMessage: 'Number Of Layers'
  },
  ordersQueueTitle: {
    id: 'app.components.SideMenu.ordersQueueTitle',
    defaultMessage: 'Orders Queue'
  },
  schneiderOrdersQueueTitle: {
    id: 'app.components.SideMenu.schneiderOrdersQueueTitle',
    defaultMessage: 'Orders'
  },
  settings: {
    id: 'app.containers.OrdersQueue.settings',
    defaultMessage: 'Settings'
  },
  userSettings: {
    id: 'app.containers.OrdersQueue.userSettings',
    defaultMessage: 'User Settings'
  },
  idCalculator: {
    id: 'app.containers.OrdersQueue.idCalculator',
    defaultMessage: 'ID Calculator'
  },
  ordersQueueResetAll: {
    id: 'app.globalMessages.ordersQueueResetAll',
    defaultMessage: 'Reset All'
  },
  ordersQueueNoOrders: {
    id: 'app.globalMessages.ordersQueueNoOrders',
    defaultMessage: 'No orders'
  },
  ordersQueueResetPress: {
    id: 'app.globalMessages.ordersQueueResetPress',
    defaultMessage: 'Reset press'
  },
  ordersQueueResetLamellas: {
    id: 'app.globalMessages.ordersQueueResetLamellas',
    defaultMessage: 'Reset lamellas'
  },
  ordersQueueLamellasLabel: {
    id: 'app.globalMessages.ordersQueueLamellasLabel',
    defaultMessage: 'Lamellas'
  },
  ordersQueueHideLamellas: {
    id: 'app.globalMessages.ordersQueueHideLamellas',
    defaultMessage: 'Hide lamellas'
  },
  ordersQueueShowLamellas: {
    id: 'app.globalMessages.ordersQueueShowLamellas',
    defaultMessage: 'Show lamellas'
  },
  ordersQueueNoLamellas: {
    id: 'app.globalMessages.ordersQueueNoLamellas',
    defaultMessage: 'No lamellas'
  },
  ordersQueueResetLamella: {
    id: 'app.globalMessages.ordersQueueResetLamella',
    defaultMessage: 'Reset'
  },
  emptyError: {
    id: 'app.containers.OrdersQueue.emptyError',
    defaultMessage: 'Must not be empty'
  },
  orderInfo: {
    id: 'app.containers.OrdersQueue.orderInfo',
    defaultMessage: 'Order Info'
  },
  layerInfo: {
    id: 'app.containers.OrdersQueue.layerInfo',
    defaultMessage: 'Layer Info'
  },
  id: {
    id: 'app.containers.editview.id',
    defaultMessage: 'Id'
  },
  lamellasInPackage: {
    id: 'app.containers.editview.lamellasInPackage',
    defaultMessage: 'Lamellas In Package'
  },
  orderimportNumber: {
    id: 'app.containers.editview.orderImportNumber',
    defaultMessage: 'Order import Number'
  },
  identifier: {
    id: 'app.containers.editview.identifier',
    defaultMessage: 'Identifier'
  },
  isConstruction: {
    id: 'app.containers.ModelFieldMessages.isConstruction',
    defaultMessage: 'isConstruction'
  },
  lamellaThickness: {
    id: 'app.containers.editview.lamellaThickness',
    defaultMessage: 'Lamella Thickness'
  },
  lamellaWidth: {
    id: 'app.containers.editview.lamellaWidth',
    defaultMessage: 'Lamella Width'
  },
  insulationWidth: {
    id: 'app.containers.editview.insulationWidth',
    defaultMessage: 'Insulation Width'
  },
  lamellaLength: {
    id: 'app.containers.editview.lamellaLength',
    defaultMessage: 'Lamella Length'
  },
  resetZPress: {
    id: 'app.containers.editview.resetZPress',
    defaultMessage: 'Reset Z-Press production'
  },
  resendMultiplan: {
    id: 'app.containers.editview.resendMultiplan',
    defaultMessage: 'Resend Multiplan Data'
  },
  resetVacuumTask: {
    id: 'app.containers.editview.resetVacuumTask',
    defaultMessage: 'Reset Vacuum Task'
  },
  resendZink: {
    id: 'app.containers.editview.resendZink',
    defaultMessage: 'Resend Zink Data'
  },
  recalculateAndResendZPress: {
    id: 'app.containers.editview.recalculateAndResendZPress',
    defaultMessage: 'Recalculate and Resend Data'
  },
  resetSchoberlOrder: {
    id: 'app.containers.editview.resetSchoberlOrder',
    defaultMessage: 'Reset Schoberl Order'
  },
  resetXFormOrder: {
    id: 'app.containers.editview.resetXFormOrder',
    defaultMessage: 'Reset xForm Order'
  },
  emptyBothChains: {
    id: 'app.containers.editview.emptyBothChains',
    defaultMessage: 'Empty Both Chains'
  },
  emptyBothChainsActive: {
    id: 'app.containers.editview.emptyBothChainsActive',
    defaultMessage: 'Chains Emptying Active'
  },
  resendWraworData: {
    id: 'app.containers.editview.resendWraworData',
    defaultMessage: 'Resend Wrawor Data'
  },
  averageLength: {
    id: 'app.containers.editview.averageLength',
    defaultMessage: 'Average Length'
  },
  lm: {
    id: 'app.components.modals.SetPackageModal.lm',
    defaultMessage: 'METERS IN PACKAGE'
  },
  strengthGrade: {
    id: 'app.containers.editview.strengthGrade',
    defaultMessage: 'Strength Grade'
  },
  strengthGradeAnte: {
    id: 'app.containers.editview.strengthGradeAnte',
    defaultMessage: 'Strength Grade'
  },
  maxCombineWidthDifference: {
    id: 'app.containers.editview.maxCombineWidthDifference',
    defaultMessage: 'Max. Combined Width Difference'
  },
  lmUsed: {
    id: 'app.containers.editview.lmUsed',
    defaultMessage: 'Lm Used'
  },
  shouldBeRemoved: {
    id: 'app.containers.editview.shouldBeRemoved',
    defaultMessage: 'Should Be Removed'
  },
  packageId: {
    id: 'app.components.modals.PackageLoading.packageId',
    defaultMessage: 'PACKAGE ID'
  },
  packageNumber: {
    id: 'app.containers.editview.packageNumber',
    defaultMessage: 'Package number'
  },
  finishedPackageId: {
    id: 'app.containers.editview.finishedPackageId',
    defaultMessage: 'finished Package Id'
  },
  piecesUsed: {
    id: 'app.containers.editview.piecesUsed',
    defaultMessage: 'Pieces Used'
  },
  inappropriateForUsing: {
    id: 'app.containers.editview.inappropriateForUsing',
    defaultMessage: 'Inappropriate For Using'
  },
  showAlreadyOrderedPackages: {
    id: 'app.containers.InfeedRaw.showAlreadyOrderedPackages',
    defaultMessage: 'Show already ordered packages'
  },
  piecesPerLayer: {
    id: 'app.containers.InfeedRaw.piecesPerLayer',
    defaultMessage: 'Pieces'
  },
  neededOnLoadingPosition: {
    id: 'app.containers.editview.neededOnLoadingPosition',
    defaultMessage: 'Needed On Loading Position'
  },
  lmAfterMessrad: {
    id: 'app.containers.editview.lmAfterMessrad',
    defaultMessage: 'Lm After Messrad'
  },
  lmWithPaketladn: {
    id: 'app.containers.editview.lmWithPaketladn',
    defaultMessage: 'Lm With Paketladn'
  },
  lmAtFlySaw: {
    id: 'app.containers.editview.lmAtFlySaw',
    defaultMessage: 'Lm At Fly Saw'
  },
  createdAt: {
    id: 'app.containers.editview.createdAt',
    defaultMessage: 'Created At'
  },
  creatingPackage: {
    id: 'app.containers.editview.creatingPackage',
    defaultMessage: 'Creating Package'
  },
  statsSent: {
    id: 'app.containers.editview.statsSent',
    defaultMessage: 'Stats Sent'
  },
  grade: {
    id: 'app.containers.editview.grade',
    defaultMessage: 'Grade'
  },
  numberOfLamellas: {
    id: 'app.containers.editview.numberOfLamellas',
    defaultMessage: 'Number Of Lamellas'
  },
  fsc: {
    id: 'app.containers.editview.fsc',
    defaultMessage: 'Fsc'
  },
  numberOfLayers: {
    id: 'app.containers.InfeedRaw.numberOfLayers',
    defaultMessage: 'Layers'
  },
  numberOfLamellasStacked: {
    id: 'app.containers.editview.numberOfLamellasStacked',
    defaultMessage: 'Number Of Lamellas Stacked'
  },
  numberOfLamellasPlaned: {
    id: 'app.containers.editview.numberOfLamellasPlaned',
    defaultMessage: 'Number Of Lamellas Planed'
  },
  sortingState: {
    id: 'app.containers.editview.sortingState',
    defaultMessage: 'Sorting State'
  },
  created_at: {
    id: 'app.containers.editview.created_at',
    defaultMessage: 'Created_at'
  },
  updated_at: {
    id: 'app.containers.editview.updated_at',
    defaultMessage: 'Updated_at'
  },
  ante_package_id: {
    id: 'app.containers.editview.ante_package_id',
    defaultMessage: 'Ante_package_id'
  },
  productionDate: {
    id: 'app.containers.editview.productionDate',
    defaultMessage: 'Production Date'
  },
  qualityId: {
    id: 'app.containers.editview.qualityId',
    defaultMessage: 'Quality Id'
  },
  packageWidth: {
    id: 'app.containers.editview.packageWidth',
    defaultMessage: 'Package Width'
  },
  articleId: {
    id: 'app.containers.editview.articleId',
    defaultMessage: 'Article Id'
  },
  materialId: {
    id: 'app.containers.editview.materialId',
    defaultMessage: 'Material Id'
  },
  articleNumber: {
    id: 'app.containers.editview.articleNumber',
    defaultMessage: 'Article Number'
  },
  processed: {
    id: 'app.containers.editview.processed',
    defaultMessage: 'Processed'
  },
  ceLabel: {
    id: 'app.containers.editview.ceLabel',
    defaultMessage: 'CE Label'
  },
  endLabel: {
    id: 'app.containers.editview.endLabel',
    defaultMessage: 'End Label'
  },
  gtin: {
    id: 'app.containers.editview.gtin',
    defaultMessage: 'Gtin'
  },
  turning0: {
    id: 'app.containers.editview.turning0',
    defaultMessage: 'Turning 1'
  },
  turning1: {
    id: 'app.containers.editview.turning1',
    defaultMessage: 'Turning 2'
  },
  turning2: {
    id: 'app.containers.editview.turning2',
    defaultMessage: 'Turning 3'
  },
  softHandling: {
    id: 'app.containers.editview.softHandling',
    defaultMessage: 'Soft Handling'
  },
  frontEnd: {
    id: 'app.containers.editview.frontEnd',
    defaultMessage: 'FrontEnd'
  },
  labelType: {
    id: 'app.containers.editview.labelType',
    defaultMessage: 'Label Type'
  },
  layers: {
    id: 'app.containers.editview.layers',
    defaultMessage: 'Layers'
  },
  packageLabelType: {
    id: 'app.containers.editview.packageLabelType',
    defaultMessage: 'Package Label Type'
  },
  stickSpacing: {
    id: 'app.containers.editview.stickSpacing',
    defaultMessage: 'Package Stick Spacing'
  },
  shortArticleNumber: {
    id: 'app.containers.editview.shortArticleNumber',
    defaultMessage: 'Short Article Number'
  },
  bottomStamp: {
    id: 'app.containers.editview.bottomStamp',
    defaultMessage: 'Bottom Stamp'
  },
  lmNetto: {
    id: 'app.containers.editview.lmNetto',
    defaultMessage: 'Lm Netto'
  },
  lmBrutto: {
    id: 'app.containers.editview.lmBrutto',
    defaultMessage: 'Lm Brutto'
  },
  packageHeight: {
    id: 'app.containers.editview.packageHeight',
    defaultMessage: 'Package Height'
  },
  destination: {
    id: 'app.containers.InfeedRaw.destination',
    defaultMessage: 'Destination'
  },
  shuttleEnableToMove: {
    id: 'app.containers.InfeedRaw.shuttleEnableToMove',
    defaultMessage: 'Shuttle Can Move'
  },
  shuttleBusy: {
    id: 'app.containers.InfeedRaw.shuttleBusy',
    defaultMessage: 'Shuttle Is Busy'
  },
  shuttleStoppedFromOP: {
    id: 'app.containers.InfeedRaw.shuttleStoppedFromOP',
    defaultMessage: 'Shuttle Stopped (OP)'
  },
  shuttleError: {
    id: 'app.containers.InfeedRaw.shuttleError',
    defaultMessage: 'Shuttle Error'
  },
  shuttleFull: {
    id: 'app.containers.InfeedRaw.shuttleFull',
    defaultMessage: 'Shuttle Is Full'
  },
  gatesClosed: {
    id: 'app.containers.InfeedRaw.gatesClosed',
    defaultMessage: 'Gate Closed'
  },
  deleteAllMovementOrders: {
    id: 'app.containers.InfeedRaw.deleteAllMovementOrders',
    defaultMessage: 'Delete all orders'
  },
  piecesMismatch: {
    id: 'app.containers.InfeedRaw.piecesMismatch',
    defaultMessage: 'Pieces Missmatch'
  },
  needsToEmpty: {
    id: 'app.containers.InfeedRaw.needsToEmpty',
    defaultMessage: 'Requires emptying'
  },
  LMToXcut: {
    id: 'app.containers.InfeedRaw.LMToXcut',
    defaultMessage: 'LM to XCut'
  },
  goldeneyeDimensions: {
    id: 'app.containers.Goldeneye.goldeneyeDimensions',
    defaultMessage: 'Dim.: '
  },
  goldeneyeEmptyList: {
    id: 'app.containers.Goldeneye.goldeneyeEmptyList',
    defaultMessage: ' Empty List '
  },
  placeEmpty: {
    id: 'app.containers.editview.placeEmpty',
    defaultMessage: 'Place Empty'
  },
  errorPackage: {
    id: 'app.containers.editview.errorPackage',
    defaultMessage: 'Error Package'
  },
  packEditable: {
    id: 'app.containers.editview.packEditable',
    defaultMessage: 'Pack Editable'
  },
  pos: {
    id: 'app.containers.editview.pos',
    defaultMessage: 'Pos'
  },
  storageNumber: {
    id: 'app.containers.editview.storageNumber',
    defaultMessage: 'Storage Number'
  },
  takenOutAt: {
    id: 'app.containers.editview.takenOutAt',
    defaultMessage: 'Taken Out At'
  },
  ledinek_package_id: {
    id: 'app.containers.editview.ledinek_package_id',
    defaultMessage: 'Ledinek_package_id'
  },
  finishedArticleId: {
    id: 'app.containers.editview.finishedArticleId',
    defaultMessage: 'Finished Article Id'
  },
  waitingForNextPackageDataStacker: {
    id: 'app.containers.editview.waitingForNextPackageDataStacker',
    defaultMessage: 'Waiting For Next Package Data Stacker'
  },
  cumulativeWood: {
    id: 'app.containers.editview.cumulativeWood',
    defaultMessage: 'Cumulative Wood'
  },
  accumulatorBeforeXcut: {
    id: 'app.containers.editview.accumulatorBeforeXcut',
    defaultMessage: 'accumulatorBeforeXcut'
  },
  afterXCutBoards: {
    id: 'app.containers.editview.afterXCutBoards',
    defaultMessage: 'afterXCutBoards'
  },
  plannedLamellaThickness: {
    id: 'app.containers.editview.plannedLamellaThickness',
    defaultMessage: 'Lamella Planed Thickness'
  },
  lamellaPlannedThickness: {
    id: 'app.containers.editview.lamellaPlannedThickness',
    defaultMessage: 'Lamella Planed Thickness'
  },
  plannedLamellaWidth: {
    id: 'app.containers.editview.plannedLamellaWidth',
    defaultMessage: 'Lamella Planed Width'
  },
  lamellaPlannedWidth: {
    id: 'app.containers.editview.lamellaPlannedWidth',
    defaultMessage: 'Lamella Planed Width'
  },
  plannedWidth: {
    id: 'app.containers.editview.plannedWidth',
    defaultMessage: 'Planed Width'
  },
  plannedThickness: {
    id: 'app.containers.editview.plannedThickness',
    defaultMessage: 'Planed Thickness'
  },
  numLamellas: {
    id: 'app.containers.editview.numLamellas',
    defaultMessage: 'Num Lamellas'
  },
  lamellas: {
    id: 'app.containers.editview.lamellas',
    defaultMessage: 'Lamellas'
  },
  IsoZincBoxSubTitle: {
    id: 'app.containers.editview.IsoZincBoxSubTitle',
    defaultMessage: 'Current Dimension'
  },
  insNumLamellas: {
    id: 'app.containers.editview.insNumLamellas',
    defaultMessage: 'ISO Num Lamellas'
  },
  omitCalculation: {
    id: 'app.containers.editview.omitCalculation',
    defaultMessage: 'Do not calculate'
  },
  currentBatchNumber: {
    id: 'app.containers.editview.currentBatchNumber',
    defaultMessage: 'Current Batch Number'
  },
  zincDoneNumLamellas: {
    id: 'app.containers.editview.zincDoneNumLamellas',
    defaultMessage: 'Zinc Done Num Lamellas'
  },
  planedLamellasNumber: {
    id: 'app.containers.editview.planedLamellasNumber',
    defaultMessage: 'Planer Done Num Lamellas'
  },
  stackedLamellasNumber: {
    id: 'app.containers.editview.stackedLamellasNumber',
    defaultMessage: 'Stacker Done Num Lamellas'
  },
  insZincDoneNumLamellas: {
    id: 'app.containers.editview.insZincDoneNumLamellas',
    defaultMessage: 'ISO Zinc Done Num Lamellas'
  },
  zPressDoneNumLamellas: {
    id: 'app.containers.editview.zPressDoneNumLamellas',
    defaultMessage: 'Z Press Done Num Lamellas'
  },
  orientation: {
    id: 'app.containers.editview.orientation',
    defaultMessage: 'Orientation'
  },
  producingOnZinc: {
    id: 'app.containers.editview.producingOnZinc',
    defaultMessage: 'Producing On Zinc'
  },
  finishedProducingOnZinc: {
    id: 'app.containers.editview.finishedProducingOnZinc',
    defaultMessage: 'Finished Producing On Zinc'
  },
  producingOnISoZinc: {
    id: 'app.containers.editview.producingOnISoZinc',
    defaultMessage: 'Producing On ISO Zinc'
  },
  finishedProducingInsZinc: {
    id: 'app.containers.editview.finishedProducingInsZinc',
    defaultMessage: 'Finished Producing On ISO Zinc'
  },
  layerNo: {
    id: 'app.containers.editview.layerNo',
    defaultMessage: 'Layer No'
  },
  rotation: {
    id: 'app.containers.editview.rotation',
    defaultMessage: 'Rotation'
  },
  numOfLamellas: {
    id: 'app.containers.editview.numOfLamellas',
    defaultMessage: 'Num Of Lamellas'
  },
  numOfLamellasPerLayer: {
    id: 'app.containers.editview.numOfLamellasPerLayer',
    defaultMessage: 'Num Of Lamellas Per Layer'
  },
  hasGlue: {
    id: 'app.containers.editview.hasGlue',
    defaultMessage: 'Has Glue'
  },
  layerDry: {
    id: 'app.containers.editview.layerDry',
    defaultMessage: 'Layer Dry'
  },
  inEtage: {
    id: 'app.containers.editview.inEtage',
    defaultMessage: 'In Etage'
  },
  separatorDistance: {
    id: 'app.containers.editview.separatorDistance',
    defaultMessage: 'Separator Distance'
  },
  numnKVHLayers: {
    id: 'app.containers.editview.numnKVHLayers',
    defaultMessage: 'Numn K V H Layers'
  },
  numLamellasPerLayer: {
    id: 'app.containers.editview.numLamellasPerLayer',
    defaultMessage: 'Num Lamellas Per Layer'
  },
  assignedToEtage: {
    id: 'app.containers.editview.assignedToEtage',
    defaultMessage: 'Assigned To Etage'
  },
  rawWidth: {
    id: 'app.containers.editview.rawWidth',
    defaultMessage: 'Raw Width'
  },
  lamellaRawWidth: {
    id: 'app.containers.editview.lamellaRawWidth',
    defaultMessage: 'Lamella Raw Width'
  },
  lamellaRawThickness: {
    id: 'app.containers.editview.lamellaRawThickness',
    defaultMessage: 'Lamella Raw Thickness'
  },
  rawSortingLoading: {
    id: 'app.containers.editview.rawSortingLoading',
    defaultMessage: 'Raw Sorting Loading'
  },
  rawThickness: {
    id: 'app.containers.editview.rawThickness',
    defaultMessage: 'Raw Thickness'
  },
  hasOneShorter: {
    id: 'app.containers.editview.hasOneShorter',
    defaultMessage: 'Has One Shorter'
  },
  hasTwoShorter: {
    id: 'app.containers.editview.hasTwoShorter',
    defaultMessage: 'Has Two Shorter'
  },
  lastLamellaToEtageTime: {
    id: 'app.containers.editview.lastLamellaToEtageTime',
    defaultMessage: 'Last Lamella To Etage Time'
  },
  etage: {
    id: 'app.containers.editview.etage',
    defaultMessage: 'Etage'
  },
  zincStartDate: {
    id: 'app.containers.editview.zincStartDate',
    defaultMessage: 'Zinc Start Date'
  },
  zincProductionTime: {
    id: 'app.containers.editview.zincProductionTime',
    defaultMessage: 'Zinc Production Time'
  },
  planerStartDate: {
    id: 'app.containers.editview.planerStartDate',
    defaultMessage: 'Planer Start Date'
  },
  planerProductionTime: {
    id: 'app.containers.editview.planerProductionTime',
    defaultMessage: 'Planer Production Time'
  },
  joinedDimensionId: {
    id: 'app.containers.editview.joinedDimensionId',
    defaultMessage: 'Joined Dimension Id'
  },
  inStorage: {
    id: 'app.containers.editview.inStorage',
    defaultMessage: 'In Storage'
  },
  fullyStored: {
    id: 'app.containers.editview.fullyStored',
    defaultMessage: 'Fully Stored'
  },
  preparedOnPress: {
    id: 'app.containers.editview.preparedOnPress',
    defaultMessage: 'Prepared On Press'
  },
  glueUsed: {
    id: 'app.containers.editview.glueUsed',
    defaultMessage: 'Glue Used'
  },
  awgTimeBetweenZinc: {
    id: 'app.containers.editview.awgTimeBetweenZinc',
    defaultMessage: 'Awg Time Between Zinc'
  },
  awgTimeBetweenPlan: {
    id: 'app.containers.editview.awgTimeBetweenPlan',
    defaultMessage: 'Awg Time Between Plan'
  },
  batchId: {
    id: 'app.containers.editview.batchId',
    defaultMessage: 'Batch Id'
  },
  primingTop: {
    id: 'app.containers.editview.primingTop',
    defaultMessage: 'Priming Top'
  },
  primingBottom: {
    id: 'app.containers.editview.primingBottom',
    defaultMessage: 'Priming Bottom'
  },
  chamferTop: {
    id: 'app.containers.editview.chamferTop',
    defaultMessage: 'Chamfer Top'
  },
  chamferTopRight: {
    id: 'app.containers.editview.chamferTopRight',
    defaultMessage: 'Chamfer Top Right'
  },
  chamferTopLeft: {
    id: 'app.containers.editview.chamferTopLeft',
    defaultMessage: 'Chamfer Top Left'
  },
  chamferBottom: {
    id: 'app.containers.editview.chamferBottom',
    defaultMessage: 'Chamfer Bottom'
  },
  chamferBottomRight: {
    id: 'app.containers.editview.chamferBottomRight',
    defaultMessage: 'Chamfer Bottom Right'
  },
  chamferBottomLeft: {
    id: 'app.containers.editview.chamferBottomLeft',
    defaultMessage: 'Chamfer Bottom Left'
  },
  requiresExactQuality: {
    id: 'app.containers.editview.requiresExactQuality',
    defaultMessage: 'Requires Exact Quality'
  },
  ist: {
    id: 'app.containers.editview.ist',
    defaultMessage: 'Ist'
  },
  seenOnCrossVacuum: {
    id: 'app.containers.editview.seenOnCrossVacuum',
    defaultMessage: 'Seen On Cross Vacuum'
  },
  isGluLam: {
    id: 'app.containers.editview.isGluLam',
    defaultMessage: 'Is Glu Lam'
  },
  crossFinished: {
    id: 'app.containers.editview.crossFinished',
    defaultMessage: 'Cross Finished'
  },
  qLamLength1: {
    id: 'app.containers.editview.qLamLength1',
    defaultMessage: 'Q Lam Length1'
  },
  stackingNumOfLayers: {
    id: 'app.containers.editview.stackingNumOfLayers',
    defaultMessage: 'Stacking Num Of Layers'
  },
  stackingLamellasPerLayer: {
    id: 'app.containers.editview.stackingLamellasPerLayer',
    defaultMessage: 'Stacking Lamellas Per Layer ff'
  },
  layersStacked: {
    id: 'app.containers.editview.layersStacked',
    defaultMessage: 'Layers Stacked'
  },
  layersStackedDrying: {
    id: 'app.containers.editview.layersStackedDrying',
    defaultMessage: 'Layers Stacked Drying'
  },
  groupString: {
    id: 'app.containers.editview.groupString',
    defaultMessage: 'Group String'
  },
  lamellasDrying: {
    id: 'app.containers.editview.lamellasDrying',
    defaultMessage: 'Lamellas Drying'
  },
  planingOffset: {
    id: 'app.containers.editview.planingOffset',
    defaultMessage: 'Planing Offset'
  },
  layerDone: {
    id: 'app.containers.editview.layerDone',
    defaultMessage: 'Layer Done'
  },
  canBeDeleted: {
    id: 'app.containers.editview.canBeDeleted',
    defaultMessage: 'Can Be Deleted'
  },
  assignedDryingSollwertLamellas: {
    id: 'app.containers.editview.assignedDryingSollwertLamellas',
    defaultMessage: 'Assigned Drying Sollwert Lamellas'
  },
  zincEndDate: {
    id: 'app.containers.editview.zincEndDate',
    defaultMessage: 'Zinc End Date'
  },
  planerEndDate: {
    id: 'app.containers.editview.planerEndDate',
    defaultMessage: 'Planer End Date'
  },
  zPressStartDate: {
    id: 'app.containers.editview.zPressStartDate',
    defaultMessage: 'Z Press Start Date'
  },
  zPressEndDate: {
    id: 'app.containers.editview.zPressEndDate',
    defaultMessage: 'Z Press End Date'
  },
  qLamellaLength: {
    id: 'app.containers.editview.qLamellaLength',
    defaultMessage: 'Q Lamella Length'
  },
  qLamellaNum: {
    id: 'app.containers.editview.qLamellaNum',
    defaultMessage: 'Q Lamella Num'
  },
  xcutOversize: {
    id: 'app.containers.editview.xcutOversize',
    defaultMessage: 'Xcut Oversize'
  },
  qlSawOversize: {
    id: 'app.containers.editview.qlSawOversize',
    defaultMessage: 'QL Saw Oversize'
  },
  reserve: {
    id: 'app.containers.editview.reserve',
    defaultMessage: 'Reserve'
  },
  plannedLamellas: {
    id: 'app.containers.editview.plannedLamellas',
    defaultMessage: 'Planed Lamellas'
  },
  numMmRawMaterialNeeded: {
    id: 'app.containers.editview.numMmRawMaterialNeeded',
    defaultMessage: 'Num Mm Raw Material Needed'
  },
  finishedAtZincAt: {
    id: 'app.containers.editview.finishedAtZincAt',
    defaultMessage: 'Finished At Zinc At'
  },
  startedAtZincAt: {
    id: 'app.containers.editview.startedAtZincAt',
    defaultMessage: 'Started At Zinc At'
  },
  awgTimeBetweenZincsSum: {
    id: 'app.containers.editview.awgTimeBetweenZincsSum',
    defaultMessage: 'Awg Time Between Zincs Sum'
  },
  numOfZincs: {
    id: 'app.containers.editview.numOfZincs',
    defaultMessage: 'Num Of Zincs'
  },
  awgZincStart: {
    id: 'app.containers.editview.awgZincStart',
    defaultMessage: 'Awg Zinc Start'
  },
  awgTimeBetweenPlanSum: {
    id: 'app.containers.editview.awgTimeBetweenPlanSum',
    defaultMessage: 'Awg Time Between Plan Sum'
  },
  numOfPlan: {
    id: 'app.containers.editview.numOfPlan',
    defaultMessage: 'Num Of Plan'
  },
  awgPlanStart: {
    id: 'app.containers.editview.awgPlanStart',
    defaultMessage: 'Awg Plan Start'
  },
  materialUsage: {
    id: 'app.containers.editview.materialUsage',
    defaultMessage: 'Material Usage'
  },
  enoughRawMaterial: {
    id: 'app.containers.editview.enoughRawMaterial',
    defaultMessage: 'Enough Raw Material'
  },
  assignedBeforeXCut: {
    id: 'app.containers.editview.assignedBeforeXCut',
    defaultMessage: 'Assigned Before X Cut'
  },
  repairOrder: {
    id: 'app.containers.editview.repairOrder',
    defaultMessage: 'Repair Order'
  },
  extraLamellaOrder: {
    id: 'app.containers.editview.extraLamellaOrder',
    defaultMessage: 'Extra Lamella Order'
  },
  currentlyLoadingMaterialFor: {
    id: 'app.containers.editview.currentlyLoadingMaterialFor',
    defaultMessage: 'Currently Loading Material For'
  },
  currentlyNeededMaterial: {
    id: 'app.components.signalCard.currentlyNeededMaterial',
    defaultMessage: 'Needs Material'
  },
  dimensionsSignalCard: {
    id: 'app.components.signalCard.dimensionsSignalCard',
    defaultMessage: 'Dimensions '
  },
  numOfBoardsSignalCard: {
    id: 'app.components.signalCard.numOfBoardsSignalCard',
    defaultMessage: 'Boards '
  },
  beforeSinglingSignalCard: {
    id: 'app.components.signalCard.beforeSinglingSignalCard',
    defaultMessage: 'Before Singling '
  },
  afterSinglingSignalCard: {
    id: 'app.components.signalCard.afterSinglingSignalCard',
    defaultMessage: 'After Singling '
  },
  alltogetherSignalCard: {
    id: 'app.components.signalCard.alltogetherSignalCard',
    defaultMessage: 'Alltogether '
  },
  producingOnZPress: {
    id: 'app.containers.editview.producingOnZPress',
    defaultMessage: 'Producing On Z Press'
  },
  finishedProducingOnZPress: {
    id: 'app.containers.editview.finishedProducingOnZPress',
    defaultMessage: 'Finished Producing On Z Press'
  },
  errorGroup: {
    id: 'app.containers.editview.errorGroup',
    defaultMessage: 'Error Group'
  },
  stored: {
    id: 'app.containers.editview.stored',
    defaultMessage: 'Stored'
  },
  numOfLamellasStored: {
    id: 'app.containers.editview.numOfLamellasStored',
    defaultMessage: 'Number of lamellas stored'
  },
  isActiveInClt: {
    id: 'app.containers.editview.isActiveInClt',
    defaultMessage: 'Active in CLT'
  },
  errorLoading: {
    id: 'app.containers.editview.errorLoading',
    defaultMessage: 'Error loading'
  },
  throughZPress: {
    id: 'app.containers.editview.throughZPress',
    defaultMessage: 'Through Z Press'
  },
  numberOfPlates: {
    id: 'app.containers.editview.numberOfPlates',
    defaultMessage: 'Number Of Plates'
  },
  zPressDonePlates: {
    id: 'app.containers.editview.zPressDonePlates',
    defaultMessage: 'Zpress Nr. Of Plates done'
  },
  goesToGigaPress: {
    id: 'app.containers.editview.goesToGigaPress',
    defaultMessage: 'Goes To Giga Press'
  },
  onForkliftPlace: {
    id: 'app.containers.editview.onForkliftPlace',
    defaultMessage: 'On Forklift Place'
  },
  numLamellasQ1: {
    id: 'app.containers.editview.numLamellasQ1',
    defaultMessage: 'Num Lamellas Q1'
  },
  lamellaLengthQ1: {
    id: 'app.containers.editview.lamellaLengthQ1',
    defaultMessage: 'Lamella Length Q1'
  },
  lamellaLengthQ2: {
    id: 'app.containers.editview.lamellaLengthQ2',
    defaultMessage: 'Lamella Length Q2'
  },
  numLamellasQ2: {
    id: 'app.containers.editview.numLamellasQ2',
    defaultMessage: 'Num Lamellas Q2'
  },
  acknowledgedAtZinc: {
    id: 'app.containers.editview.acknowledgedAtZinc',
    defaultMessage: 'Acknowledged At Zinc'
  },
  orderColor: {
    id: 'app.containers.editview.orderColor',
    defaultMessage: 'Order Color'
  },
  totalZPressLength: {
    id: 'app.containers.editview.totalZPressLength',
    defaultMessage: 'Total Z Press Length'
  },
  totalZPressPlates: {
    id: 'app.containers.editview.totalZPressPlates',
    defaultMessage: 'Total Z Press Plates'
  },
  totalZPressPlatesDone: {
    id: 'app.containers.editview.totalZPressPlatesDone',
    defaultMessage: 'Total Z Press Plates Done'
  },
  noCutPlateWidth: {
    id: 'app.containers.editview.noCutPlateWidth',
    defaultMessage: 'No Cut Plate Width'
  },
  noGroupMode: {
    id: 'app.containers.editview.noGroupMode',
    defaultMessage: 'No Group Mode'
  },
  paNr: {
    id: 'app.containers.editview.paNr',
    defaultMessage: 'Pa Nr'
  },
  orderCharge: {
    id: 'app.containers.editview.orderCharge',
    defaultMessage: 'Order Charge'
  },
  skipDimension: {
    id: 'app.containers.editview.skipDimension',
    defaultMessage: 'Skip Dimension'
  },
  isKVH: {
    id: 'app.containers.editview.isKVH',
    defaultMessage: 'Is K V H'
  },
  currentDate: {
    id: 'app.containers.editview.currentDate',
    defaultMessage: 'Current Date'
  },
  currentDimension: {
    id: 'app.containers.editview.currentDimension',
    defaultMessage: 'Current Dim.'
  },
  planerPackage: {
    id: 'app.containers.editview.planerPackage',
    defaultMessage: 'Planer Package'
  },
  numberOfBoardsPerLayer: {
    id: 'app.containers.editview.numberOfBoardsPerLayer',
    defaultMessage: 'Number Of Boards Per Layer'
  },
  pressChainAfterRollers: {
    id: 'app.containers.editview.pressChainAfterRollers',
    defaultMessage: 'Press Chain After Rollers'
  },
  productionOrdersHashCode: {
    id: 'app.containers.editview.productionOrdersHashCode',
    defaultMessage: 'Production Orders Hash Code'
  },
  vacuumMode: {
    id: 'app.containers.editview.vacuumMode',
    defaultMessage: 'Vacuum Mode'
  },
  stationRequest: {
    id: 'app.containers.editview.stationRequest',
    defaultMessage: 'Station Request'
  },
  ch_w_dp_bool: {
    id: 'app.containers.editview.ch_w_dp_bool',
    defaultMessage: 'Ch_w_dp_bool'
  },
  waitingForNextPackageDataSuperplan: {
    id: 'app.containers.editview.waitingForNextPackageDataSuperplan',
    defaultMessage: 'Waiting For Next Package Data Superplan'
  },
  lastGoldenEyeLamella: {
    id: 'app.containers.editview.lastGoldenEyeLamella',
    defaultMessage: 'Last Golden Eye Lamella'
  },
  groupUUID: {
    id: 'app.containers.editview.groupUUID',
    defaultMessage: 'Group U U I D'
  },
  panelWidth: {
    id: 'app.containers.editview.panelWidth',
    defaultMessage: 'Panel Width'
  },
  panelThickness: {
    id: 'app.containers.editview.panelThickness',
    defaultMessage: 'Panel Thickness'
  },
  panelLength: {
    id: 'app.containers.editview.panelLength',
    defaultMessage: 'Panel Length'
  },
  firstLayerOfGlueTime: {
    id: 'app.containers.editview.firstLayerOfGlueTime',
    defaultMessage: 'First Layer Of Glue Time'
  },
  combinedPressId: {
    id: 'app.containers.editview.combinedPressId',
    defaultMessage: 'Combined Press ID'
  },
  pressTimeStart: {
    id: 'app.containers.editview.pressTimeStart',
    defaultMessage: 'Press Time Start'
  },
  pressTimeEnd: {
    id: 'app.containers.editview.pressTimeEnd',
    defaultMessage: 'Press Time End'
  },
  orderNumber: {
    id: 'app.containers.editview.orderNumber',
    defaultMessage: 'Order Number'
  },
  client: {
    id: 'app.containers.editview.client',
    defaultMessage: 'Client'
  },
  pressureRAwgNumOfSamples: {
    id: 'app.containers.editview.pressureRAwgNumOfSamples',
    defaultMessage: 'Pressure R Awg Num Of Samples'
  },
  pressureRAwgSum: {
    id: 'app.containers.editview.pressureRAwgSum',
    defaultMessage: 'Pressure R Awg Sum'
  },
  pressureAwgFinal: {
    id: 'app.containers.editview.pressureAwgFinal',
    defaultMessage: 'Pressure Awg Final'
  },
  sollDruckAwgNumOfSamples: {
    id: 'app.containers.editview.sollDruckAwgNumOfSamples',
    defaultMessage: 'Soll Druck Awg Num Of Samples'
  },
  sollDruckAwgSum: {
    id: 'app.containers.editview.sollDruckAwgSum',
    defaultMessage: 'Soll Druck Awg Sum'
  },
  sollDruckAwgFinal: {
    id: 'app.containers.editview.sollDruckAwgFinal',
    defaultMessage: 'Soll Druck Awg Final'
  },
  optimizationDone: {
    id: 'app.containers.editview.optimizationDone',
    defaultMessage: 'Optimization Done'
  },
  sentToPress: {
    id: 'app.containers.editview.sentToPress',
    defaultMessage: 'Sent To Press'
  },
  toPress: {
    id: 'app.containers.editview.toPress',
    defaultMessage: 'To Press'
  },
  status: {
    id: 'app.containers.editview.status',
    defaultMessage: 'Status'
  },
  glueAmount: {
    id: 'app.containers.editview.glueAmount',
    defaultMessage: 'Glue Amount'
  },
  targetPressure: {
    id: 'app.containers.editview.targetPressure',
    defaultMessage: 'Target Pressure'
  },
  targetSollDruck: {
    id: 'app.containers.editview.targetSollDruck',
    defaultMessage: 'Target Soll Druck'
  },
  recipe: {
    id: 'app.containers.editview.recipe',
    defaultMessage: 'Recipe'
  },
  glueForPress: {
    id: 'app.containers.editview.glueForPress',
    defaultMessage: 'Glue For Press'
  },
  cutMode: {
    id: 'app.containers.editview.cutMode',
    defaultMessage: 'Cut Mode'
  },
  masterpanelpakID: {
    id: 'app.containers.editview.masterpanelpakID',
    defaultMessage: 'Masterpanelpak I D'
  },
  batchText: {
    id: 'app.containers.editview.batchText',
    defaultMessage: 'Batch Text'
  },
  comission: {
    id: 'app.containers.editview.comission',
    defaultMessage: 'Comission'
  },
  articleCode: {
    id: 'app.containers.editview.articleCode',
    defaultMessage: 'Article Code'
  },
  sortingInfeedPlannedThickness: {
    id: 'app.containers.editview.sortingInfeedPlannedThickness',
    defaultMessage: 'Sorting Infeed Planed Thickness'
  },
  istNumBoards: {
    id: 'app.containers.editview.istNumBoards',
    defaultMessage: 'Ist Num Boards'
  },
  sequenceNumber: {
    id: 'app.containers.editview.sequenceNumber',
    defaultMessage: 'Sequence Number'
  },
  layerSequenceNumber: {
    id: 'app.containers.editview.layerSequenceNumber',
    defaultMessage: 'Layer Sequence Number'
  },
  usage: {
    id: 'app.containers.editview.usage',
    defaultMessage: 'Usage'
  },
  sortedUsage: {
    id: 'app.containers.editview.sortedUsage',
    defaultMessage: 'Sorted Usage'
  },
  fillingDisabled: {
    id: 'app.containers.editview.fillingDisabled',
    defaultMessage: 'Filling Disabled'
  },
  numberOfBoardsBeforePlaner: {
    id: 'app.containers.editview.numberOfBoardsBeforePlaner',
    defaultMessage: 'Number Of Boards Before Planer'
  },
  currentMaterialPackageAndLengthString: {
    id: 'app.containers.editview.currentMaterialPackageAndLengthString',
    defaultMessage: 'Current Material'
  },
  dryingTime: {
    id: 'app.containers.editview.dryingTime',
    defaultMessage: 'Drying Time'
  },
  maxMoistureLimit: {
    id: 'app.containers.editview.maxMoistureLimit',
    defaultMessage: 'Max Moisture Limit'
  },
  loaderPCData: {
    id: 'app.containers.editview.loaderPCData',
    defaultMessage: 'Loader PC Data'
  },
  emptying: {
    id: 'app.containers.editview.emptying',
    defaultMessage: 'Emptying'
  },
  operational: {
    id: 'app.containers.editview.operational',
    defaultMessage: 'Operational'
  },
  disabled: {
    id: 'app.containers.editview.fullDisabled',
    defaultMessage: 'Disabled'
  },
  full: {
    id: 'app.containers.editview.full',
    defaultMessage: 'Full'
  },
  fullSolis: {
    id: 'app.containers.editview.fullSolis',
    defaultMessage: 'Full PLC / Full PC '
  },
  joinedDim: {
    id: 'app.containers.editview.joinedDim',
    defaultMessage: 'Joined Dim'
  },
  layer: {
    id: 'app.containers.DashboardXLAM.layer',
    defaultMessage: 'Layer'
  },
  sollNumBoards: {
    id: 'app.containers.editview.sollNumBoards',
    defaultMessage: 'Soll Num Boards'
  },
  compartmentIndex: {
    id: 'app.containers.editview.compartmentIndex',
    defaultMessage: 'Compartment Index'
  },
  manualEmptying: {
    id: 'app.containers.editview.manualEmptying',
    defaultMessage: 'Manual Emptying'
  },
  negativeWoodBufferForBetterDimensionNext: {
    id: 'app.containers.editview.negativeWoodBufferForBetterDimensionNext',
    defaultMessage: 'Negative Wood Buffer For Better Dimension Next'
  },
  noGroupModeWidthTakeaway: {
    id: 'app.containers.editview.noGroupModeWidthTakeaway',
    defaultMessage: 'Group Mode Width Takeaway'
  },
  sortingInfeedPlannedWidthOffset: {
    id: 'app.containers.editview.sortingInfeedPlannedWidthOffset',
    defaultMessage: 'Sorting Infeed Planed Width Offset'
  },
  waitingForDryingOrder: {
    id: 'app.containers.editview.waitingForDryingOrder',
    defaultMessage: 'Waiting For Drying Order'
  },
  etageNumber: {
    id: 'app.containers.editview.etageNumber',
    defaultMessage: 'Etage Number'
  },
  compartmentNumber: {
    id: 'app.containers.editview.compartmentNumber',
    defaultMessage: 'Compartment Number'
  },
  indexInSequence: {
    id: 'app.containers.editview.indexInSequence',
    defaultMessage: 'Index In Sequence'
  },
  timeInStorage: {
    id: 'app.containers.editview.timeInStorage',
    defaultMessage: 'Time In Storage'
  },
  isDry: {
    id: 'app.containers.editview.isDry',
    defaultMessage: 'Is Dry'
  },
  etageCurrentlyFilling: {
    id: 'app.containers.editview.etageCurrentlyFilling',
    defaultMessage: 'Etage Currently Filling'
  },
  minMoistureLimit: {
    id: 'app.containers.editview.minMoistureLimit',
    defaultMessage: 'Min Moisture Limit'
  },
  combinedAllowanceFromVacuum: {
    id: 'app.containers.editview.combinedAllowanceFromVacuum',
    defaultMessage: 'Combined Allowance From Vacuum'
  },
  goldenEyeSortState: {
    id: 'app.containers.editview.goldenEyeSortState',
    defaultMessage: 'Golden Eye Sort State'
  },
  currentWoodOnLine: {
    id: 'app.containers.editview.currentWoodOnLine',
    defaultMessage: 'Current Wood On Line'
  },
  planerSettings: {
    id: 'app.containers.editview.planerSettings',
    defaultMessage: 'Planer Settings'
  },
  fillKVH: {
    id: 'app.containers.editview.fillKVH',
    defaultMessage: 'Fill K V H'
  },
  editEnabled1: {
    id: 'app.containers.editview.editEnabled1',
    defaultMessage: 'Edit Enabled1'
  },
  pressExit1: {
    id: 'app.containers.editview.pressExit1',
    defaultMessage: 'Press Exit1'
  },
  pressExit: {
    id: 'app.containers.editview.pressExit',
    defaultMessage: 'Press Exit'
  },
  editEnabled2: {
    id: 'app.containers.editview.editEnabled2',
    defaultMessage: 'Edit Enabled2'
  },
  pressExit2: {
    id: 'app.containers.editview.pressExit2',
    defaultMessage: 'Press Exit2'
  },
  pressChainAfterPusher: {
    id: 'app.containers.editview.pressChainAfterPusher',
    defaultMessage: 'Press Chain After Pusher'
  },
  editEnabled3: {
    id: 'app.containers.editview.editEnabled3',
    defaultMessage: 'Edit Enabled3'
  },
  editEnabled4: {
    id: 'app.containers.editview.editEnabled4',
    defaultMessage: 'Edit Enabled4'
  },
  noGroupModeCOversize: {
    id: 'app.containers.editview.noGroupModeCOversize',
    defaultMessage: 'Group Mode C Oversize'
  },
  order1: {
    id: 'app.containers.editview.order1',
    defaultMessage: 'Order1'
  },
  allowanceRawInfeed: {
    id: 'app.containers.editview.allowanceRawInfeed',
    defaultMessage: 'Allowance Raw Infeed'
  },
  currentVacuumMode: {
    id: 'app.containers.editview.currentVacuumMode',
    defaultMessage: 'Current Vacuum Mode'
  },
  totalNeededWithoutWoodOnLine: {
    id: 'app.containers.editview.totalNeededWithoutWoodOnLine',
    defaultMessage: 'Total Needed Without Wood On Line'
  },
  endId: {
    id: 'app.containers.editview.endId',
    defaultMessage: 'End Id'
  },
  currentSetNumberOfBoards: {
    id: 'app.containers.editview.currentSetNumberOfBoards',
    defaultMessage: 'Current Set Number Of Boards'
  },
  mitnemerPlaces: {
    id: 'app.containers.editview.mitnemerPlaces',
    defaultMessage: 'Mitnemer Places'
  },
  superplanOrder1: {
    id: 'app.containers.editview.superplanOrder1',
    defaultMessage: 'Multiplan order 1'
  },
  superplanOrder2: {
    id: 'app.containers.editview.superplanOrder2',
    defaultMessage: 'Multiplan order 2'
  },
  zPressOrder: {
    id: 'app.containers.editview.zPressOrder',
    defaultMessage: 'Z Press Order'
  },
  zPressOrder1: {
    id: 'app.containers.editview.zPressOrder1',
    defaultMessage: 'Z Press 1 Order'
  },
  uniPressOrder1: {
    id: 'app.containers.editview.uniPressOrder1',
    defaultMessage: 'UniPress 1 Order'
  },
  zPressOrder2: {
    id: 'app.containers.editview.zPressOrder2',
    defaultMessage: 'Z Press 2 Order'
  },
  zPressLastDataSent1: {
    id: 'app.containers.editview.zPressLastDataSent1',
    defaultMessage: 'Z Press 1 Last sent Order'
  },
  uniPressLastDataSent1: {
    id: 'app.containers.editview.uniPressLastDataSent1',
    defaultMessage: 'UniPress 1 Last sent Order'
  },
  zPressLastDataSent2: {
    id: 'app.containers.editview.zPressLastDataSent2',
    defaultMessage: 'Z Press 2 Last sent Order'
  },
  liftZPress1Order: {
    id: 'app.containers.editview.liftZPress1Order',
    defaultMessage: 'Z Press 1 Lift Order'
  },
  liftZPress2Order: {
    id: 'app.containers.editview.liftZPress2Order',
    defaultMessage: 'Z Press 2 Lift Order'
  },
  lastCrossLiftJD: {
    id: 'app.containers.editview.lastCrossLiftJD',
    defaultMessage: 'Last lift cross order'
  },
  ccZPress1Holder1: {
    id: 'app.containers.editview.ccZPress1Holder1',
    defaultMessage: 'ZPress 1 holder 1'
  },
  ccZPress1Holder2: {
    id: 'app.containers.editview.ccZPress1Holder2',
    defaultMessage: 'ZPress 1 holder 2'
  },
  ccZPress2Holder1: {
    id: 'app.containers.editview.ccZPress2Holder1',
    defaultMessage: 'ZPress 2 holder 1'
  },
  ccZPress2Holder2: {
    id: 'app.containers.editview.ccZPress2Holder2',
    defaultMessage: 'ZPress 2 holder 2'
  },
  liftZPres1Order: {
    id: 'app.containers.editview.liftZPres1Order',
    defaultMessage: 'Lift ZPress order 1'
  },
  liftZPres2Order: {
    id: 'app.containers.editview.liftZPres2Order',
    defaultMessage: 'Lift ZPress order 2'
  },
  numberOfBoards: {
    id: 'app.containers.editview.numberOfBoards',
    defaultMessage: 'Number Of Boards'
  },
  manualFillingEtage: {
    id: 'app.containers.editview.manualFillingEtage',
    defaultMessage: 'Manual Filling Etage'
  },
  sortingInfeedPlannedWidth: {
    id: 'app.containers.editview.sortingInfeedPlannedWidth',
    defaultMessage: 'Sorting Infeed Planed Width'
  },
  sortingInfeedWidthOffset: {
    id: 'app.containers.editview.sortingInfeedWidthOffset',
    defaultMessage: 'Sorting Infeed Width Offset'
  },
  sortingInfeedThicknessOffset: {
    id: 'app.containers.editview.sortingInfeedThicknessOffset',
    defaultMessage: 'Sorting Infeed Thickness Offset'
  },
  totalNeededAfterSingling: {
    id: 'app.containers.editview.totalNeededAfterSingling',
    defaultMessage: 'Total Needed After Singling'
  },
  stackingPackage: {
    id: 'app.containers.editview.stackingPackage',
    defaultMessage: 'Stacking Package'
  },
  defaultVacuumLocation: {
    id: 'app.containers.editview.defaultVacuumLocation',
    defaultMessage: 'Default Vacuum Location'
  },
  manualLoading: {
    id: 'app.containers.editview.manualLoading',
    defaultMessage: 'Manual Loading'
  },
  dataSentToMiniZink: {
    id: 'app.containers.editview.dataSentToMiniZink',
    defaultMessage: 'Order Data Sent To Minizink'
  },
  freigabeVakum: {
    id: 'app.containers.editview.freigabeVakum',
    defaultMessage: 'Vacuum Allowance'
  },
  freigabeMultiplan: {
    id: 'app.containers.editview.freigabeMultiplan',
    defaultMessage: 'Multiplan Allowance'
  },
  freigabeOrder: {
    id: 'app.containers.editview.freigabeOrder',
    defaultMessage: 'Zink Waiting for Order'
  },
  brookhuisOn: {
    id: 'app.containers.editview.brookhuisOn',
    defaultMessage: 'Brookhuis On'
  },
  brookhuisConnected: {
    id: 'app.containers.editview.brookhuisConnected',
    defaultMessage: 'Brookhuis Connected'
  },
  shuttleAvailable: {
    id: 'app.containers.editview.shuttleAvailable',
    defaultMessage: 'Shuttle Available'
  },
  wraworActive: {
    id: 'app.containers.editview.wraworActive',
    defaultMessage: 'Wrawor Active'
  },
  xFormActive: {
    id: 'app.containers.editview.xFormActive',
    defaultMessage: 'XForm Active'
  },
  wraworBeamDone: {
    id: 'app.containers.editview.wraworBeamDone',
    defaultMessage: 'Wrawor Beam Done'
  },
  chainMovingPlc: {
    id: 'app.containers.editview.chainMovingPlc',
    defaultMessage: 'First Chain Moving'
  },
  vacuumAvailable: {
    id: 'app.containers.editview.vacuumAvailable',
    defaultMessage: 'Vacuum Available'
  },
  crossroadsMoveAvailable: {
    id: 'app.containers.editview.crossroadsMoveAvailable',
    defaultMessage: 'Crossroads Move Available'
  },
  wraworReadyForPlate: {
    id: 'app.containers.editview.wraworReadyForPlate',
    defaultMessage: 'Wrawor Ready For Plate'
  },
  numberOfBoardsStacked: {
    id: 'app.containers.editview.numberOfBoardsStacked',
    defaultMessage: 'Number Of Boards Stacked'
  },
  combinedAllowanceRawInfeed: {
    id: 'app.containers.editview.combinedAllowanceRawInfeed',
    defaultMessage: 'Combined Allowance Raw Infeed'
  },
  sortingInfeedWidth: {
    id: 'app.containers.editview.sortingInfeedWidth',
    defaultMessage: 'Sorting Infeed Width'
  },
  productionSequenceHashCode: {
    id: 'app.containers.editview.productionSequenceHashCode',
    defaultMessage: 'Production Sequence Hash Code'
  },
  minTakeaway: {
    id: 'app.containers.editview.minTakeaway',
    defaultMessage: 'Min Takeaway'
  },
  wasteLamellaLength: {
    id: 'app.containers.editview.wasteLamellaLength',
    defaultMessage: 'Waste Lamella Length'
  },
  testLamellaLength: {
    id: 'app.containers.editview.testLamellaLength',
    defaultMessage: 'Test Lamella Length'
  },
  extraLamellaLength: {
    id: 'app.containers.editview.extraLamellaLength',
    defaultMessage: 'Extra Lamella Length'
  },
  packageLengthBuffer: {
    id: 'app.containers.editview.packageLengthBuffer',
    defaultMessage: 'Package Length Buffer'
  },
  averagePackageSize: {
    id: 'app.containers.editview.averagePackageSize',
    defaultMessage: 'Average package size'
  },
  clearWoodlayers: {
    id: 'app.containers.editview.clearWoodlayers',
    defaultMessage: 'Clear wood layers'
  },
  insertTestlayers: {
    id: 'app.containers.editview.insertTestlayers',
    defaultMessage: 'Insert test layers'
  },
  insertWastelayers: {
    id: 'app.containers.editview.insertWastelayers',
    defaultMessage: 'Insert waste layers'
  },
  packageTest: {
    id: 'app.containers.editview.packageTest',
    defaultMessage: 'Package test'
  },
  maxEncoderDifferenceFull: {
    id: 'app.containers.editview.maxEncoderDifferenceFull',
    defaultMessage: 'Max Encoder Difference Full'
  },
  separationDistance: {
    id: 'app.containers.editview.separationDistance',
    defaultMessage: 'Separation distance'
  },
  maxDryingEncoder: {
    id: 'app.containers.editview.maxDryingEncoder',
    defaultMessage: 'Max drying encoder'
  },
  glueType: {
    id: 'app.containers.editview.glueType',
    defaultMessage: 'Glue Type'
  },
  groupBatchSize: {
    id: 'app.containers.editview.groupBatchSize',
    defaultMessage: 'Group batch size'
  },
  globalZPressOffset: {
    id: 'app.containers.editview.globalZPressOffset',
    defaultMessage: 'Global ZPress offset'
  },
  cncOversizeWidth: {
    id: 'app.containers.editview.cncOversizeWidth',
    defaultMessage: 'CNC oversize width'
  },
  cncOversizeLenght: {
    id: 'app.containers.editview.cncOversizeLenght',
    defaultMessage: 'CNC oversize length'
  },
  urgentRequest: {
    id: 'app.containers.editview.urgentRequest',
    defaultMessage: 'Urgent request'
  },
  afterCurrentlyProducingLayer: {
    id: 'app.containers.editview.afterCurrentlyProducingLayer',
    defaultMessage: 'After currently producing layer'
  },
  afterCurrentlyProducingOrder: {
    id: 'app.containers.editview.afterCurrentlyProducingOrder',
    defaultMessage: 'After currently producing order'
  },
  emergencyRequest: {
    id: 'app.containers.editview.emergencyRequest',
    defaultMessage: 'Emergency request'
  },
  FJMachine: {
    id: 'app.containers.editview.FJMachine',
    defaultMessage: 'Finger jointing machine'
  },
  maxTakeaway: {
    id: 'app.containers.editview.maxTakeaway',
    defaultMessage: 'Max Takeaway'
  },
  kvhOversize: {
    id: 'app.containers.editview.kvhOversize',
    defaultMessage: 'Kvh Oversize'
  },
  qOversize: {
    id: 'app.containers.editview.qOversize',
    defaultMessage: 'Q Oversize'
  },
  lOversize: {
    id: 'app.containers.editview.lOversize',
    defaultMessage: 'L Oversize'
  },
  nextPackageId: {
    id: 'app.containers.editview.nextPackageId',
    defaultMessage: 'Next Package Id'
  },
  maxPanelLength: {
    id: 'app.containers.editview.maxPanelLength',
    defaultMessage: 'Max Panel Length'
  },
  minPanelLength: {
    id: 'app.containers.editview.minPanelLength',
    defaultMessage: 'Min Panel Length'
  },
  maxPanelWidth: {
    id: 'app.containers.editview.maxPanelWidth',
    defaultMessage: 'Max Panel Width'
  },
  minPanelWidth: {
    id: 'app.containers.editview.minPanelWidth',
    defaultMessage: 'Min Panel Width'
  },
  maxLamellaLength: {
    id: 'app.containers.editview.maxLamellaLength',
    defaultMessage: 'Max Lamella Length'
  },
  minLamellaLength: {
    id: 'app.containers.editview.minLamellaLength',
    defaultMessage: 'Min Lamella Length'
  },
  maxLamellaWidth: {
    id: 'app.containers.editview.maxLamellaWidth',
    defaultMessage: 'Max Lamella Width'
  },
  minLamellaWidth: {
    id: 'app.containers.editview.minLamellaWidth',
    defaultMessage: 'Min Lamella Width'
  },
  maxLamellaThickness: {
    id: 'app.containers.editview.maxLamellaThickness',
    defaultMessage: 'Max Lamella Thickness'
  },
  minLamellaThickness: {
    id: 'app.containers.editview.minLamellaThickness',
    defaultMessage: 'Min Lamella Thickness'
  },
  minZincLength: {
    id: 'app.containers.editview.minZincLength',
    defaultMessage: 'Min Zinc Length'
  },
  maxZincLength: {
    id: 'app.containers.editview.maxZincLength',
    defaultMessage: 'Max Zinc Length'
  },
  cncOversize: {
    id: 'app.containers.editview.cncOversize',
    defaultMessage: 'Cnc Oversize'
  },
  goldenEyeConnected: {
    id: 'app.containers.editview.goldenEyeConnected',
    defaultMessage: 'Golden Eye Connected'
  },
  manualEmptyingID: {
    id: 'app.containers.editview.manualEmptyingID',
    defaultMessage: 'Manual Emptying I D'
  },
  percentageOfWoodBeforeGoldenEye: {
    id: 'app.containers.editview.percentageOfWoodBeforeGoldenEye',
    defaultMessage: 'Percentage Of Wood Before Golden Eye'
  },
  numberOfBoardsAfterPlaner: {
    id: 'app.containers.editview.numberOfBoardsAfterPlaner',
    defaultMessage: 'Number Of Boards After Planer'
  },
  sortingInfeedPlannedThicknessOffset: {
    id: 'app.containers.editview.sortingInfeedPlannedThicknessOffset',
    defaultMessage: 'Sorting Infeed Planed Thickness Offset'
  },
  emptyFromVacuumToZink: {
    id: 'app.containers.editview.emptyFromVacuumToZink',
    defaultMessage: 'Empty From Vacuum To Zink'
  },
  numberOfBoardsPlaned: {
    id: 'app.containers.editview.numberOfBoardsPlaned',
    defaultMessage: 'Number Of Boards Planed'
  },
  rawVacuumMode: {
    id: 'app.containers.editview.rawVacuumMode',
    defaultMessage: 'Raw Vacuum Mode'
  },
  pressPusher: {
    id: 'app.containers.editview.pressPusher',
    defaultMessage: 'Press Pusher'
  },
  sortingInfeedThickness: {
    id: 'app.containers.editview.sortingInfeedThickness',
    defaultMessage: 'Sorting Infeed Thickness'
  },
  panels: {
    id: 'app.containers.editview.panels',
    defaultMessage: 'Panels'
  },
  multiplePanels: {
    id: 'app.containers.editview.multiplePanels',
    defaultMessage: 'Multiple Panels'
  },
  panel: {
    id: 'app.containers.editview.panel',
    defaultMessage: 'Panel'
  },
  panelsInPress: {
    id: 'app.containers.editview.panelsInPress',
    defaultMessage: 'Panels in press'
  },
  joinedDimension: {
    id: 'app.containers.editview.joinedDimension',
    defaultMessage: 'Joined Dimension'
  },
  group: {
    id: 'app.containers.editview.group',
    defaultMessage: 'Group'
  },
  startId: {
    id: 'app.containers.editview.startId',
    defaultMessage: 'Start Id'
  },
  noGroupModeLOversize: {
    id: 'app.containers.editview.noGroupModeLOversize',
    defaultMessage: 'Group Mode L Oversize'
  },
  manualFilling: {
    id: 'app.containers.editview.manualFilling',
    defaultMessage: 'Manual Filling'
  },
  currentNeededMaterialForLayer: {
    id: 'app.containers.editview.currentNeededMaterialForLayer',
    defaultMessage: 'Current Needed Material For Layer'
  },
  woodBufferForDimension: {
    id: 'app.containers.editview.woodBufferForDimension',
    defaultMessage: 'Wood Buffer For Dimension'
  },
  changeWidthFrom: {
    id: 'app.containers.editview.changeWidthFrom',
    defaultMessage: 'Change Width From'
  },
  changeWidthTo: {
    id: 'app.containers.editview.changeWidthTo',
    defaultMessage: 'Change Width To'
  },
  changeThicknessFrom: {
    id: 'app.containers.editview.changeThicknessFrom',
    defaultMessage: 'Change Thickness From'
  },
  changeThicknessTo: {
    id: 'app.containers.editview.changeThicknessTo',
    defaultMessage: 'Change Thickness To'
  },
  changeBoardDimensions: {
    id: 'app.containers.editview.changeBoardDimensions',
    defaultMessage: 'Change Board Dimensions'
  },
  makeExtraLamellasId: {
    id: 'app.containers.editview.makeExtraLamellasId',
    defaultMessage: 'Make Extra Lamellas Id'
  },
  makeExtraLamellasNum: {
    id: 'app.containers.editview.makeExtraLamellasNum',
    defaultMessage: 'Make Extra Lamellas Number'
  },
  makeExtraLamellas: {
    id: 'app.containers.editview.makeExtraLamellas',
    defaultMessage: 'Make Extra Lamellas'
  },
  changePlaneThicknessFrom: {
    id: 'app.containers.editview.changePlaneThicknessFrom',
    defaultMessage: 'Change Plane Thickness From'
  },
  changePlaneThicknessTo: {
    id: 'app.containers.editview.changePlaneThicknessTo',
    defaultMessage: 'Change Planed Thickness To'
  },
  changePlaneThickness: {
    id: 'app.containers.editview.changePlaneThickness',
    defaultMessage: 'Change Planed Thickness'
  },
  stickerTest: {
    id: 'app.containers.editview.stickerTest',
    defaultMessage: 'Sticker Test'
  },
  stickerPanelThickness: {
    id: 'app.containers.editview.stickerPanelThickness',
    defaultMessage: 'Sticker Panel Thickness'
  },
  stickerPanelTopQaulity: {
    id: 'app.containers.editview.stickerPanelTopQaulity',
    defaultMessage: 'Sticker Top Qaulity'
  },
  stickerPanelBottomQuality: {
    id: 'app.containers.editview.stickerPanelBottomQuality',
    defaultMessage: 'Sticker Panel Bottom Quality'
  },
  stickerPanelId: {
    id: 'app.containers.editview.stickerPanelId',
    defaultMessage: 'Sticker Panel ID'
  },
  currentVacuumWidth: {
    id: 'app.containers.editview.currentVacuumWidth',
    defaultMessage: 'Current Vacuum Width'
  },
  currentVacuumThickness: {
    id: 'app.containers.editview.currentVacuumThickness',
    defaultMessage: 'Current Vacuum Thickness'
  },
  currentVacuumLength: {
    id: 'app.containers.editview.currentVacuumLength',
    defaultMessage: 'Current Vacuum Length'
  },
  manualVacuumAllowance: {
    id: 'app.containers.editview.manualVacuumAllowance',
    defaultMessage: 'Manual Vacuum Allowance'
  },
  manualMultiplanAllowance: {
    id: 'app.containers.editview.manualMultiplanAllowance',
    defaultMessage: 'Manual Multiplan Allowance'
  },
  manualFillingID: {
    id: 'app.containers.editview.manualFillingID',
    defaultMessage: 'Manual Filling ID'
  },
  maxRawWidth: {
    id: 'app.containers.editview.maxRawWidth',
    defaultMessage: 'Max raw width'
  },
  minRawWidth: {
    id: 'app.containers.editview.minRawWidth',
    defaultMessage: 'Min raw width'
  },
  urgent: {
    id: 'app.containers.editview.urgent',
    defaultMessage: 'Urgent'
  },
  toggleUrgent: {
    id: 'app.containers.editview.toggleUrgent',
    defaultMessage: 'Toggle Urgent'
  },
  productId: {
    id: 'app.containers.editview.productId',
    defaultMessage: 'Product Id'
  },
  stackerNumber: {
    id: 'app.containers.editview.stackerNumber',
    defaultMessage: 'Stacker'
  },
  storagePercentageUsed: {
    id: 'app.containers.editview.storagePercentageUsed',
    defaultMessage: 'Storage percentage used'
  },
  storagePercentageUsedAnte: {
    id: 'app.containers.editview.storagePercentageUsedAnte',
    defaultMessage: 'Storage percentage used'
  },
  wrapping: {
    id: 'app.containers.editview.wrapping',
    defaultMessage: 'Wrapping'
  },
  stopper: {
    id: 'app.containers.editview.stopper',
    defaultMessage: 'Anschlag'
  },
  jobCode: {
    id: 'app.containers.editview.jobCode',
    defaultMessage: 'Job code'
  },
  materialAlreadyLoadedFor: {
    id: 'app.containers.editview.materialAlreadyLoadedFor',
    defaultMessage: 'Already loaded for'
  },
  moveGroupDimChange: {
    id: 'app.containers.editview.moveGroupDimChange',
    defaultMessage: 'Move from next same dimension group on dimension breaks'
  },
  dimBreakId: {
    id: 'app.containers.editview.dimBreakId',
    defaultMessage: 'Dim Break id'
  },
  hasADimBreakOrder: {
    id: 'app.containers.editview.hasADimBreakOrder',
    defaultMessage: 'Has a dimension break order'
  },
  dimensionChangeFromNextGroup: {
    id: 'app.containers.editview.dimensionChangeFromNextGroup',
    defaultMessage: 'Dimension change order'
  },
  dimBreakOf: {
    id: 'app.containers.editview.dimBreakOf',
    defaultMessage: 'Dimension change of ID'
  },
  dimension: {
    id: 'app.containers.editview.dimension',
    defaultMessage: 'Dimension'
  },
  blockHeight: {
    id: 'app.containers.editview.blockHeight',
    defaultMessage: 'Panel stacking wood block height'
  },
  rollers1Height: {
    id: 'app.containers.editview.rollers1Height',
    defaultMessage: 'Rollers 1 height (CNC1)'
  },
  rollers2Height: {
    id: 'app.containers.editview.rollers2Height',
    defaultMessage: 'Rollers 2 height (CNC2)'
  },
  rollers3Height: {
    id: 'app.containers.editview.rollers3Height',
    defaultMessage: 'Rollers 3 height (EXIT)'
  },
  qOversizeMin: {
    id: 'app.containers.editview.qOversizeMin',
    defaultMessage: 'Q oversize MIN'
  },
  qOversizeMax: {
    id: 'app.containers.editview.qOversizeMax',
    defaultMessage: 'Q oversize MAX'
  },
  acceptableDimensionJumps: {
    id: 'app.containers.editview.acceptableDimensionJumps',
    defaultMessage: 'Acceptable dimension jumps'
  },
  oneByOneThreshold: {
    id: 'app.containers.editview.oneByOneThreshold',
    defaultMessage: 'One by one threshold'
  },
  addOrder: {
    id: 'app.containers.Tableview.addOrder',
    defaultMessage: 'Add new order'
  },
  addSupplier: {
    id: 'app.containers.Tableview.addSupplier',
    defaultMessage: 'Add new Supplier'
  },
  edit: {
    id: 'app.containers.editView.edit',
    defaultMessage: 'Edit'
  },
  add: {
    id: 'app.containers.editView.add',
    defaultMessage: 'Add'
  },
  formErrors: {
    id: 'app.containers.editView.formErrors',
    defaultMessage: 'Form is not completely filled!'
  },
  delete: {
    id: 'app.containers.editView.delete',
    defaultMessage: 'Delete'
  },
  transferToNewChild: {
    id: 'app.containers.editView.transferToNewChild',
    defaultMessage: 'Transfer data to new'
  },
  crossLayer: {
    id: 'app.containers.editView.crossLayer',
    defaultMessage: 'Cross layer'
  },
  insulationLayer: {
    id: 'app.containers.editView.insulationLayer',
    defaultMessage: 'Insulation layer'
  },
  insQLayer: {
    id: 'app.containers.editView.insQLayer',
    defaultMessage: 'Insulation Cross'
  },
  insLLayer: {
    id: 'app.containers.editView.insLLayer',
    defaultMessage: 'Insulation Long'
  },
  mLayer: {
    id: 'app.containers.editView.mLayer',
    defaultMessage: 'Multipiece Long'
  },
  longLayer: {
    id: 'app.containers.editView.longLayer',
    defaultMessage: 'Long layer'
  },
  addOrderWithRecipe: {
    id: 'app.containers.Tableview.addOrderWithRecipe',
    defaultMessage: 'Add Order with Recipe'
  },
  addProjectWithRecipe: {
    id: 'app.containers.Tableview.addProjectWithRecipe',
    defaultMessage: 'Add Project with new Length'
  },
  addLayerWithRecipe: {
    id: 'app.containers.Tableview.addLayerWithRecipe',
    defaultMessage: 'Add Recipe with recipe layers'
  },
  jdQueueTitle: {
    id: 'app.components.SideMenu.jdQueueTitle',
    defaultMessage: 'JD Queue'
  },
  closebtn: {
    id: 'app.containers.PackagesQueue.closebtn',
    defaultMessage: 'Close'
  },
  missinglamellreq: {
    id: 'app.containers.JoinedDimQueue.missinglamellreq',
    defaultMessage: 'Missing Lamellas request'
  },
  missingDimensions: {
    id: 'app.containers.JoinedDimQueue.missingDimensions',
    defaultMessage: 'Missing Dimensions'
  },
  extralamelreq: {
    id: 'app.containers.JoinedDimQueue.extralamelreq',
    defaultMessage: 'Extra Lamellas request'
  },
  testlamelreq: {
    id: 'app.containers.JoinedDimQueue.testlamelreq',
    defaultMessage: 'Test Lamellas request'
  },
  wastelamelreq: {
    id: 'app.containers.JoinedDimQueue.wastelamelreq',
    defaultMessage: 'Waste Lamellas request'
  },
  'missing-lamella-request': {
    id: 'app.containers.JoinedDimQueue.missingLamellaRequest',
    defaultMessage: 'Missing Lamella Request'
  },
  'extra-lamella-request': {
    id: 'app.containers.JoinedDimQueue.extraLamellaRequest',
    defaultMessage: 'Extra Lamella Request'
  },
  ignoreKVH: {
    id: 'app.containers.JoinedDimQueue.ignoreKVH',
    defaultMessage: 'Ignore KVH'
  },
  'test-lamella-request': {
    id: 'app.containers.JoinedDimQueue.testLamellaRequest',
    defaultMessage: 'Test Lamella Request'
  },
  'waste-lamella-request': {
    id: 'app.containers.JoinedDimQueue.wasteLamellaRequest',
    defaultMessage: 'Waste Lamella Request'
  },
  lagerShortTitle: {
    id: 'app.containers.DashboardXLAM.lagerShortTitle',
    defaultMessage: 'Lager Short'
  },
  press: {
    id: 'app.components.SideMenu.press',
    defaultMessage: 'Press'
  },
  extraStoragePlcTitle: {
    id: 'app.containers.MachineTitles.extraStoragePlcTitle',
    defaultMessage: 'Extra Lamella Storage PLC Signals'
  },
  extraLamellaTitle: {
    id: 'app.containers.MachineTitles.extraLamellaTitle',
    defaultMessage: 'Add Extra Lamella'
  },
  cutList: {
    id: 'app.containers.MachineTitles.cutList',
    defaultMessage: 'Cutlist'
  },
  trashLamellaTitle: {
    id: 'app.containers.MachineTitles.trashLamellaTitle',
    defaultMessage: 'Remove Lamella'
  },
  goldeneyePlcTitle: {
    id: 'app.containers.MachineTitles.goldeneyePlcTitle',
    defaultMessage: 'Goldeneye PLC Signals'
  },
  goldeneyeExtraLamellaTitle: {
    id: 'app.containers.MachineTitles.goldeneyeExtraLamellaTitle',
    defaultMessage: 'Extra Lamella'
  },
  goldeneyeTitle: {
    id: 'app.containers.MachineTitles.goldeneyeTitle',
    defaultMessage: 'Goldeneye'
  },
  goldeneyeMeasures: {
    id: 'app.containers.MachineTitles.goldeneyeMeasures',
    defaultMessage: 'Goldeneye measures'
  },
  goldeneyeSubtitle: {
    id: 'app.containers.MachineTitles.goldeneyeSubtitle',
    defaultMessage: 'Scan report | Lamellas before XCut'
  },
  beforexcutTitle: {
    id: 'app.containers.MachineTitles.beforexcutTitle',
    defaultMessage: 'Before XCUT Lamellas'
  },
  xcutPlcTitle: {
    id: 'app.containers.MachineTitles.xcutPlcTitle',
    defaultMessage: 'XCUT PLC Signals'
  },
  infeedPlcTitle: {
    id: 'app.containers.MachineTitles.infeedPlcTitle',
    defaultMessage: 'Infeed PLC Signals'
  },
  insulationPlcTitle: {
    id: 'app.containers.MachineTitles.insulationPlcTitle',
    defaultMessage: 'Vacuum Insulation PLC Signals'
  },
  crossZPressPlcTitle: {
    id: 'app.containers.MachineTitles.crossZPressPlcTitle',
    defaultMessage: 'Cross ZPress PLC Signals'
  },
  infeedSettingsTitle: {
    id: 'app.containers.MachineTitles.infeedSettingsTitle',
    defaultMessage: 'Infeed Settings'
  },
  freigabeMicrotec: {
    id: 'app.containers.MachineTitles.freigabeMicrotec',
    defaultMessage: 'Freigabe to Microtec Scanner - data received'
  },
  testLamellaRequest: {
    id: 'app.containers.MachineTitles.testLamellaRequest',
    defaultMessage: 'Test Lamella request'
  },
  testLamellaConditions: {
    id: 'app.containers.MachineTitles.testLamellaConditions',
    defaultMessage: 'Test lamella conditions'
  },
  resendXcutData: {
    id: 'app.containers.MachineTitles.resendXcutData',
    defaultMessage: 'Resend Xcut Data'
  },
  testReaJetData: {
    id: 'app.containers.MachineTitles.testReaJetData',
    defaultMessage: 'Test ReaJet Data'
  },
  resetOperatorWaste: {
    id: 'app.containers.MachineTitles.resetOperatorWaste',
    defaultMessage: 'Reset operator waste'
  },
  clearScannedPackage: {
    id: 'app.containers.MachineTitles.clearScannedPackage',
    defaultMessage: 'Clear scanned package'
  },
  paketDataNachPLC: {
    id: 'app.containers.MachineTitles.paketDataNachPLC',
    defaultMessage: 'Paket data nach PLC'
  },
  resendProducedPaketInfodata: {
    id: 'app.containers.MachineTitles.resendProducedPaketInfodata',
    defaultMessage: 'Resend Produced Paket Infodata'
  },
  resendProducedPaketPrinter: {
    id: 'app.containers.MachineTitles.resendProducedPaketPrinter',
    defaultMessage: 'Resend Produced Paket Printer'
  },
  testSticker: {
    id: 'app.containers.MachineTitles.resendProducedPaketPrinter',
    defaultMessage: 'Test Sticker'
  },
  beforeStorageTitle: {
    id: 'app.containers.MachineTitles.beforeStorageTitle',
    defaultMessage: 'Before Storage'
  },
  missingID: {
    id: 'app.containers.MachineTitles.missingID',
    defaultMessage: 'No ID'
  },
  missingSmartyInfo: {
    id: 'app.containers.MachineTitles.missingSmartyInfo',
    defaultMessage: 'Missing Information from Smarty'
  },
  CompleteInfoAboutLamella: {
    id: 'app.containers.MachineTitles.CompleteInfoAboutLamella',
    defaultMessage: 'Complete Information'
  },
  InfeedMachinesTitle: {
    id: 'app.containers.MachineTitles.InfeedMachinesTitle',
    defaultMessage: 'Infeed'
  },
  OutfeedMachinesTitle: {
    id: 'app.containers.MachineTitles.InfeedMachinesTitle',
    defaultMessage: 'Outfeed'
  },
  lamellaStorage: {
    id: 'app.containers.MachineTitles.lamellaStorage',
    defaultMessage: 'Lamella Storage'
  },
  infeedLoadersTitle: {
    id: 'app.containers.MachineTitles.infeedLoadersTitle',
    defaultMessage: 'Infeed Loaders'
  },
  zincPlcTitle: {
    id: 'app.containers.MachineTitles.zincPlcTitle',
    defaultMessage: 'Zinc PLC Signals'
  },
  zincSettingsTitle: {
    id: 'app.containers.MachineTitles.zincSettingsTitle',
    defaultMessage: 'Zinc Settings'
  },
  dryingPlcTitle: {
    id: 'app.containers.MachineTitles.dryingPlcTitle',
    defaultMessage: 'Drying PLC Signals'
  },
  lagerlongPlcTitle: {
    id: 'app.containers.MachineTitles.lagerlongPlcTitle',
    defaultMessage: 'Lager Long PLC Signals'
  },
  lagershortPlcTitle: {
    id: 'app.containers.MachineTitles.lagershortPlcTitle',
    defaultMessage: 'Lager Short PLC Signals'
  },
  lagershortTitle: {
    id: 'app.containers.MachineTitles.lagershortTitle',
    defaultMessage: 'Lager Short Status'
  },
  lagerlongTitle: {
    id: 'app.containers.MachineTitles.lagerlongTitle',
    defaultMessage: 'Lager Long Status'
  },
  dryingSettingsTitle: {
    id: 'app.containers.MachineTitles.dryingSettingsTitle',
    defaultMessage: 'Drying Settings'
  },
  pressPlcTitle: {
    id: 'app.containers.MachineTitles.pressPlcTitle',
    defaultMessage: 'Press PLC Signals'
  },
  sandingTitle: {
    id: 'app.containers.MachineTitle.sandingTitle',
    defaultMessage: 'Sanding'
  },
  pressStatusTitle: {
    id: 'app.containers.MachineTitles.pressStatusTitle',
    defaultMessage: 'Press Status'
  },
  lam_elevatorTitle: {
    id: 'app.containers.MachineTitles.lam_elevatorTitle',
    defaultMessage: 'Lamella on lift'
  },
  floor1_sector1Title: {
    id: 'app.containers.MachineTitles.floor1_sector1Title',
    defaultMessage: 'Storage first compartment'
  },
  floor1_sector2Title: {
    id: 'app.containers.MachineTitles.floor1_sector2Title',
    defaultMessage: 'Storage second compartment'
  },
  firstCompartmentTitle: {
    id: 'app.containers.MachineTitles.firstCompartmentTitle',
    defaultMessage: 'Storage first compartment'
  },
  secondCompartmentTitle: {
    id: 'app.containers.MachineTitles.secondCompartmentTitle',
    defaultMessage: 'Storage second compartment'
  },
  thirdCompartmentTitle: {
    id: 'app.containers.MachineTitles.thirdCompartmentTitle',
    defaultMessage: 'Storage third compartment'
  },
  fourthCompartmentTitle: {
    id: 'app.containers.MachineTitles.fourthCompartmentTitle',
    defaultMessage: 'Storage fourth compartment'
  },
  fifthCompartmentTitle: {
    id: 'app.containers.MachineTitles.fifthCompartmentTitle',
    defaultMessage: 'Storage fifth compartment'
  },
  lam_for_epTitle: {
    id: 'app.containers.MachineTitles.lam_for_epTitle',
    defaultMessage: 'Lamella before Europlan'
  },
  lam_after_epTitle: {
    id: 'app.containers.MachineTitles.lam_after_epTitle',
    defaultMessage: 'Lamella after Europlan'
  },
  stacker_liftTitle: {
    id: 'app.containers.MachineTitles.stacker_liftTitle',
    defaultMessage: 'Lift stacker'
  },
  stackerTitle: {
    id: 'app.containers.MachineTitles.stackerTitle',
    defaultMessage: 'Stacker'
  },
  layerAfterEp: {
    id: 'app.containers.MachineTitles.layerAfterEp',
    defaultMessage: 'Layer after Europlan'
  },
  layerAfterEp1: {
    id: 'app.containers.MachineTitles.layerAfterEp1',
    defaultMessage: 'Layer 1 after Europlan'
  },
  layerAfterEp2: {
    id: 'app.containers.MachineTitles.layerAfterEp2',
    defaultMessage: 'Layer 2 after Europlan'
  },
  packageRollConveyor: {
    id: 'app.containers.MachineTitles.packageRollConveyor',
    defaultMessage: 'Package roll conveyor'
  },
  packageRollConveyor1: {
    id: 'app.containers.MachineTitles.packageRollConveyor1',
    defaultMessage: 'Package roll conveyor 1'
  },
  packageRollConveyor2: {
    id: 'app.containers.MachineTitles.packageRollConveyor2',
    defaultMessage: 'Package roll conveyor 2'
  },
  wrapper_forksTitle: {
    id: 'app.containers.MachineTitles.wrapper_forksTitle',
    defaultMessage: 'Wrapper forks'
  },
  wrapperTitle: {
    id: 'app.containers.MachineTitles.wrapperTitle',
    defaultMessage: 'Wrapper'
  },
  wrapped_packageTitle: {
    id: 'app.containers.MachineTitles.wrapped_packageTitle',
    defaultMessage: 'Before Wrapping'
  },
  aufsnit: {
    id: 'app.components.TabelaricModal.aufsnit',
    defaultMessage: 'Long lamella length margin'
  },
  selectPackageTitle: {
    id: 'app.components.RawInfeedLoadingBox.selectPackageTitle',
    defaultMessage: 'Assign package'
  },
  assignProduct: {
    id: 'app.components.RawInfeedLoadingBox.assignProduct',
    defaultMessage: 'Assign product'
  },
  woodSupplier: {
    id: 'app.components.RawInfeedLoadingBox.woodSupplier',
    defaultMessage: 'Wood Supplier'
  },
  assignedProductStacker: {
    id: 'app.components.RawInfeedLoadingBox.assignedProductStacker',
    defaultMessage: 'Assigned Product'
  },
  product: {
    id: 'app.components.RawInfeedLoadingBox.product',
    defaultMessage: 'Product'
  },
  assignSupplier: {
    id: 'app.components.RawInfeedLoadingBox.assignSupplier',
    defaultMessage: 'Assign supplier'
  },
  inputPackage: {
    id: 'app.components.RawInfeed.inputPackage',
    defaultMessage: 'Input Package'
  },
  layerInput: {
    id: 'app.components.RawInfeed.layerInput',
    defaultMessage: 'Layer Input'
  },
  layerExit: {
    id: 'app.components.RawInfeed.layerExit',
    defaultMessage: 'Layer Exit'
  },
  cross: {
    id: 'app.components.RawInfeed.cross',
    defaultMessage: 'zig zag'
  },
  sticks: {
    id: 'app.components.RawInfeed.sticks',
    defaultMessage: 'sticks'
  },
  middle: {
    id: 'app.components.RawInfeed.middle',
    defaultMessage: 'middle'
  },
  midnight: {
    id: 'app.components.RawInfeed.midnight',
    defaultMessage: 'Start Daily Counter'
  },
  straps: {
    id: 'app.components.RawInfeed.straps',
    defaultMessage: 'straps'
  },
  fj: {
    id: 'app.components.RawInfeed.fj',
    defaultMessage: 'FJ'
  },
  warehouse: {
    id: 'app.components.RawInfeed.warehouse',
    defaultMessage: 'Warehouse'
  },
  pressStackerTitle: {
    id: 'app.containers.MachineTitles.pressStackerTitle',
    defaultMessage: 'Press Stacker'
  },
  stackerSettingsTitle: {
    id: 'app.containers.MachineTitles.stackerSettingsTitle',
    defaultMessage: 'Stacker Settings'
  },
  lastPrintedLabel: {
    id: 'app.containers.MachineTitles.lastPrintedLabel',
    defaultMessage: 'Last printed label'
  },
  loading: {
    id: 'app.containers.MachineTitles.loading',
    defaultMessage: 'Loading'
  },
  stackerPlcTitle: {
    id: 'app.containers.MachineTitles.stackerPlcTitle',
    defaultMessage: 'Stacker PLC Signals'
  },
  orderDetails: {
    id: 'app.containers.MachineTitles.orderDetails',
    defaultMessage: 'Order details'
  },
  panelCorrectionMode: {
    id: 'app.containers.MachineTitles.panelCorrectionMode',
    defaultMessage: 'Panel correction'
  },
  craneOperation: {
    id: 'app.containers.MachineTitles.craneOperation',
    defaultMessage: 'Crane operation'
  },
  vacuumOperation: {
    id: 'app.containers.MachineTitles.vacuumOperation',
    defaultMessage: 'Vacuum operation'
  },
  allowDrag: {
    id: 'app.containers.MachineTitles.allowDrag',
    defaultMessage: 'Allow Drag'
  },
  update: {
    id: 'app.containers.MachineTitles.updated',
    defaultMessage: 'Update'
  },
  reset: {
    id: 'app.containers.MachineTitles.reset',
    defaultMessage: 'Reset'
  },
  cutlist: {
    id: 'app.containers.MachineTitles.cutlist',
    defaultMessage: 'Cutlist'
  },
  fromLocation: {
    id: 'app.containers.MachineTitles.fromLocation',
    defaultMessage: 'From location'
  },
  toLocation: {
    id: 'app.containers.MachineTitles.toLocation',
    defaultMessage: 'To location'
  },
  sendToXLAM: {
    id: 'app.containers.MachineTitles.sendToXLAM',
    defaultMessage: 'Send to XLAM'
  },
  requestStarted: {
    id: 'app.containers.MachineTitles.requestStarted',
    defaultMessage: 'Request started'
  },
  sourceConfirmed: {
    id: 'app.containers.MachineTitles.sourceConfirmed',
    defaultMessage: 'Source confirmed'
  },
  destinationConfirmed: {
    id: 'app.containers.MachineTitles.destinationConfirmed',
    defaultMessage: 'Destination confirmed'
  },
  RCallowance: {
    id: 'app.containers.MachineTitles.RCallowance',
    defaultMessage: 'RC Allowance'
  },
  generalCraneAllowance: {
    id: 'app.containers.MachineTitles.generalCraneAllowance',
    defaultMessage: 'Crane Allowance'
  },
  currentCraneOrder: {
    id: 'app.containers.MachineTitles.currentCraneOrder',
    defaultMessage: 'Current crane order'
  },
  sendToCNC1: {
    id: 'app.containers.MachineTitles.sendToCNC1',
    defaultMessage: 'Send to CNC 1'
  },
  sendToCNC2: {
    id: 'app.containers.MachineTitles.sendToCNC2',
    defaultMessage: 'Send to CNC 2'
  },
  vhod1title: {
    id: 'app.containers.InfeedRaw.vhod1title',
    defaultMessage: 'Infeed'
  },
  xcut1title: {
    id: 'app.containers.xcut1.xcut1title',
    defaultMessage: 'XCut1'
  },
  moisture: {
    id: 'app.containers.InfeedRaw.moisture',
    defaultMessage: 'Moisture meter settings'
  },
  supplier: {
    id: 'app.components.modals.PackageLoading.supplier',
    defaultMessage: 'SUPPLIER'
  },
  numOfBoards: {
    id: 'app.components.modals.PackageLoading.numOfBoards',
    defaultMessage: 'NO. BOARDS'
  },
  species: {
    id: 'app.components.modals.PackageLoading.species',
    defaultMessage: 'SPECIES'
  },
  set: {
    id: 'app.components.modals.PackageLoading.set',
    defaultMessage: 'SET'
  },
  numRows: {
    id: 'app.components.modals.PackageLoading.numRows',
    defaultMessage: 'NO. ROWS'
  },
  numColumns: {
    id: 'app.components.modals.PackageLoading.numColumns',
    defaultMessage: 'NO. COLS'
  },
  setModalTitle: {
    id: 'app.components.modals.PackageLoading.setModalTitle',
    defaultMessage: 'package'
  },
  areaA11Simple: {
    id: 'app.components.modals.PackageLoading.areaA11Simple',
    defaultMessage: 'Area A11'
  },
  areaA12Simple: {
    id: 'app.components.modals.PackageLoading.areaA12Simple',
    defaultMessage: 'Area A12'
  },
  areaA11: {
    id: 'app.components.modals.PackageLoading.areaA11',
    defaultMessage: 'Area A11 (package loading)'
  },
  areaA12: {
    id: 'app.components.modals.PackageLoading.areaA12',
    defaultMessage: 'Area A12 (vacuum)'
  },
  areaA13: {
    id: 'app.components.modals.PackageLoading.areaA13',
    defaultMessage: 'Area A13 (dog chain)'
  },
  automaticA11: {
    id: 'app.components.modals.PackageLoading.automaticA11',
    defaultMessage: 'Automatic A11 (package loading)'
  },
  automaticA12: {
    id: 'app.components.modals.PackageLoading.automaticA12',
    defaultMessage: 'Automatic A12 (vacuum)'
  },
  automaticA13: {
    id: 'app.components.modals.PackageLoading.automaticA13',
    defaultMessage: 'Automatic A13 (dog chain)'
  },
  ml: {
    id: 'app.components.modals.PackageLoading.ml',
    defaultMessage: 'Manual loading'
  },
  xcutempty: {
    id: 'app.components.modals.PackageLoading.xcutempty',
    defaultMessage: 'XCut empty'
  },
  clearanceHolder1: {
    id: 'app.components.modals.PackageLoading.clearanceHolder1',
    defaultMessage: 'Clearance holder 1'
  },
  clearanceVacuum: {
    id: 'app.components.modals.PackageLoading.clearanceVacuum',
    defaultMessage: 'Vacuum clearance'
  },
  A1Clearance: {
    id: 'app.components.modals.PackageLoading.A1Clearance',
    defaultMessage: 'A1 clearance to load'
  },
  B1Clearance: {
    id: 'app.components.modals.PackageLoading.B1Clearance',
    defaultMessage: 'B1 clearance to load'
  },
  C1Clearance: {
    id: 'app.components.modals.PackageLoading.C1Clearance',
    defaultMessage: 'C1 clearance to load'
  },
  D1Clearance: {
    id: 'app.components.modals.PackageLoading.D1Clearance',
    defaultMessage: 'D1 clearance to load'
  },
  newDimension: {
    id: 'app.components.modals.PackageLoading.newDimension',
    defaultMessage: 'New dimension'
  },
  holder1: {
    id: 'app.components.modals.PackageLoading.holder1',
    defaultMessage: 'Holder 1'
  },
  empty: {
    id: 'app.components.modals.PackageLoading.empty',
    defaultMessage: 'Empty'
  },
  notEmpty: {
    id: 'app.components.modals.PackageLoading.notEmpty',
    defaultMessage: 'Not empty'
  },
  boards: {
    id: 'app.components.modals.PackageLoading.boards',
    defaultMessage: 'boards'
  },
  moistureMeterParameters: {
    id: 'app.components.modals.PackageLoading.moistureMeterParameters',
    defaultMessage: 'Moisture meter parameters'
  },
  numberOfBoardsBeforeHolder1: {
    id: 'app.components.modals.PackageLoading.numberOfBoardsBeforeHolder1',
    defaultMessage: 'Number of boards before holder 1'
  },
  boardsBeforeOptiscan: {
    id: 'app.components.modals.PackageLoading.boardsBeforeOptiscan',
    defaultMessage: 'LAMELLAS BEFORE OPTISCAN'
  },
  dogChainBoards: {
    id: 'app.components.modals.PackageLoading.dogChainBoards',
    defaultMessage: 'MITNEMER LAMELLAS'
  },
  addScannedPackage: {
    id: 'app.components.modals.PackageLoading.addScannedPackage',
    defaultMessage: 'ADD SCANNED PACKAGE'
  },
  XCutEvents: {
    id: 'app.components.modals.PackageLoading.XCutEvents',
    defaultMessage: 'XCUT EVENTS'
  },
  turnOffManualLoading: {
    id: 'app.components.modals.PackageLoading.turnOffManualLoading',
    defaultMessage: 'TURN OFF MANUAL LOADING'
  },
  clearBeforeOptifeed: {
    id: 'app.components.modals.PackageLoading.clearBeforeOptifeed',
    defaultMessage: 'CLEAR BEFORE OPTIFEED'
  },
  resendMicrotecData: {
    id: 'app.components.modals.PackageLoading.resendMicrotecData',
    defaultMessage: 'Resend batch/package data to Microtec'
  },
  currentNeededForLayer: {
    id: 'app.components.modals.PackageLoading.currentNeededForLayer',
    defaultMessage: 'Current needed for layer'
  },
  currentAfterGoldenEyeToXCut: {
    id: 'app.components.modals.PackageLoading.currentAfterGoldenEyeToXCut',
    defaultMessage: 'Current wood after goldeneye to xcut'
  },
  totalNeededAfterGoldenEye: {
    id: 'app.components.modals.PackageLoading.totalNeededAfterGoldenEye',
    defaultMessage: 'Total needed after golden eye'
  },
  currentBatchId: {
    id: 'app.components.modals.PackageLoading.currentBatchId',
    defaultMessage: 'Current batch id'
  },
  scannedPackagesQueue: {
    id: 'app.components.modals.PackageLoading.scannedPackagesQueue',
    defaultMessage: 'Scanned packages queue'
  },
  moveScannedToLoaded: {
    id: 'app.components.modals.PackageLoading.moveScannedToLoaded',
    defaultMessage: 'Scanned to loaded'
  },
  cutWasteBoardsOnXCut: {
    id: 'app.components.modals.PackageLoading.cutWasteBoardsOnXCut',
    defaultMessage: 'Cut waste boards on xcut'
  },
  groupid: {
    id: 'app.containers.Zinc.groupid',
    defaultMessage: 'Group ID '
  },
  orderid: {
    id: 'app.containers.Zinc.orderid',
    defaultMessage: 'Order ID '
  },
  woodonline: {
    id: 'app.containers.Zinc.woodonline',
    defaultMessage: 'Current wood on line'
  },
  woodonlineForDim: {
    id: 'app.containers.Zinc.woodonlineForDim',
    defaultMessage: 'Current wood on line for dim.'
  },
  neededmaterial: {
    id: 'app.containers.Zinc.neededmaterial',
    defaultMessage: 'Current needed material'
  },
  vacuumstatus: {
    id: 'app.containers.Zinc.vacuumstatus',
    defaultMessage: 'Vacuum status'
  },
  mode: {
    id: 'app.containers.Zinc.mode',
    defaultMessage: 'Mode'
  },
  lamellasproduced: {
    id: 'app.containers.Zinc.lamellasproduced',
    defaultMessage: 'Lamellas produced'
  },
  lamellarequest: {
    id: 'app.containers.Zinc.lamellarequest',
    defaultMessage: 'Test lamella request'
  },
  forlayers: {
    id: 'app.containers.Zinc.forlayers',
    defaultMessage: 'm for layers'
  },
  totalDimNum: {
    id: 'app.containers.Zinc.totalDimNum',
    defaultMessage: 'Total for dim.'
  },
  mainChainEmpty: {
    id: 'app.containers.Zinc.mainChainEmpty',
    defaultMessage: 'Main chain empty'
  },
  lineEmptyUntilZink: {
    id: 'app.containers.Zinc.lineEmptyUntilZink',
    defaultMessage: 'Infeed empty'
  },
  jointEmpty: {
    id: 'app.containers.Zinc.jointEmpty',
    defaultMessage: 'Joint empty'
  },
  powerFeedEmpty: {
    id: 'app.containers.Zinc.powerFeedEmpty',
    defaultMessage: 'Powerfeed empty'
  },
  exitStatusTitle: {
    id: 'app.containers.MachineTitles.exitStatusTitle',
    defaultMessage: 'Exit Status'
  },
  recalc: {
    id: 'app.containers.OrdersQueue.recalc',
    defaultMessage: 'Recalculate groups'
  },
  combineidValidation: {
    id: 'app.containers.OrdersQueue.combineidValidation',
    defaultMessage: 'Combined ID validation'
  },
  fiber: {
    id: 'app.components.SideMenu.fiber',
    defaultMessage: '3D model'
  },
  exit: {
    id: 'app.components.SideMenu.exit',
    defaultMessage: 'Exit'
  },
  orders: {
    id: 'app.components.SideMenu.orders',
    defaultMessage: 'Orders'
  },
  beams: {
    id: 'app.components.SideMenu.beams',
    defaultMessage: 'Beams'
  },
  beam: {
    id: 'app.components.SideMenu.beam',
    defaultMessage: 'Beam'
  },
  bsh: {
    id: 'app.components.SideMenu.bsh',
    defaultMessage: 'BSH Orders'
  },
  kvh: {
    id: 'app.components.SideMenu.kvh',
    defaultMessage: 'KVH Orders'
  },
  schilligerTodo: {
    id: 'app.components.SideMenu.schilligerTodo',
    defaultMessage: 'Todo'
  },
  schilligerReady: {
    id: 'app.components.SideMenu.schilligerReady',
    defaultMessage: 'Ready'
  },
  schilligerDone: {
    id: 'app.components.SideMenu.schilligerDone',
    defaultMessage: 'Done'
  },
  schilligerProducing: {
    id: 'app.components.SideMenu.schilligerProducing',
    defaultMessage: 'Producing'
  },
  schilligerOrders: {
    id: 'app.components.SideMenu.schilligerOrders',
    defaultMessage: 'Orders'
  },
  schilligerSorted: {
    id: 'app.components.SideMenu.schilligerSorted',
    defaultMessage: 'Sorted'
  },
  fileUploaded: {
    id: 'app.components.SideMenu.fileUploaded',
    defaultMessage: 'Upload'
  },
  minda: {
    id: 'app.components.SideMenu.minda',
    defaultMessage: 'Minda'
  },
  csv: {
    id: 'app.components.SideMenu.csv',
    defaultMessage: 'CSV'
  },
  ordersUploaded: {
    id: 'app.components.SideMenu.fileUploaded',
    defaultMessage: 'Orders upload'
  },
  excelStatistics: {
    id: 'app.components.SideMenu.excelStatistics',
    defaultMessage: 'Excel Statistics'
  },
  configFiles: {
    id: 'app.components.SideMenu.configFiles',
    defaultMessage: 'Configuration files'
  },
  todo: {
    id: 'app.components.SideMenu.todo',
    defaultMessage: 'Todo'
  },
  nextToDo: {
    id: 'app.components.SideMenu.nextToDo',
    defaultMessage: 'Next To Do'
  },
  ready: {
    id: 'app.components.SideMenu.ready',
    defaultMessage: 'Ready'
  },
  optimized: {
    id: 'app.components.SideMenu.optimized',
    defaultMessage: 'Optimized'
  },
  done: {
    id: 'app.components.SideMenu.done',
    defaultMessage: 'Done'
  },
  producing: {
    id: 'app.components.SideMenu.producing',
    defaultMessage: 'producing'
  },
  servers: {
    id: 'app.components.SideMenu.servers',
    defaultMessage: 'Servers'
  },
  packages: {
    id: 'app.components.SideMenu.packages',
    defaultMessage: 'Packages'
  },
  incoming: {
    id: 'app.components.SideMenu.incoming',
    defaultMessage: 'Incoming'
  },
  cart: {
    id: 'app.components.SideMenu.cart',
    defaultMessage: 'Cart'
  },
  sorted: {
    id: 'app.components.SideMenu.sorted',
    defaultMessage: 'Sorted'
  },
  created: {
    id: 'app.components.SideMenu.created',
    defaultMessage: 'Created'
  },
  qualitySorting: {
    id: 'app.components.SideMenu.qualitySorting',
    defaultMessage: 'Q. Sorting'
  },
  recipes: {
    id: 'app.components.SideMenu.recipes',
    defaultMessage: 'Recipes'
  },
  recipeLayer: {
    id: 'app.components.SideMenu.recipeLayer',
    defaultMessage: 'Layer Recipe'
  },
  materialsTable: {
    id: 'app.components.SideMenu.materialsTable',
    defaultMessage: 'Materials Table'
  },
  qualityTable: {
    id: 'app.components.SideMenu.qualityTable',
    defaultMessage: 'Quality Table'
  },
  primer: {
    id: 'app.components.SideMenu.primer',
    defaultMessage: 'Primer'
  },
  eventlog: {
    id: 'app.components.SideMenu.eventlog',
    defaultMessage: 'Eventlog'
  },
  lineSettings: {
    id: 'app.components.SideMenu.lineSettings',
    defaultMessage: 'Line Settings'
  },
  maintenance: {
    id: 'app.components.SideMenu.maintenance',
    defaultMessage: 'Maintenance'
  },
  fixedRecipeLayers: {
    id: 'app.components.SideMenu.fixedRecipeLayers',
    defaultMessage: 'Fixed Recipe Layers'
  },
  hollow: {
    id: 'app.components.SideMenu.hollow',
    defaultMessage: 'Hollow'
  },
  erp: {
    id: 'app.components.SideMenu.erp',
    defaultMessage: 'Erp'
  },
  refinements: {
    id: 'app.components.SideMenu.refinements',
    defaultMessage: 'Refinements'
  },
  extralamellas: {
    id: 'app.components.SideMenu.extralamellas',
    defaultMessage: 'Extra lamellas'
  },
  productionline: {
    id: 'app.components.SideMenu.productionline',
    defaultMessage: 'Production line'
  },
  productionstatus: {
    id: 'app.components.SideMenu.productionstatus',
    defaultMessage: 'Status'
  },
  productlist: {
    id: 'app.components.SideMenu.productlist',
    defaultMessage: 'Product List'
  },
  materialNeededTitle: {
    id: 'app.components.SideMenu.materialNeededTitle',
    defaultMessage: 'Material needed'
  },
  accumulatorEtages: {
    id: 'app.components.SideMenu.accumulatorEtages',
    defaultMessage: 'Accumulator Etages'
  },
  lamellasOnTheLine: {
    id: 'app.components.SideMenu.lamellasOnTheLine',
    defaultMessage: 'Lamellas On The Line'
  },
  packagesQueueTitle: {
    id: 'app.components.SideMenu.packagesQueueTitle',
    defaultMessage: 'Packages Queue'
  },
  incomingPackagesQueueTitle: {
    id: 'app.components.SideMenu.incomingPackagesQueueTitle',
    defaultMessage: 'Inc. Pckg.'
  },
  createdPackagesQueueTitle: {
    id: 'app.components.SideMenu.createdPackagesQueueTitle',
    defaultMessage: 'Created Pckg.'
  },
  errorListTitle: {
    id: 'app.components.SideMenu.errorListTitle',
    defaultMessage: 'Error List'
  },
  problemSolutionTitle: {
    id: 'app.components.SideMenu.problemSolutionTitle',
    defaultMessage: 'Get the solution to your problem'
  },
  sortingQueueTitle: {
    id: 'app.components.SideMenu.sortingQueueTitle',
    defaultMessage: 'Sorting Queue'
  },
  maschines: {
    id: 'app.components.SideMenu.maschines',
    defaultMessage: 'Machines'
  },
  IBA: {
    id: 'app.components.SideMenu.IBA',
    defaultMessage: 'IBA'
  },
  maschinesAnte: {
    id: 'app.components.SideMenu.maschinesAnte',
    defaultMessage: 'Machines'
  },
  lagerlong: {
    id: 'app.components.SideMenu.lagerlong',
    defaultMessage: 'Lager Long'
  },
  lagerlongAnte: {
    id: 'app.components.SideMenu.lagerlongAnte',
    defaultMessage: 'Lager Long'
  },
  lagershort: {
    id: 'app.components.SideMenu.lagershort',
    defaultMessage: 'Lager Short'
  },
  lagershortAnte: {
    id: 'app.components.SideMenu.lagershortAnte',
    defaultMessage: 'Lager Short'
  },
  drying: {
    id: 'app.components.SideMenu.drying',
    defaultMessage: 'Drying'
  },
  dryingAnte: {
    id: 'app.components.SideMenu.dryingAnte',
    defaultMessage: 'Drying'
  },
  setToSpl: {
    id: 'app.components.SideMenu.setToSpl',
    defaultMessage: 'Set For Spl'
  },
  dryingSim: {
    id: 'app.components.SideMenu.dryingSim',
    defaultMessage: 'Drying Simulation'
  },
  dryingMech: {
    id: 'app.components.SideMenu.dryingMech',
    defaultMessage: 'Drying Mech.'
  },
  longlamellas: {
    id: 'app.components.SideMenu.longlamellas',
    defaultMessage: 'Lamellas ZPressLong'
  },
  shortlamellas: {
    id: 'app.components.SideMenu.shortlamellas',
    defaultMessage: 'Lamellas ZPressShort'
  },
  zpress: {
    id: 'app.components.SideMenu.zpress',
    defaultMessage: 'ZPress'
  },
  schneiderDrying: {
    id: 'app.components.SideMenu.schneiderDrying',
    defaultMessage: 'Drying'
  },
  zincs: {
    id: 'app.components.SideMenu.zincs',
    defaultMessage: 'Zincs'
  },
  zinc1: {
    id: 'app.components.SideMenu.zinc1',
    defaultMessage: 'Zinc 1'
  },
  zinc2: {
    id: 'app.components.SideMenu.zinc2',
    defaultMessage: 'Zinc 2'
  },
  zinc3: {
    id: 'app.components.SideMenu.zinc3',
    defaultMessage: 'Zinc 3'
  },
  zinc: {
    id: 'app.components.SideMenu.zinc',
    defaultMessage: 'Zinc'
  },
  bodenlager: {
    id: 'app.components.SideMenu.bodenlager',
    defaultMessage: 'Stacking storage'
  },
  goldeneye: {
    id: 'app.components.SideMenu.goldeneye',
    defaultMessage: 'Goldeneye'
  },
  smartiFifo: {
    id: 'app.components.SideMenu.smartiFifo',
    defaultMessage: 'Smarti'
  },
  m3Connected: {
    id: 'app.components.SideMenu.m3Connected',
    defaultMessage: 'M3 Connected'
  },
  stacker: {
    id: 'app.components.SideMenu.stacker',
    defaultMessage: 'Stacker'
  },
  stack: {
    id: 'app.components.SideMenu.stack',
    defaultMessage: 'Stack'
  },
  presstacker: {
    id: 'app.components.SideMenu.presstacker',
    defaultMessage: 'Press Stacker'
  },
  packageinfeed: {
    id: 'app.components.SideMenu.packageinfeed',
    defaultMessage: 'Sorting Packages'
  },
  packageinfeedAnte: {
    id: 'app.components.SideMenu.packageinfeedAnte',
    defaultMessage: 'X-Cut'
  },
  loadedPackages: {
    id: 'app.components.SideMenu.loadedPackages',
    defaultMessage: 'Loaded Packages'
  },
  scannedPackagesbtn: {
    id: 'app.containers.Header.scannedPackagesbtn',
    defaultMessage: 'Scanned Packages'
  },
  storage: {
    id: 'app.components.SideMenu.storage',
    defaultMessage: 'Storage'
  },
  beforeStorage: {
    id: 'app.components.SideMenu.beforeStorage',
    defaultMessage: 'Before Storage'
  },
  smarty: {
    id: 'app.components.SideMenu.smarty',
    defaultMessage: 'Smarty'
  },
  insulation: {
    id: 'app.components.SideMenu.insulation',
    defaultMessage: 'Insulation'
  },
  infeeds: {
    id: 'app.components.SideMenu.infeeds',
    defaultMessage: 'Infeeds'
  },
  infeed1: {
    id: 'app.components.SideMenu.infeed1',
    defaultMessage: 'Infeed 1'
  },
  infeed2: {
    id: 'app.components.SideMenu.infeed2',
    defaultMessage: 'Infeed 2'
  },
  extralamellastorage: {
    id: 'app.components.SideMenu.extralamellastorage',
    defaultMessage: 'Xtra Lam Storage'
  },
  lift: {
    id: 'app.components.SideMenu.lift',
    defaultMessage: 'Lift'
  },
  products: {
    id: 'app.components.SideMenu.products',
    defaultMessage: 'Products'
  },
  suppliers: {
    id: 'app.components.SideMenu.suppliers',
    defaultMessage: 'Suppliers'
  },
  afterZPressStacks: {
    id: 'app.components.SideMenu.afterZPressStacks',
    defaultMessage: 'After ZPress stacks'
  },
  platesStorage: {
    id: 'app.components.SideMenu.platesStorage',
    defaultMessage: 'Plates Storage'
  },
  indicatorBackend: {
    id: 'app.components.SideMenu.indicatorBackend',
    defaultMessage: 'Backend'
  },
  indicatorControl: {
    id: 'app.components.SideMenu.indicatorControl',
    defaultMessage: 'Control'
  },
  indicatorZebra: {
    id: 'app.components.SideMenu.indicatorZebra',
    defaultMessage: 'Zebra'
  },
  indicatorPlc0: {
    id: 'app.components.SideMenu.indicatorPlc0',
    defaultMessage: 'Infeed PLC'
  },
  indicatorPlc1: {
    id: 'app.components.SideMenu.indicatorPlc1',
    defaultMessage: 'Zinc PLC'
  },
  indicatorPlc2: {
    id: 'app.components.SideMenu.indicatorPlc2',
    defaultMessage: 'Multiplan PLC'
  },
  indicatorPlc3: {
    id: 'app.components.SideMenu.indicatorPlc3',
    defaultMessage: 'XCut PLC'
  },
  indicatorPlc4: {
    id: 'app.components.SideMenu.indicatorPlc4',
    defaultMessage: 'Press PLC'
  },
  indicatorPlc5: {
    id: 'app.components.SideMenu.indicatorPlc5',
    defaultMessage: 'Europlan/EXIT PLC'
  },
  eingangPCData: {
    id: 'app.components.SideMenu.eingangPCData',
    defaultMessage: 'Infeed PC data'
  },
  epMitPCData: {
    id: 'app.components.SideMenu.epMitPCData',
    defaultMessage: 'Planer PC data'
  },
  zincPCData: {
    id: 'app.components.SideMenu.zincPCData',
    defaultMessage: 'Zinc PC data'
  },
  infeed: {
    id: 'app.components.SideMenu.infeed',
    defaultMessage: 'Infeed'
  },
  infeedAnte: {
    id: 'app.components.SideMenu.infeedAnte',
    defaultMessage: 'Infeed'
  },
  periodicTask: {
    id: 'app.components.SideMenu.periodicTask',
    defaultMessage: 'Periodic Task'
  },
  oneTimeTask: {
    id: 'app.components.SideMenu.oneTimeTask',
    defaultMessage: 'One Time Task'
  },
  cltinfeed: {
    id: 'app.components.SideMenu.cltinfeed',
    defaultMessage: 'CLT Infeed'
  },
  maxipress: {
    id: 'app.components.SideMenu.maxipress',
    defaultMessage: 'Maxipress'
  },
  multiplanPCData: {
    id: 'app.components.SideMenu.multiplanPCData',
    defaultMessage: 'MPlan PC data'
  },
  xcutPCData: {
    id: 'app.components.SideMenu.xcutPCData',
    defaultMessage: 'XCut PC data'
  },
  xcutsPCData: {
    id: 'app.components.SideMenu.xcutsPCData',
    defaultMessage: 'XCuts'
  },
  xcut1PCData: {
    id: 'app.components.SideMenu.xcutsPCData',
    defaultMessage: 'XCut 1 PC data'
  },
  xcut2PCData: {
    id: 'app.components.SideMenu.xcutsPCData',
    defaultMessage: 'XCut 2 PC data'
  },
  xcut3PCData: {
    id: 'app.components.SideMenu.xcutsPCData',
    defaultMessage: 'XCut 3 PC data'
  },
  pressPCData: {
    id: 'app.components.SideMenu.pressPCData',
    defaultMessage: 'Press PC data'
  },
  vnc: {
    id: 'app.components.SideMenu.vnc',
    defaultMessage: 'PLC panel'
  },
  vncAndCamera: {
    id: 'app.components.SideMenu.vncAndCamera',
    defaultMessage: 'PLC & Camera'
  },
  camera: {
    id: 'app.components.SideMenu.camera',
    defaultMessage: 'Camera'
  },
  statistics: {
    id: 'app.components.SideMenu.statistics',
    defaultMessage: 'Statistics'
  },
  statisticsSchneider: {
    id: 'app.components.SideMenu.statisticsSchneider',
    defaultMessage: 'Aus. Leimbuch'
  },
  brookhuis: {
    id: 'app.components.SideMenu.brookhuis',
    defaultMessage: 'Brookhuis'
  },
  gluebook: {
    id: 'app.components.SideMenu.gluebook',
    defaultMessage: 'Gluebook'
  },
  dailyStatus: {
    id: 'app.components.SideMenu.dailyStatus',
    defaultMessage: 'Daily Status'
  },
  glueAssign: {
    id: 'app.components.SideMenu.glueAssign',
    defaultMessage: 'Glue Assign'
  },
  projects: {
    id: 'app.components.SideMenu.projects',
    defaultMessage: 'Projects'
  },
  users: {
    id: 'app.components.SideMenu.users',
    defaultMessage: 'Users'
  },
  videos: {
    id: 'app.components.SideMenu.videos',
    defaultMessage: 'Video Player'
  },
  videotutorials: {
    id: 'app.components.SideMenu.videotutorials',
    defaultMessage: 'Video Tutorials'
  },
  dailyStats: {
    id: 'app.components.SideMenu.dailyStats',
    defaultMessage: 'Daily Stats'
  },
  gradeStatistics: {
    id: 'app.components.SideMenu.gradeStatistics',
    defaultMessage: 'Grade Statistics'
  },
  moisturestats: {
    id: 'app.components.SideMenu.moisturestats',
    defaultMessage: 'Moisture stats'
  },
  permissionsview: {
    id: 'app.components.SideMenu.permissionsview',
    defaultMessage: 'Permissions'
  },
  moveToTodo: {
    id: 'app.containers.Tableview.moveToTodo',
    defaultMessage: 'Move to TODO'
  },
  optimize: {
    id: 'app.containers.Tableview.optimize',
    defaultMessage: 'Optimize'
  },
  removeAllOptimized: {
    id: 'app.containers.Tableview.removeAllOptimized',
    defaultMessage: 'Remove All Optimized'
  },
  samePackageIdTodo: {
    id: 'app.containers.Tableview.samePackageIdTodo',
    defaultMessage: 'Same Package TODO'
  },
  produceSamePackageId: {
    id: 'app.containers.Tableview.produceSamePackageId',
    defaultMessage: 'Produce Same Package'
  },
  moveToProduction: {
    id: 'app.containers.Tableview.moveToProduction',
    defaultMessage: 'Move to Production'
  },
  createCLTPackages: {
    id: 'app.containers.Tableview.createCLTPackages',
    defaultMessage: 'Create CLT Packages'
  },
  recalculate: {
    id: 'app.containers.Tableview.recalculate',
    defaultMessage: 'Recalculate'
  },
  resetCLTPackages: {
    id: 'app.containers.Tableview.resetCLTPackages',
    defaultMessage: 'Reset CLT Packages'
  },
  moveToDone: {
    id: 'app.containers.Tableview.moveToDone',
    defaultMessage: 'Move to Done'
  },
  moveOrderToNextCheckpoint: {
    id: 'app.containers.Tableview.moveOrderToNextCheckpoint',
    defaultMessage: 'Move to Next Step'
  },
  donePressing: {
    id: 'app.containers.Tableview.donePressing',
    defaultMessage: 'Done Pressing'
  },
  offPress: {
    id: 'app.containers.Tableview.offPress',
    defaultMessage: 'Off Press'
  },
  setDonePressing: {
    id: 'app.containers.Tableview.setDonePressing',
    defaultMessage: 'Change Status to Done Pressing'
  },
  setOffPress: {
    id: 'app.containers.Tableview.setOffPress',
    defaultMessage: 'Change Status to Off Press'
  },
  changeExtraStatus: {
    id: 'app.containers.Tableview.changeExtraStatus',
    defaultMessage: 'Change Extra Status'
  },
  addCadworkOrder: {
    id: 'app.containers.Tableview.addCadworkOrder',
    defaultMessage: 'Add cadwork order'
  },
  moveToReady: {
    id: 'app.containers.Tableview.moveToReady',
    defaultMessage: 'Move to ready'
  },
  restartSimulation: {
    id: 'app.containers.Tableview.restartSimulation',
    defaultMessage: 'Restart Simulation'
  },
  moveToDoneSchneider: {
    id: 'app.containers.Tableview.moveToDoneSchneider',
    defaultMessage: 'Move to Done'
  },
  1: {
    id: 'app.containers.Tableview.1',
    defaultMessage: '1'
  },
  2: {
    id: 'app.containers.Tableview.2',
    defaultMessage: '2'
  },
  3: {
    id: 'app.containers.Tableview.3',
    defaultMessage: '3'
  },
  4: {
    id: 'app.containers.Tableview.4',
    defaultMessage: '4'
  },
  5: {
    id: 'app.containers.Tableview.5',
    defaultMessage: '5'
  },
  6: {
    id: 'app.containers.Tableview.6',
    defaultMessage: '6'
  },
  moveToReadySchneider: {
    id: 'app.containers.Tableview.moveToReadySchneider',
    defaultMessage: 'Move to Ready'
  },
  fileUpload: {
    id: 'app.containers.Tableview.fileUpload',
    defaultMessage: 'file upload'
  },
  moveToProductionNew: {
    id: 'app.containers.Tableview.moveToProductionNew',
    defaultMessage: 'Move Order to Production test'
  },
  deleteOrderFromQueue: {
    id: 'app.containers.Tableview.deleteOrderFromQueue',
    defaultMessage: 'Remove Order from Production'
  },
  deleteOrder: {
    id: 'app.containers.Tableview.deleteOrder',
    defaultMessage: 'Delete Order'
  },
  deleteSortedOrder: {
    id: 'app.containers.Tableview.deleteSortedOrder',
    defaultMessage: 'Delete Order'
  },
  purgeOrder: {
    id: 'app.containers.Tableview.purgeOrder',
    defaultMessage: 'Delete Order Permanently'
  },
  deleteLayer: {
    id: 'app.containers.Tableview.deleteLayer',
    defaultMessage: 'Delete Layer'
  },
  deleteRepair: {
    id: 'app.containers.Tableview.deleteRepair',
    defaultMessage: 'Delete Repair'
  },
  moveOrderToDone: {
    id: 'app.containers.Tableview.moveOrderToDone',
    defaultMessage: 'Move to Done'
  },
  moveOrderToDoneSchneider: {
    id: 'app.containers.Tableview.moveOrderToDoneSchneider',
    defaultMessage: 'Move to Done'
  },
  deleteProject: {
    id: 'app.containers.Tableview.deleteProject',
    defaultMessage: 'Delete Project'
  },
  addExtraLamelEntry: {
    id: 'app.containers.Tableview.addExtraLamelEntry',
    defaultMessage: 'Add Entry'
  },
  addRecipe: {
    id: 'app.containers.Tableview.addRecipe',
    defaultMessage: 'Add new Recipe'
  },
  addIncomingPackage: {
    id: 'app.containers.Tableview.addIncomingPackage',
    defaultMessage: 'Add new Package'
  },
  addUser: {
    id: 'app.containers.Tableview.addUser',
    defaultMessage: 'Add new User'
  },
  addRecipeLayer: {
    id: 'app.containers.Tableview.addRecipeLayer',
    defaultMessage: 'Add new Recipe Layer'
  },
  forceMachineSetting: {
    id: 'app.containers.Tableview.forceMachineSetting',
    defaultMessage: 'Force setting to PLC'
  },
  deleteMachineSetting: {
    id: 'app.containers.Tableview.deleteMachineSetting',
    defaultMessage: 'Delete machine setting'
  },
  deleteRecipe: {
    id: 'app.containers.Tableview.deleteRecipe',
    defaultMessage: 'Delete Recipe'
  },
  deleteIncomingPackage: {
    id: 'app.containers.Tableview.deleteIncomingPackage',
    defaultMessage: 'Delete Incoming Package'
  },
  stopTask: {
    id: 'app.containers.Tableview.stopTask',
    defaultMessage: 'Stop Task'
  },
  deleteExtraLamella: {
    id: 'app.containers.Tableview.deleteExtraLamella',
    defaultMessage: 'Delete Extra Lamella'
  },
  activateProject: {
    id: 'app.containers.Tableview.activateProject',
    defaultMessage: 'Activate project'
  },
  addedAtAscending: {
    id: 'app.containers.Tableview.addedAtAscending',
    defaultMessage: 'Ascending addedAt'
  },
  addedAtDescending: {
    id: 'app.containers.Tableview.addedAtDescending',
    defaultMessage: 'Descending addedAt'
  },
  IdDescending: {
    id: 'app.containers.Tableview.IdDescending',
    defaultMessage: 'Ascending ID'
  },
  IdAscending: {
    id: 'app.containers.Tableview.IdAscending',
    defaultMessage: 'Descending ID'
  },
  ordering: {
    id: 'app.containers.Tableview.ordering',
    defaultMessage: 'Ordering'
  },
  exact: {
    id: 'app.containers.Tableview.exact',
    defaultMessage: 'Exact'
  },
  range: {
    id: 'app.containers.Tableview.range',
    defaultMessage: 'Range'
  },
  downloadItem: {
    id: 'app.containers.Tableview.downloadItem',
    defaultMessage: 'Download Item'
  },
  makeTodoCopy: {
    id: 'app.containers.Tableview.makeTodoCopy',
    defaultMessage: 'Duplicate to TODO'
  },
  approvedForPlaningTitle: {
    id: 'app.containers.Tableview.approvedForPlaningTitle',
    defaultMessage: 'Approve planing'
  },
  approvedForPlaningBody: {
    id: 'app.containers.Tableview.approvedForPlaningBody',
    defaultMessage: 'Approve order for planing?'
  },
  panelTooWide: {
    id: 'app.containers.ModelFieldErrors.panelTooWide',
    defaultMessage: 'Panel too wide'
  },
  panelTooNarrow: {
    id: 'app.containers.ModelFieldErrors.panelTooNarrow',
    defaultMessage: 'Panel too narrow'
  },
  panelTooLong: {
    id: 'app.containers.ModelFieldErrors.panelTooLong',
    defaultMessage: 'Panel too long'
  },
  panelTooShort: {
    id: 'app.containers.ModelFieldErrors.panelTooShort',
    defaultMessage: 'Panel too short'
  },
  rawMaterialTooWide: {
    id: 'app.containers.ModelFieldErrors.rawMaterialTooWide',
    defaultMessage: 'Raw material too wide'
  },
  insulationWidthError: {
    id: 'app.containers.ModelFieldErrors.insulationWidthError',
    defaultMessage: 'Insulation Width Error'
  },
  rawMaterialTooNarrow: {
    id: 'app.containers.ModelFieldErrors.rawMaterialTooNarrow',
    defaultMessage: 'Raw material too narrow'
  },
  planedMaterialTooWide: {
    id: 'app.containers.ModelFieldErrors.planedMaterialTooWide',
    defaultMessage: 'Planed material too wide'
  },
  planedMaterialTooNarrow: {
    id: 'app.containers.ModelFieldErrors.planedMaterialTooNarrow',
    defaultMessage: 'Planed material too narrow'
  },
  lamellaTooWide: {
    id: 'app.containers.ModelFieldErrors.lamellaTooWide',
    defaultMessage: 'Lamella too wide'
  },
  lamellaTooNarrow: {
    id: 'app.containers.ModelFieldErrors.lamellaTooNarrow',
    defaultMessage: 'Lamella too narrow'
  },
  lamellaTooThick: {
    id: 'app.containers.ModelFieldErrors.lamellaTooThick',
    defaultMessage: 'Lamella height too thick'
  },
  lamellaTooLow: {
    id: 'app.containers.ModelFieldErrors.lamellaTooLow',
    defaultMessage: 'Lamella height too low'
  },
  lamellaTooLong: {
    id: 'app.containers.ModelFieldErrors.lamellaTooLong',
    defaultMessage: 'Lamella too long'
  },
  lamellaTooShort: {
    id: 'app.containers.ModelFieldErrors.lamellaTooShort',
    defaultMessage: 'Lamella too short'
  },
  notBlank: {
    id: 'app.containers.ModelFieldErrors.notBlank',
    defaultMessage: 'cannot be blank'
  },
  mustNumber: {
    id: 'app.containers.ModelFieldErrors.mustNumber',
    defaultMessage: 'must be a number'
  },
  aboveZero: {
    id: 'app.containers.ModelFieldErrors.aboveZero',
    defaultMessage: 'must be above zero'
  },
  LELETEST: {
    id: 'app.containers.ModelFieldErrors.LELETEST',
    defaultMessage: 'LELE TEST'
  },
  addFilter: {
    id: 'app.components.TableBottomFilter.addFilter',
    defaultMessage: 'Add filter'
  },
  results: {
    id: 'app.components.TableBottomFilter.results',
    defaultMessage: 'Results'
  },
  manualModeSwitch: {
    id: 'app.components.MenuSwitch.manualModeSwitch',
    defaultMessage: 'Manual Mode Settings'
  },
  manualSwitch: {
    id: 'app.components.MenuSwitch.manualSwitch',
    defaultMessage: 'Manual on/off'
  },
  loadedPackagesbtn: {
    id: 'app.containers.Header.loadedPackagesbtn',
    defaultMessage: 'Loaded Packages'
  },
  incomingPackagesbtn: {
    id: 'app.containers.Header.incomingPackagesbtn',
    defaultMessage: 'Incoming Packages'
  },
  createdPackagesbtn: {
    id: 'app.containers.Header.createdPackagesbtn',
    defaultMessage: 'Created Packages'
  },
  stackedPackagesbtn: {
    id: 'app.containers.Header.stackedPackagesbtn',
    defaultMessage: 'Stacked Packages'
  },
  numStackLamellas: {
    id: 'app.containers.Header.numStackLamellas',
    defaultMessage: 'Stacked lamellas number'
  },
  materialNeededbtn: {
    id: 'app.containers.Header.materialNeededbtn',
    defaultMessage: 'Material Needed'
  },
  ordersqueuebtn: {
    id: 'app.containers.Header.ordersqueuebtn',
    defaultMessage: 'Orders Queue'
  },
  errorlistbtn: {
    id: 'app.containers.Header.errorlistbtn',
    defaultMessage: 'Error List'
  },
  fjordersqueuebtn: {
    id: 'app.containers.Header.fjordersqueuebtn',
    defaultMessage: 'FJ Order Queue'
  },
  mostOrdersQueue: {
    id: 'app.containers.Header.mostOrdersQueue',
    defaultMessage: 'Most Order Queue'
  },
  exitData: {
    id: 'app.containers.Header.exitData',
    defaultMessage: 'Exit Data'
  },
  testCutHistory: {
    id: 'app.containers.Header.testCutHistory',
    defaultMessage: 'Test Cut History'
  },
  cltordersqueuebtn: {
    id: 'app.containers.Header.cltordersqueuebtn',
    defaultMessage: 'CLT Queue'
  },
  layersqueuebtn: {
    id: 'app.containers.Header.layersqueuebtn',
    defaultMessage: 'Layers Queue'
  },
  schneiderLayersqueuebtn: {
    id: 'app.containers.Header.schneiderLayersqueuebtn',
    defaultMessage: 'Layers'
  },
  cltlayersqueuebtn: {
    id: 'app.containers.Header.cltlayersqueuebtn',
    defaultMessage: 'CLT Layers Queue'
  },
  errorslistbtn: {
    id: 'app.containers.Header.errorslistbtn',
    defaultMessage: 'Errors'
  },
  problemsolutionbtn: {
    id: 'app.containers.Header.problemsolutionbtn',
    defaultMessage: 'Problem helper'
  },
  sortingqueue: {
    id: 'app.containers.Header.sortingqueue',
    defaultMessage: 'Sorting pckg'
  },
  archiveMode: {
    id: 'app.containers.Header.archiveMode',
    defaultMessage: 'Archive Mode'
  },
  archiveGrayscale: {
    id: 'app.containers.Header.archiveGrayscale',
    defaultMessage: 'Grayscale archive'
  },
  debugMode: {
    id: 'app.containers.Header.debugMode',
    defaultMessage: 'Debug Mode'
  },
  editorMode: {
    id: 'app.containers.Header.editorMode',
    defaultMessage: 'Editor Mode'
  },
  en: {
    id: 'app.language.en',
    defaultMessage: 'En'
  },
  de: {
    id: 'app.language.de',
    defaultMessage: 'De'
  },
  se: {
    id: 'app.language.se',
    defaultMessage: 'Se'
  },
  fi: {
    id: 'app.language.fi',
    defaultMessage: 'Fi'
  },
  es: {
    id: 'app.language.es',
    defaultMessage: 'Es'
  },
  et: {
    id: 'app.language.et',
    defaultMessage: 'Et'
  },
  he: {
    id: 'app.language.he',
    defaultMessage: 'He'
  },
  pt: {
    id: 'app.language.pt',
    defaultMessage: 'Pt'
  },
  sl: {
    id: 'app.language.sl',
    defaultMessage: 'Sl'
  },
  fr: {
    id: 'app.language.fr',
    defaultMessage: 'Fr'
  },
  cltpackages: {
    id: 'app.language.cltpackages',
    defaultMessage: 'CLT Packages'
  },
  mostPackages: {
    id: 'app.language.mostPackages',
    defaultMessage: 'Most Orders'
  },
  files: {
    id: 'app.files',
    defaultMessage: 'Files'
  },
  axxosData: {
    id: 'app.axxosData',
    defaultMessage: 'Axxos Data'
  },
  parseProject: {
    id: 'app.arborealParseProject',
    defaultMessage: 'Parse project'
  },
  parseProjectTest: {
    id: 'app.arborealparseProjectTest',
    defaultMessage: 'Parse project Test'
  },
  createProjectFromFile: {
    id: 'app.arborealcreateProjectFromFile',
    defaultMessage: 'Create Project From File'
  },
  importOrderValues: {
    id: 'app.importOrderValues',
    defaultMessage: 'Extract Order Values'
  },
  addCLTPackage: {
    id: 'app.addCLTPackage',
    defaultMessage: 'Add CLT package'
  },
  formed: {
    id: 'app.formed',
    defaultMessage: 'Formed'
  },
  cltPackaged: {
    id: 'app.cltPackaged',
    defaultMessage: 'CLT Packaged'
  },
  parsePackage: {
    id: 'app.parsePackage',
    defaultMessage: 'Parse package data'
  },
  reload: {
    id: 'app.reload',
    defaultMessage: 'Reload'
  },
  logout: {
    id: 'app.logout',
    defaultMessage: 'Logout'
  },
  privilege: {
    id: 'app.privilege',
    defaultMessage: 'Privilege'
  },
  profile: {
    id: 'app.profile',
    defaultMessage: 'Profile'
  },
  account: {
    id: 'app.account',
    defaultMessage: 'Account'
  },
  machinesettings: {
    id: 'app.machinesettings',
    defaultMessage: 'Machine settings'
  },
  lineRecipes: {
    id: 'app.lineRecipes',
    defaultMessage: 'Line Recipes'
  },
  addMachineSetting: {
    id: 'app.addMachineSetting',
    defaultMessage: 'Add machine setting'
  },
  extractAllValues: {
    id: 'app.extractAllValues',
    defaultMessage: 'Extract all values'
  },
  uploadAllValues: {
    id: 'app.uploadAllValues',
    defaultMessage: 'Upload all values'
  },
  importMachineSettingNames: {
    id: 'app.importMachineSettingNames',
    defaultMessage: 'Import names'
  },
  automaticValueImport: {
    id: 'app.automaticValueImport',
    defaultMessage: 'Automatic value import'
  },
  addArborealRawMaterialMap: {
    id: 'app.addArborealRawMaterialMap',
    defaultMessage: 'Add Arboreal Raw Material Map'
  },
  addQuality: {
    id: 'app.addQuality',
    defaultMessage: 'Add Arboreal Raw Material Map'
  },
  addWoodTypeAnte: {
    id: 'app.addWoodTypeAnte',
    defaultMessage: 'Add Wood Type/Primer Setting'
  },
  materialStatus: {
    id: 'app.materialStatus',
    defaultMessage: 'Material status'
  },
  scannedPackageQueue: {
    id: 'app.scannedPackageQueue',
    defaultMessage: 'Scanned package'
  },
  restartScanner: {
    id: 'app.restartScanner',
    defaultMessage: 'Restart Scanner'
  },
  currentlyUsing: {
    id: 'app.currentlyUsing',
    defaultMessage: 'Currently used package'
  },
  packageBeforeXCut: {
    id: 'app.packageBeforeXCut',
    defaultMessage: 'Package before XCut'
  },
  infeedHolder: {
    id: 'app.infeedHolder',
    defaultMessage: 'Infeed Holder'
  },
  CutListDetail: {
    id: 'app.CutListDetail',
    defaultMessage: 'CutList Detail'
  },
  goodWood: {
    id: 'app.goodWood',
    defaultMessage: 'Good Wood'
  },
  badWood: {
    id: 'app.badWood',
    defaultMessage: 'Bad Wood'
  },
  infeedRolls: {
    id: 'app.infeedRolls',
    defaultMessage: 'Infeed rolls'
  },
  moveToLoaded: {
    id: 'app.moveToLoaded',
    defaultMessage: 'Move to loaded'
  },
  createPackageLabel: {
    id: 'app.createPackage',
    defaultMessage: 'Create package label'
  },
  all: {
    id: 'app.all',
    defaultMessage: 'All'
  },
  sendPanelToPLCTitle: {
    id: 'app.sendPanelToPLCTitle',
    defaultMessage: 'Send order data to PLC'
  },
  sendPanelToPLCBody: {
    id: 'app.sendPanelToPLCBody',
    defaultMessage: 'As title suggests'
  },
  scannedPackage: {
    id: 'app.scannedPackage',
    defaultMessage: 'Scanned package'
  },
  arborealID: {
    id: 'app.arborealID',
    defaultMessage: 'Arboreal ID'
  },
  vacuumPackages: {
    id: 'app.vacuumPackages',
    defaultMessage: 'Packages under vacuum'
  },
  packageForklift: {
    id: 'app.packageForklift',
    defaultMessage: 'Package forklift'
  },
  exitPackage: {
    id: 'app.exitPackage',
    defaultMessage: 'Exit package'
  },
  material: {
    id: 'app.material',
    defaultMessage: 'Mat.'
  },
  article: {
    id: 'app.article',
    defaultMessage: 'Article'
  },
  submit: {
    id: 'app.submit',
    defaultMessage: 'Submit'
  },
  terminal: {
    id: 'containers.Tableview.terminal',
    defaultMessage: 'Terminals'
  },
  plcComm: {
    id: 'containers.Tableview.plcComm',
    defaultMessage: 'Plc Comm'
  },
  services: {
    id: 'containers.Tableview.services',
    defaultMessage: 'Services'
  },
  kava: {
    id: 'app.components.SideMenu.kava',
    defaultMessage: 'Kava'
  },
  lastPackageId: {
    id: 'app.lastPackageId',
    defaultMessage: 'Last package id'
  },
  rauteREADY: {
    id: 'app.rauteREADY',
    defaultMessage: 'raute READY/Wood allowance'
  },
  rauteConnected: {
    id: 'app.rauteConnected',
    defaultMessage: 'raute SOCKET'
  },
  rauteWoodAllowance: {
    id: 'app.rauteWoodAllowance',
    defaultMessage: 'raute Wood Allowance'
  },
  lastRauteId: {
    id: 'app.lastRauteId',
    defaultMessage: 'ID before RAUTE'
  },
  lastAfterRauteId: {
    id: 'app.lastAfterRauteId',
    defaultMessage: 'ID after RAUTE'
  },
  canChangeDimensions: {
    id: 'app.canChangeDimensions',
    defaultMessage: 'Can skip dim.'
  },
  addToProject: {
    id: 'app.addToProject',
    defaultMessage: 'Add to project'
  },
  unlockFJGroups: {
    id: 'app.components.RawInfeedLoadingBox.assignToFJ',
    defaultMessage: 'Unlock FJ assignments'
  },
  sendToProduction: {
    id: 'app.containers.Tableview.sendToProduction',
    defaultMessage: 'Send to Production'
  },
  resendData: {
    id: 'app.containers.Tableview.resendData',
    defaultMessage: 'Resend data'
  },
  confirmDimensionChange: {
    id: 'app.containers.Tableview.confirmDimensionChange',
    defaultMessage: 'Confirm dimension change'
  },
  clearZpressOrder: {
    id: 'app.containers.Tableview.clearZpressOrder',
    defaultMessage: 'clearZpressOrder'
  },
  waitUntilFull: {
    id: 'app.containers.Tableview.waitUntilFull',
    defaultMessage: 'Wait full'
  },
  emptyExtraLayers: {
    id: 'app.containers.Tableview.emptyExtraLayers',
    defaultMessage: 'Empty extra'
  },
  finishedPackages: {
    id: 'app.containers.Tableview.finishedPackages',
    defaultMessage: 'Finished packages'
  },
  filling_mode: {
    id: 'app.containers.Tableview.filling_mode',
    defaultMessage: 'Fill'
  },
  emptying_mode: {
    id: 'app.containers.Tableview.filling_mode',
    defaultMessage: 'Emptying'
  },
  whiteGlueEnabled: {
    id: 'app.containers.Tableview.whiteGlueEnabled',
    defaultMessage: 'White glue enabled for all layers'
  },
  whiteGlue: {
    id: 'app.containers.Tableview.whiteGlue',
    defaultMessage: 'White glue'
  },
  noLayersToEmpty: {
    id: 'app.globalMessages.noLayersToEmpty',
    defaultMessage: 'No layers to empty'
  },
  readyToEmpty: {
    id: 'app.globalMessages.readyToEmpty',
    defaultMessage: 'Ready'
  },
  neededBefore: {
    id: 'app.globalMessages.neededBefore',
    defaultMessage: 'Needed before'
  },
  currentlyEmptying: {
    id: 'app.globalMessages.currentlyEmptying',
    defaultMessage: 'Currently emptying'
  },
  clearOutput: {
    id: 'app.globalMessages.clearOutput',
    defaultMessage: 'Clear output'
  },
  combineOrders: {
    id: 'app.globalMessages.combineOrders',
    defaultMessage: 'Combine orders'
  },
  breakOrders: {
    id: 'app.globalMessages.breakOrders',
    defaultMessage: 'Break orders'
  },
  missingPlateReq: {
    id: 'app.globalMessages.missingPlateReq',
    defaultMessage: 'Missing plate request'
  },
  machineDataOK: {
    id: 'app.globalMessages.machineDataOK',
    defaultMessage: 'Machine Data OK'
  },
  sendingFromPlaner: {
    id: 'app.globalMessages.sendingFromPlaner',
    defaultMessage: 'Sending from planer'
  },
  W1Takeaway: {
    id: 'app.globalMessages.W1Takeaway',
    defaultMessage: 'W1 Takeaway'
  },
  W3Takeaway: {
    id: 'app.globalMessages.W3Takeaway',
    defaultMessage: 'W3 Takeaway'
  },
  posWhiteGlue: {
    id: 'app.globalMessages.posWhiteGlue',
    defaultMessage: 'Position white glue'
  },
  posHotmelt: {
    id: 'app.globalMessages.posHotmelt',
    defaultMessage: 'Position hotmelt'
  },
  hotmelt: {
    id: 'app.globalMessages.hotmelt',
    defaultMessage: 'Hotmelt'
  },
  zinkGlue: {
    id: 'app.globalMessages.zinkGlue',
    defaultMessage: 'Zink Glue'
  },
  zinkGlueAnte: {
    id: 'app.globalMessages.zinkGlueAnte',
    defaultMessage: 'Zink Glue'
  },
  zinkHardener: {
    id: 'app.globalMessages.zinkHardener',
    defaultMessage: 'Zink Hardener'
  },
  zinkHardenerAnte: {
    id: 'app.globalMessages.zinkHardenerAnte',
    defaultMessage: 'Zink Hardener'
  },
  qSawOffset: {
    id: 'app.globalMessages.qSawOffset',
    defaultMessage: 'Q Saw Offset'
  },
  lSawOffset: {
    id: 'app.globalMessages.lSawOffset',
    defaultMessage: 'L Saw Offset'
  },
  staticThicknessTakeaway: {
    id: 'app.globalMessages.staticThicknessTakeaway',
    defaultMessage: 'Static Thickness Takeaway'
  },
  lamellaGlueThickness: {
    id: 'app.globalMessages.lamellaGlueThickness',
    defaultMessage: 'Lamella Glue Thickness'
  },
  addedWidthFromShortToLong: {
    id: 'app.globalMessages.addedWidthFromShortToLong',
    defaultMessage: 'Added width Short -> Long'
  },
  addedWidthFromLongToShort: {
    id: 'app.globalMessages.addedWidthFromLongToShort',
    defaultMessage: 'Added width Long -> Short'
  },
  addedWidthEndOfGroup: {
    id: 'app.globalMessages.addedWidthEndOfGroup',
    defaultMessage: 'Added width End of Group'
  },
  lamellasUntilEndErrorThreshold: {
    id: 'app.globalMessages.lamellasUntilEndErrorThreshold',
    defaultMessage: 'Lamellas Until End Error Threshold'
  },
  minimumLamellasPerGroup: {
    id: 'app.globalMessages.minimumLamellasPerGroup',
    defaultMessage: 'Min. Lamellas Per Group'
  },
  minMergeAmount: {
    id: 'app.globalMessages.minMergeAmount',
    defaultMessage: 'Min. Merge Amount'
  },
  maxPackageOrders: {
    id: 'app.globalMessages.maxPackageOrders',
    defaultMessage: 'Max. Package Orders'
  },
  estimatedMaterialMultiplier: {
    id: 'app.globalMessages.estimatedMaterialMultiplier',
    defaultMessage: 'Estimated Material Multiplier'
  },
  pressGlue: {
    id: 'app.globalMessages.pressGlue',
    defaultMessage: 'Press Glue'
  },
  pressGlueAnte: {
    id: 'app.globalMessages.pressGlueAnte',
    defaultMessage: 'Press Glue'
  },
  printWithPlanerPrinter: {
    id: 'app.globalMessages.printWithPlanerPrinter',
    defaultMessage: 'Print With Planer Printer'
  },
  printWithOfficePrinter: {
    id: 'app.globalMessages.printWithOfficePrinter',
    defaultMessage: 'Print With Office Printer'
  },
  disableMixer: {
    id: 'app.globalMessages.disableMixer',
    defaultMessage: 'Disable Mixer'
  },
  emptyingSingleLayersAllowed: {
    id: 'app.globalMessages.emptyingSingleLayersAllowed',
    defaultMessage: 'Emptying Single Layers Allowed'
  },
  autoLamellaCorrection: {
    id: 'app.globalMessages.autoLamellaCorrection',
    defaultMessage: 'Auto Lamella Correction'
  },
  joinJds: {
    id: 'app.globalMessages.joinJds',
    defaultMessage: 'Join Layers Together'
  },
  calculateMaxNumberOfGrouporders: {
    id: 'app.globalMessages.calculateMaxNumberOfGrouporders',
    defaultMessage: 'Calc MaxNum Of Group Orders'
  },
  sortByPlannedWidthAscending: {
    id: 'app.globalMessages.sortByPlannedWidthAscending',
    defaultMessage: 'Sort By Planed Width Ascending'
  },
  maxOrdersToJoin: {
    id: 'app.globalMessages.maxOrdersToJoin',
    defaultMessage: 'Max Orders To Join'
  },
  orderIsDoneAfterThisPosition: {
    id: 'app.globalMessages.orderIsDoneAfterThisPosition',
    defaultMessage: 'Order Is Done After This Position'
  },
  limitBodenlagerPosition: {
    id: 'app.globalMessages.limitBodenlagerPosition',
    defaultMessage: 'Limit Stacking Position'
  },
  maxPanelReduction: {
    id: 'app.globalMessages.maxPanelReduction',
    defaultMessage: 'Max Panel Reduction'
  },
  maxPanelIncrease: {
    id: 'app.globalMessages.maxPanelIncrease',
    defaultMessage: 'Max Panel Increase'
  },
  resizePanelsWhenParsing: {
    id: 'app.globalMessages.resizePanelsWhenParsing',
    defaultMessage: 'Resize Panels When Parsing'
  },
  shorterLamellas: {
    id: 'app.globalMessages.shorterLamellas',
    defaultMessage: 'Allow Shorter Lamellas'
  },
  ejectWasteLamellas: {
    id: 'app.globalMessages.ejectWasteLamellas',
    defaultMessage: 'Eject Waste Lamellas After Microtec'
  },
  isoPackageCombine: {
    id: 'app.globalMessages.isoPackageCombine',
    defaultMessage: 'Iso Package Combine'
  },
  crossPackageCombine: {
    id: 'app.globalMessages.crossPackageCombine',
    defaultMessage: 'Cross Package Combine'
  },
  usePlanerSettings: {
    id: 'app.globalMessages.usePlanerSettings',
    defaultMessage: 'Use Planer Setup'
  },
  sendBatchData: {
    id: 'app.globalMessages.sendBatchData',
    defaultMessage: 'Send Batch Data to Microtec'
  },
  clearPlanerSettings: {
    id: 'app.globalMessages.usePlanerSettings',
    defaultMessage: 'Clear Planer Setup'
  },
  allowMergingOfIDs: {
    id: 'app.globalMessages.allowMegingOfIDs',
    defaultMessage: 'Allow ID Merging'
  },
  checkOrderDone: {
    id: 'app.globalMessages.checkOrderDone',
    defaultMessage: 'Check Order Done'
  },
  zPress1Settings: {
    id: 'app.globalMessages.zPress1Settings',
    defaultMessage: 'ZPress 1 Settings'
  },
  zPress2Settings: {
    id: 'app.globalMessages.zPress2Settings',
    defaultMessage: 'ZPress 2 Settings'
  },
  unipressSettings: {
    id: 'app.globalMessages.unipressSettings',
    defaultMessage: 'Unipress Settings'
  },
  zinc1Settings: {
    id: 'app.globalMessages.zinc1Settings',
    defaultMessage: 'Zink 1 Settings'
  },
  zinc2Settings: {
    id: 'app.globalMessages.zinc2Settings',
    defaultMessage: 'Zink 2 Settings'
  },
  dailyStatsSettings: {
    id: 'app.globalMessages.dailyStatsSettings',
    defaultMessage: 'Daily stats'
  },
  generalSettings: {
    id: 'app.globalMessages.generalSettings',
    defaultMessage: 'General Settings'
  },
  linesOfWhiteGlue: {
    id: 'app.globalMessages.linesOfWhiteGlue',
    defaultMessage: 'Lines of white glue'
  },
  linesOfHotmelt: {
    id: 'app.globalMessages.linesOfHotmelt',
    defaultMessage: 'Lines of white hotmelt'
  },
  turningBeforePress: {
    id: 'app.globalMessages.turningBeforePress',
    defaultMessage: 'Turning before press'
  },
  turningEverySecond: {
    id: 'app.globalMessages.turningEverySecond',
    defaultMessage: 'Turning every second'
  },
  turningZinc: {
    id: 'app.globalMessages.turningZinc',
    defaultMessage: 'Turning FJ'
  },
  confirmFinishZPress: {
    id: 'app.globalMessages.confirmFinishZPress',
    defaultMessage: 'Confirm that id finished, missing'
  },
  waitingLineToEmptyToContinue: {
    id: 'app.globalMessages.waitingLineToEmptyToContinue',
    defaultMessage: 'Waiting for line to empty to reassign'
  },
  packagesSynced: {
    id: 'app.globalMessages.packagesSynced',
    defaultMessage: 'Packages synced with the machine'
  },
  syncOrders: {
    id: 'app.globalMessages.syncOrders',
    defaultMessage: 'Sync'
  },
  removeOrders: {
    id: 'app.globalMessages.removeOrders',
    defaultMessage: 'Remove Orders'
  },
  orderMatchesBeforePlaner: {
    id: 'app.globalMessages.orderMatchesBeforePlaner',
    defaultMessage: 'Order matches before planer'
  },
  orderMatchesAfterPlaner: {
    id: 'app.globalMessages.orderMatchesAfterPlaner',
    defaultMessage: 'Order matches after planer'
  },
  lineEmptyFromSuperplanToStacker: {
    id: 'app.globalMessages.lineEmptyFromSuperplanToStacker',
    defaultMessage: 'Empty from planer to stacker'
  },
  splVacuumAllowance: {
    id: 'app.globalMessages.splVacuumAllowance',
    defaultMessage: 'Vacuum allowance'
  },
  stacker2Allowance: {
    id: 'app.globalMessages.stacker2Allowance',
    defaultMessage: 'Stacker allowance 2'
  },
  stacker1Allowance: {
    id: 'app.globalMessages.stacker1Allowance',
    defaultMessage: 'Stacker allowance 1'
  },
  stackerAllowances: {
    id: 'app.globalMessages.stackerAllowances',
    defaultMessage: 'Stacker Allowances'
  },
  sortingLine1Full: {
    id: 'app.globalMessages.sortingLine1Full',
    defaultMessage: 'Sorting line 1 Full after stacker'
  },
  clearFIFO: {
    id: 'app.globalMessages.clearFIFO',
    defaultMessage: 'Clear FIFO'
  },
  clear: {
    id: 'app.globalMessages.clear',
    defaultMessage: 'clear'
  },
  waitingForLineToEmpty: {
    id: 'app.globalMessages.waitingForLineToEmpty',
    defaultMessage: 'Waiting for the line to empty'
  },
  goldenEyeCounter: {
    id: 'app.globalMessages.goldenEyeCounter',
    defaultMessage: 'Golden eye counter'
  },
  sortingOrder: {
    id: 'app.globalMessages.sortingOrder',
    defaultMessage: 'Sorting order'
  },
  erpIdSchilliger: {
    id: 'app.globalMessages.erpIdSchilliger',
    defaultMessage: 'Erp Id'
  },
  setNewSortingOrder: {
    id: 'app.globalMessages.setNewSortingOrder',
    defaultMessage: 'Set new Sorting order'
  },
  orderStatus: {
    id: 'app.globalMessages.orderStatus',
    defaultMessage: 'Order status'
  },
  orderDone: {
    id: 'app.globalMessages.orderDone',
    defaultMessage: 'Order done'
  },
  changeStatus: {
    id: 'app.globalMessages.orderDone',
    defaultMessage: 'Change Status'
  },
  change: {
    id: 'app.globalMessages.change',
    defaultMessage: '🔄️'
  },
  sortedInputs: {
    id: 'app.globalMessages.sortedInputs',
    defaultMessage: 'Article inputs'
  },
  sortedInput: {
    id: 'app.globalMessages.sortedInput',
    defaultMessage: 'Article input'
  },
  sortedOutputs: {
    id: 'app.globalMessages.sortedOutputs',
    defaultMessage: 'Article outputs'
  },
  sortedOutput: {
    id: 'app.globalMessages.sortedOutput',
    defaultMessage: 'Article output'
  },
  insights: {
    id: 'app.insights',
    defaultMessage: 'Insights'
  },
  matchAndAssignBySettings: {
    id: 'app.containers.tableView.matchAndAssignBySettings',
    defaultMessage: 'Assign by settings'
  },
  schneiderOrderRawMaterial: {
    id: 'app.containers.tableView.schneiderOrderRawMaterial',
    defaultMessage: 'Order raw material'
  },
  notFoundText: {
    id: 'app.containers.notFoundPage.notFoundText',
    defaultMessage: 'This page could not be found'
  },
  backHomeText: {
    id: 'app.containers.notFoundPage.backHomeText',
    defaultMessage: 'Back To Homepage'
  },
  crossOrderCanBeLoaded: {
    id: 'app.containers.notFoundPage.crossOrderCanBeLoaded',
    defaultMessage: 'Cross order can be loaded'
  },
  isoZincTitle: {
    id: 'app.containers.notFoundPage.isoZincTitle',
    defaultMessage: 'ISO Zinc'
  },
  hasInsulation: {
    id: 'app.containers.notFoundPage.hasInsulation',
    defaultMessage: 'has INS'
  },
  loadingISONext: {
    id: 'app.containers.notFoundPage.loadingISONext',
    defaultMessage: 'Loading ISO next'
  },
  loadingWoodNext: {
    id: 'app.containers.notFoundPage.loadingWoodNext',
    defaultMessage: 'Loading wood next'
  },
  stackedPackageInfo: {
    id: 'app.containers.notFoundPage.stackedPackageInfo',
    defaultMessage: 'Stacked package dimensions'
  },
  orderBeforePlaner: {
    id: 'app.containers.notFoundPage.orderBeforePlaner',
    defaultMessage: 'Order before planer'
  },
  orderAfterPlaner: {
    id: 'app.containers.notFoundPage.orderAfterPlaner',
    defaultMessage: 'Order after planer'
  },
  orderBeforeXCut: {
    id: 'app.containers.notFoundPage.orderBeforeXCut',
    defaultMessage: 'Order before XCUT2'
  },
  ISOFullyLoaded: {
    id: 'app.containers.notFoundPage.ISOFullyLoaded',
    defaultMessage: 'ISO fully loaded'
  },
  woodFullyLoaded: {
    id: 'app.containers.notFoundPage.woodFullyLoaded',
    defaultMessage: 'Wood fully loaded'
  },
  subtractFromID: {
    id: 'app.containers.notFoundPage.subtractFromID',
    defaultMessage: 'Subtract from ID'
  },
  deleted: {
    id: 'app.containers.notFoundPage.deleted',
    defaultMessage: 'Deleted'
  },
  speedTime: {
    id: 'app.containers.notFoundPage.speedTime',
    defaultMessage: 'Speed - Time'
  },
  emptyingStatus: {
    id: 'app.containers.notFoundPage.emptyingStatus',
    defaultMessage: 'Emptying status'
  },
  automaticEmptyingActive: {
    id: 'app.containers.notFoundPage.automaticEmptyingActive',
    defaultMessage: 'Automatic emptying active (last lamella time exceeded)'
  },
  automaticEmptyingEnabled: {
    id: 'app.containers.notFoundPage.automaticEmpty',
    defaultMessage: 'Automatic emptying enabled'
  },
  ktz1InfeedEmpty: {
    id: 'app.containers.notFoundPage.ktz1InfeedEmpty',
    defaultMessage: 'KTZ 1 infeed empty'
  },
  ktz2InfeedEmpty: {
    id: 'app.containers.notFoundPage.ktz2InfeedEmpty',
    defaultMessage: 'KTZ 2 infeed empty'
  },
  itemDetails: {
    id: 'app.containers.notFoundPage.itemDetails',
    defaultMessage: 'Item details'
  },
  currentGroup: {
    id: 'app.containers.notFoundPage.currentGroup',
    defaultMessage: 'Current group'
  },
  splitWood: {
    id: 'app.containers.notFoundPage.splitWood',
    defaultMessage: 'Split wood'
  },
  noCutMode: {
    id: 'app.containers.notFoundPage.noCutMode',
    defaultMessage: 'KVH No Cut Mode'
  },
  manualLabelMode: {
    id: 'app.containers.notFoundPage.manualLabelMode',
    defaultMessage: 'Custom Label Mode'
  },
  lastEmptyingData: {
    id: 'app.containers.notFoundPage.lastEmptyingData',
    defaultMessage: 'Last emptying data'
  },
  currentQualitySelect: {
    id: 'app.containers.notFoundPage.currentQualitySelect',
    defaultMessage: 'Current default quality'
  },
  currentOrderSelect: {
    id: 'app.containers.notFoundPage.currentOrderSelect',
    defaultMessage: 'Current default order'
  },
  currentSuitableEtages: {
    id: 'app.containers.notFoundPage.currentSuitableEtages',
    defaultMessage: 'Current suitable etages'
  },
  selectWidth: {
    id: 'app.containers.customModal.selectWidth',
    defaultMessage: 'Change Width'
  },
  externalQuality: {
    id: 'app.containers.ModelFieldMessages.externalQuality',
    defaultMessage: 'Ext. quality'
  },
  updatePlanerSetup: {
    id: 'app.containers.Tableview.updatePlanerSetup',
    defaultMessage: 'Update Planer Setup'
  },
  confirmServer: {
    id: 'app.containers.Tableview.confirmServer',
    defaultMessage: 'Confirm Server'
  },
  scanServer: {
    id: 'app.containers.Tableview.scanServer',
    defaultMessage: 'Scan Servers'
  },
  printerEvents: {
    id: 'app.containers.Tableview.printerEvents',
    defaultMessage: 'Printer Events'
  },

  operationState: {
    id: 'app.containers.Tableview.operationState',
    defaultMessage: 'Operation state'
  },
  paternosterAllowance: {
    id: 'app.containers.Tableview.paternosterAllowance',
    defaultMessage: 'Paternoster allowance'
  },
  paternosterOperationAuto: {
    id: 'app.containers.Tableview.paternosterOperationAuto',
    defaultMessage: 'Paternoster operation auto'
  },
  plcPaternosterRequest: {
    id: 'app.containers.Tableview.plcPaternosterRequest',
    defaultMessage: 'PLC paternoster request'
  },
  testOutfeedPrinter2: {
    id: 'app.containers.Tableview.testOutfeedPrinter2',
    defaultMessage: 'Test OutfeedPrinter2'
  },
  testKVHStackerPrinter: {
    id: 'app.containers.Tableview.testKVHStackerPrinter',
    defaultMessage: 'Test KVHStackerPrinter'
  },
  testCLTpanelPrinter: {
    id: 'app.containers.Tableview.testCLTpanelPrinter',
    defaultMessage: 'Test CLTpanelPrinter'
  },
  testFlexiPressPrinter: {
    id: 'app.containers.Tableview.testFlexiPressPrinter',
    defaultMessage: 'Test FlexiPress Printer'
  },
  testRotoPressPrinter: {
    id: 'app.containers.Tableview.testRotoPressPrinter',
    defaultMessage: 'Test RotoPress Printer'
  },
  testCutSawPrinter: {
    id: 'app.containers.Tableview.testCutSawPrinter',
    defaultMessage: 'Test CutSaw Printer'
  },
  currentActiveOrder: {
    id: 'app.containers.Tableview.currentActiveOrder',
    defaultMessage: 'Current active order'
  },
  packagePosA: {
    id: 'app.containers.Tableview.packagePosA',
    defaultMessage: 'OUTER A'
  },
  packagePosB: {
    id: 'app.containers.Tableview.packagePosB',
    defaultMessage: 'INNER B'
  },
  manualA: {
    id: 'app.containers.Tableview.manualA',
    defaultMessage: 'Manual A'
  },
  manualB: {
    id: 'app.containers.Tableview.manualB',
    defaultMessage: 'Manual B'
  },
  forceCalculation: {
    id: 'app.containers.Tableview.forceCalculation',
    defaultMessage: 'Force calculation'
  },
  orderInfoBox: {
    id: 'app.containers.DashboardXLAM.orderInfoBox',
    defaultMessage: 'Order Info'
  },
  sendGlobalMessage: {
    id: 'app.containers.App.sendGlobalMessage',
    defaultMessage: 'Send global message'
  },
  clearGlobalMessage: {
    id: 'app.containers.App.clearGlobalMessage',
    defaultMessage: 'Clear global message'
  },
  pleaseEnterMessage: {
    id: 'app.containers.App.pleaseEnterMessage',
    defaultMessage: 'Please enter message'
  },
  meas: {
    id: 'app.containers.meas',
    defaultMessage: 'Meas'
  },
  infeedArray: {
    id: 'app.containers.infeedArray',
    defaultMessage: 'InfeedArray'
  },
  entryChain: {
    id: 'app.containers.entryChain',
    defaultMessage: 'EntryChain'
  },
  mainChain: {
    id: 'app.containers.mainChain',
    defaultMessage: 'MainChain'
  },
  pow: {
    id: 'app.containers.pow',
    defaultMessage: 'Pow'
  },
  loadingPackagePosition: {
    id: 'app.containers.loadingPackagePosition',
    defaultMessage: 'Loading pos'
  },
  RTL1Title: {
    id: 'app.containers.RTL1Title',
    defaultMessage: 'Rotoles 1'
  },
  RTL2Title: {
    id: 'app.containers.RTL2Title',
    defaultMessage: 'Rotoles 2'
  },
  unipressTitle: {
    id: 'app.containers.unipressTitle',
    defaultMessage: 'Unipress'
  },
  resetLamellaSequence: {
    id: 'app.containers.resetLamellaSequence',
    defaultMessage: 'Reset Lamella Sequence'
  },
  halterLength: {
    id: 'app.containers.halterLength',
    defaultMessage: 'halterLength'
  },
  mainChainLength: {
    id: 'app.containers.mainChainLength',
    defaultMessage: 'mainChainLength'
  },
  powerJointLength: {
    id: 'app.containers.powerJointLength',
    defaultMessage: 'powerJointLength'
  },
  abzieherLength: {
    id: 'app.containers.abzieherLength',
    defaultMessage: 'abzieherLength'
  },
  pressSawLength: {
    id: 'app.containers.pressSawLength',
    defaultMessage: 'pressSawLength'
  },
  noGroupModeLong: {
    id: 'app.containers.editview.noGroupModeLong',
    defaultMessage: 'Group mode Long'
  },
  noGroupModeCross: {
    id: 'app.containers.editview.noGroupModeCross',
    defaultMessage: 'Group mode Cross'
  },
  totalLength: {
    id: 'app.containers.editview.totalLength',
    defaultMessage: 'Total - Xcut to Zinc'
  },
  downtime: {
    id: 'app.containers.editview.downtime',
    defaultMessage: 'Down Time'
  },
  glueSettings: {
    id: 'app.containers.editview.glueSettings',
    defaultMessage: 'Glue Settings'
  },
  'id-info': {
    id: 'app.containers.editview.idInfo',
    defaultMessage: 'This is the order ID'
  },
  'changeId-info': {
    id: 'app.containers.editview.changeIdInfo',
    defaultMessage: 'Identifier for change tracking'
  },
  'lamellaThickness-info': {
    id: 'app.containers.editview.lamellaThicknessInfo',
    defaultMessage: 'Thickness of the lamella'
  },
  'lamellaWidth-info': {
    id: 'app.containers.editview.lamellaWidthInfo',
    defaultMessage: 'Width of the lamella'
  },
  'lamellaLength-info': {
    id: 'app.containers.editview.lamellaLengthInfo',
    defaultMessage: 'Length of the lamella'
  },
  'lamellaPlannedThickness-info': {
    id: 'app.containers.editview.lamellaPlannedThicknessInfo',
    defaultMessage: 'Planed thickness of the lamella'
  },
  'lamellaPlannedWidth-info': {
    id: 'app.containers.editview.lamellaPlannedWidthInfo',
    defaultMessage: 'Planed width of the lamella'
  },
  'quality-info': {
    id: 'app.containers.editview.qualityInfo',
    defaultMessage: 'Quality grade of the lamella'
  },
  'numLamellas-info': {
    id: 'app.containers.editview.numLamellasInfo',
    defaultMessage: 'Number of lamellas in this layer'
  },
  'zincDoneNumLamellas-info': {
    id: 'app.containers.editview.zincDoneNumLamellasInfo',
    defaultMessage: 'Number of lamellas completed on zinc press'
  },
  'producingOnZinc-info': {
    id: 'app.containers.editview.producingOnZincInfo',
    defaultMessage: 'Lamellas currently in production on zinc press'
  },
  'zPressDoneNumLamellas-info': {
    id: 'app.containers.editview.zPressDoneNumLamellasInfo',
    defaultMessage: 'Number of lamellas finished on Z-Press'
  },
  'finishedProducingOnZinc-info': {
    id: 'app.containers.editview.finishedProducingOnZincInfo',
    defaultMessage: 'Lamellas finished producing on zinc press'
  },
  'FJmachine-info': {
    id: 'app.containers.editview.FJmachineInfo',
    defaultMessage: 'Finger joint machine assigned'
  },
  'orientation-info': {
    id: 'app.containers.editview.orientationInfo',
    defaultMessage: 'Orientation of the lamellas'
  },
  'rotation-info': {
    id: 'app.containers.editview.rotationInfo',
    defaultMessage: 'Rotation status of the lamellas'
  },
  'producingOnZPress-info': {
    id: 'app.containers.editview.producingOnZPressInfo',
    defaultMessage: 'Lamellas currently in production on Z-Press'
  },
  'finishedProducingOnZPress-info': {
    id: 'app.containers.editview.finishedProducingOnZPressInfo',
    defaultMessage: 'Lamellas finished producing on Z-Press'
  },
  'acknowledgedOnZinc-info': {
    id: 'app.containers.editview.acknowledgedOnZincInfo',
    defaultMessage: 'Lamellas acknowledged on zinc press'
  },
  'orderCharge-info': {
    id: 'app.containers.editview.orderChargeInfo',
    defaultMessage: 'Order charge number'
  },
  'noGroupMode-info': {
    id: 'app.containers.editview.noGroupModeInfo',
    defaultMessage: 'Production in no-group mode'
  },
  'masterpanel-info': {
    id: 'app.containers.editview.masterpanelInfo',
    defaultMessage: 'Master panel information'
  },
  'noGroupUsed-info': {
    id: 'app.containers.editview.noGroupUsedInfo',
    defaultMessage: 'Indicates if no-group mode is used'
  },
  'layerCutOnSaw-info': {
    id: 'app.containers.editview.layerCutOnSawInfo',
    defaultMessage: 'Indicates if layer is cut on saw'
  },
  'splitWood-info': {
    id: 'app.containers.editview.splitWoodInfo',
    defaultMessage: 'Indicates split wood usage'
  },
  'currentOffset-info': {
    id: 'app.containers.editview.currentOffsetInfo',
    defaultMessage: 'Current saw offset'
  },
  'craneCommandSent-info': {
    id: 'app.containers.editview.craneCommandSentInfo',
    defaultMessage: 'Crane command sent'
  },
  'craneCommandOk-info': {
    id: 'app.containers.editview.craneCommandOkInfo',
    defaultMessage: 'Crane command confirmed OK'
  },
  'craneCommandError-info': {
    id: 'app.containers.editview.craneCommandErrorInfo',
    defaultMessage: 'Error in crane command'
  },
  'sawOffset-info': {
    id: 'app.containers.editview.sawOffsetInfo',
    defaultMessage: 'Configured saw offset'
  },
  'extraLamella-info': {
    id: 'app.containers.editview.extraLamellaInfo',
    defaultMessage: 'Extra lamella needed'
  },
  'correctionAdded-info': {
    id: 'app.containers.editview.correctionAddedInfo',
    defaultMessage: 'Correction added to the order'
  },
  'errorLength-info': {
    id: 'app.containers.editview.errorLengthInfo',
    defaultMessage: 'Error length detected'
  },
  'extraLamellaOrder-info': {
    id: 'app.containers.editview.extraLamellaOrderInfo',
    defaultMessage: 'Order includes extra lamella'
  },
  'extraPlateOrder-info': {
    id: 'app.containers.editview.extraPlateOrderInfo',
    defaultMessage: 'Order includes extra plate'
  },
  'wasteCycle-info': {
    id: 'app.containers.editview.wasteCycleInfo',
    defaultMessage: 'Waste cycle indicator'
  },
  'canFinishZPressOrder-info': {
    id: 'app.containers.editview.canFinishZPressOrderInfo',
    defaultMessage: 'Order can be finished on Z-Press'
  },
  'panelWidth-info': {
    id: 'app.containers.editview.panelWidthInfo',
    defaultMessage: 'Panel width'
  },
  'subtractedLamellasDouble-info': {
    id: 'app.containers.editview.subtractedLamellasDoubleInfo',
    defaultMessage: 'Subtracted lamellas double counted'
  },
  'assignedPress-info': {
    id: 'app.containers.editview.assignedPressInfo',
    defaultMessage: 'Assigned press machine'
  },
  'orderId-info': {
    id: 'app.containers.editview.orderIdInfo',
    defaultMessage: 'Order identifier'
  },
  'layerId-info': {
    id: 'app.containers.editview.layerIdInfo',
    defaultMessage: 'Layer identifier'
  },
  materialmap: {
    id: 'app.containers.editview.materialmap',
    defaultMessage: 'Material Map'
  },
  singleQCLamella: {
    id: 'app.containers.editview.singleQCLamella',
    defaultMessage: 'Single QC lamella'
  },
  brokenLamella: {
    id: 'app.containers.editview.brokenLamella',
    defaultMessage: 'Broken lamella'
  },
  xcutWoodLength: {
    id: 'app.containers.editview.xcutWoodLength',
    defaultMessage: 'XCut Wood Length'
  },
  dimensionOverlap: {
    id: 'app.containers.editview.dimensionOverlap',
    defaultMessage: 'Dimension overlap'
  },
  startExtraWoodLength: {
    id: 'app.containers.editview.startExtraWoodLength',
    defaultMessage: 'Start Extra Wood Length'
  },
  confirmLabel: {
    id: 'app.containers.editview.confirmLabel',
    defaultMessage: 'Confirm Action'
  },
  confirmAction: {
    id: 'app.containers.editview.confirmAction',
    defaultMessage: 'Are you sure you want to proceed with this action?'
  },
  setExtraLength: {
    id: 'app.containers.editview.setExtraLength',
    defaultMessage: 'Set Extra Length'
  },
  lamellaSequence: {
    id: 'app.containers.lamellaSequence',
    defaultMessage: 'Lamella Sequence'
  },
  layerAfterVacuum: {
    id: 'app.containers.layerAfterVacuum',
    defaultMessage: 'Layer After Vacuum'
  },
  boardForScanner: {
    id: 'app.containers.boardForScanner',
    defaultMessage: 'Boards For Goldeneye'
  },
  emptyBothChainsInfo: {
    id: 'emptyBothChains-info',
    defaultMessage: 'Empty both chains'
  },
  lOversizeInfo: {
    id: 'lOversize-info',
    defaultMessage: 'Additional millimeters added to the width of an L layer.'
  },
  qOversizeInfo: {
    id: 'qOversize-info',
    defaultMessage: 'Additional millimeters added to the width of a C panel.'
  },
  minHeightRawDifferenceInfo: {
    id: 'minHeightRawDifference-info',
    defaultMessage: 'Minimum millimeters removed from thickness by Multiplan.'
  },
  maxHeightRawDifferenceInfo: {
    id: 'maxHeightRawDifference-info',
    defaultMessage: 'Maximum millimeters removed from thickness by Multiplan.'
  },
  maxXMPanelsInfo: {
    id: 'maxXMPanels-info',
    defaultMessage: 'Maximum number of panels that can be pressed in an XM press.'
  },
  maxPressHeightInfo: {
    id: 'maxPressHeight-info',
    defaultMessage: 'Maximum total thickness of all panels in an XM press.'
  },
  beamOversizeInfo: {
    id: 'beamOversize-info',
    defaultMessage: 'Extra millimeters added to beam width after Wrawor processing.'
  },
  minTakeawayInfo: {
    id: 'minTakeaway-info',
    defaultMessage: 'Minimum millimeters removed from width by Multiplan.'
  },
  maxTakeawayInfo: {
    id: 'maxTakeaway-info',
    defaultMessage: 'Maximum millimeters removed from width by Multiplan.'
  },
  minCltPanelOversizeInfo: {
    id: 'minCltPanelOversize-info',
    defaultMessage: 'Thickness oversize for CLT panels.'
  },
  minBeamPanelOversizeInfo: {
    id: 'minBeamPanelOversize-info',
    defaultMessage: 'Thickness oversize for beam panels.'
  },
  xFormReserveInfo: {
    id: 'xFormReserve-info',
    defaultMessage: 'Additional millimeters reserved for Schoberl processing.'
  },
  dryingTimeInfo: {
    id: 'dryingTime-info',
    defaultMessage: 'Minutes the panel needs to wait after press before it is moved by vacuum '
  },
  qualityLengthPairs: {
    id: 'app.titles.qualityLengthPairs',
    defaultMessage: 'Qualities'
  },
  badQuality: {
    id: 'app.titles.badQuality',
    defaultMessage: 'Bad Quality'
  },
  addQualityPair: {
    id: 'app.buttons.addQualityPair',
    defaultMessage: 'Add Quality Pair'
  },
  addMaintenanceTask: {
    id: 'app.buttons.addMaintenanceTask',
    defaultMessage: 'Add Maintenance Task'
  },
  addLineSetting: {
    id: 'app.buttons.addLineSetting',
    defaultMessage: 'Add Line Setting'
  },
  addPeriodicTask: {
    id: 'app.buttons.addPeriodicTask',
    defaultMessage: 'Add Periodic Maintenance Task'
  },
  xlamQuality: {
    id: 'app.fields.xlamQuality',
    defaultMessage: 'XLam Quality'
  },
  monitors: {
    id: 'app.components.SideMenu.monitors',
    defaultMessage: 'Monitors'
  },
  infeed3D: {
    id: 'app.components.MachinesFiber.infeed3D',
    defaultMessage: 'Infeed 3D Simulation'
  },
  lineStatusView: {
    id: 'app.containers.Sidebar.lineStatusViewer',
    defaultMessage: 'Line Status'
  },
  bshstorage: {
    id: 'app.components.MachinesFiber.bshstorage',
    defaultMessage: 'BSH storage'
  },
  bshemptying: {
    id: 'app.containers.editview.bshemptying',
    defaultMessage: 'bshemptying'
  },
  bshemptied: {
    id: 'app.containers.editview.bshemptied',
    defaultMessage: 'bshemptied'
  },
  inMaxiPress: {
    id: 'app.containers.editview.inMaxiPress',
    defaultMessage: 'inMaxiPress'
  },
  readyForPress: {
    id: 'app.containers.editview.readyForPress',
    defaultMessage: 'readyForPress'
  },
  finishedOnPress: {
    id: 'app.containers.editview.finishedOnPress',
    defaultMessage: 'finishedOnPress'
  },
  overrideReadyForPress: {
    id: 'app.containers.editview.overrideReadyForPress',
    defaultMessage: 'overrideReadyForPress'
  },
  overrideReadyForPressLevel: {
    id: 'app.containers.editview.overrideReadyForPressLevel',
    defaultMessage: 'overrideReadyForPressLevel'
  },
  readyForMaxiPress: {
    id: 'app.containers.editview.readyForMaxiPress',
    defaultMessage: 'readyForMaxiPress'
  },
  finishedOnMaxiPress: {
    id: 'app.containers.editview.finishedOnMaxiPress',
    defaultMessage: 'finishedOnMaxiPress'
  },
  overrideReadyForMaxiPress: {
    id: 'app.containers.editview.overrideReadyForMaxiPress',
    defaultMessage: 'overrideReadyForMaxiPress'
  },
  sentToMaxiPress: {
    id: 'app.containers.editview.sentToMaxiPress',
    defaultMessage: 'sentToMaxiPress'
  },
  lamellaCount: {
    id: 'app.containers.bodenlager.lamellaCount',
    defaultMessage: 'Lamella count'
  },
  noLamellaFound: {
    id: 'app.containers.bodenlager.noLamellaFound',
    defaultMessage: 'No suitable lamella found.'
  },
  hfPressDataNext: {
    id: 'app.containers.bodenlager.hfPressDataNext',
    defaultMessage: 'HF Press Data Next'
  },
  hfPressData: {
    id: 'app.containers.bodenlager.hfPressData',
    defaultMessage: 'HF Press Data'
  },
  chargeInfo: {
    id: 'app.containers.bodenlager.chargeInfo',
    defaultMessage: 'Charge Info'
  },
  chargeInfoNext: {
    id: 'app.containers.bodenlager.chargeInfoNext',
    defaultMessage: 'Charge Info Next'
  },
  stackStructure: {
    id: 'app.containers.bodenlager.stackStructure',
    defaultMessage: 'Stack Structure'
  },
  optimizedFilling: {
    id: 'app.containers.Tableview.optimizedFilling',
    defaultMessage: 'optimizedFilling'
  },
  goldeneyeSetup: {
    id: 'app.containers.Tableview.goldeneyeSetup',
    defaultMessage: 'Goldeneye Setup'
  },
  kallesoeDestinationCalculationInfo: {
    id: 'kallesoeDestinationCalculation-info',
    defaultMessage: 'Kallesoe Storage Automatic Destination Calculation'
  },
  kallesoeDebugLevelInfo: {
    id: 'kallesoeDebugLevel-info',
    defaultMessage: 'Kallesoe Storage Force To Compartment Number'
  },
  emptyingNlevelCalculation: {
    id: 'app.containers.editview.emptyingNlevelCalculation',
    defaultMessage: 'Emptying N level calculation'
  },
  maxLiftWidth: {
    id: 'app.containers.editview.maxLiftWidth',
    defaultMessage: 'Max lift width'
  },
  holder1Width: {
    id: 'app.containers.editview.holder1Width',
    defaultMessage: 'Holder 1 width'
  },
  lastFewOrdersPressedMax: {
    id: 'app.containers.editview.lastFewOrdersPressedMax',
    defaultMessage: 'Last few orders pressed max'
  },
  lastFewOrdersDeletedMax: {
    id: 'app.containers.editview.lastFewOrdersDeletedMax',
    defaultMessage: 'Last few orders deleted max'
  },
  ignoreSeqError: {
    id: 'app.containers.editview.ignoreSeqError',
    defaultMessage: 'Ignore sequence error'
  },
  headCutLength: {
    id: 'app.containers.editview.headCutLength',
    defaultMessage: 'Head cut length'
  },
  hasHeadCut: {
    id: 'app.containers.editview.hasHeadCut',
    defaultMessage: 'Has head cut'
  },
  bufferForDimension: {
    id: 'app.containers.editview.bufferForDimension',
    defaultMessage: 'Buffer for dimension'
  },
  extraLamellaStorage: {
    id: 'app.containers.editview.extraLamellaStorage',
    defaultMessage: 'Extra lamella storage'
  },
  dryingOrderViewSize: {
    id: 'app.containers.editview.dryingOrderViewSize',
    defaultMessage: 'Drying order view size'
  },
  maxJoinLength: {
    id: 'app.containers.editview.maxJoinLength',
    defaultMessage: 'Max join length'
  },
  xcutSawBladeThickness: {
    id: 'app.containers.editview.xcutSawBladeThickness',
    defaultMessage: 'Xcut saw blade thickness'
  },
  forceMultiLevel: {
    id: 'app.containers.editview.forceMultiLevel',
    defaultMessage: 'Force multi level'
  },
  floorStorageSectionMax: {
    id: 'app.containers.editview.floorStorageSectionMax',
    defaultMessage: 'Floor storage section max'
  },
  outsideFinalBeamThickness: {
    id: 'app.containers.editview.outsideFinalBeamThickness',
    defaultMessage: 'Outside Final Lamella Thickness'
  },
  outsideBottomBeamThickness: {
    id: 'app.containers.editview.outsideBottomBeamThickness',
    defaultMessage: 'Outside Bottom Lamella Thickness'
  },
  floatTsToTop: {
    id: 'app.containers.editview.floatTsToTop',
    defaultMessage: 'Float TS to top'
  },
  simPlanerId: {
    id: 'app.containers.editview.simPlanerId',
    defaultMessage: 'Sim planer ID'
  },
  kallesoeDebugLevel: {
    id: 'app.containers.editview.kallesoeDebugLevel',
    defaultMessage: 'Kallesoe debug level'
  },
  kallesoeSectionWidth: {
    id: 'app.containers.editview.kallesoeSectionWidth',
    defaultMessage: 'Kallesoe section width'
  },
  zinkDestination: {
    id: 'app.containers.editview.zinkDestination',
    defaultMessage: 'Zink destination'
  },
  kallesoeDestinationCalculation: {
    id: 'app.containers.editview.kallesoeDestinationCalculation',
    defaultMessage: 'Kallesoe destination calculation'
  },
  storageBuffer: {
    id: 'app.containers.editview.storageBuffer',
    defaultMessage: 'Storage buffer'
  },
  zeroLineOffset: {
    id: 'app.containers.editview.zeroLineOffset',
    defaultMessage: 'Zero line offset'
  },
  withQCSample: {
    id: 'app.containers.editview.withQCSample',
    defaultMessage: 'With QC sample'
  },
  withHeadcut: {
    id: 'app.containers.editview.withHeadcut',
    defaultMessage: 'With headcut'
  },
  headcutLength: {
    id: 'app.containers.editview.headcutLength',
    defaultMessage: 'Headcut length'
  },
  qCSampleLength: {
    id: 'app.containers.editview.qCSampleLength',
    defaultMessage: 'QC sample length'
  },
  groove: {
    id: 'app.containers.editview.groove',
    defaultMessage: 'Groove'
  },
  grooveDepth: {
    id: 'app.containers.editview.grooveDepth',
    defaultMessage: 'Groove depth'
  },
  distanceFromEdge: {
    id: 'app.containers.editview.distanceFromEdge',
    defaultMessage: 'Distance from edge'
  },
  dbPassword: {
    id: 'app.containers.editview.dbPassword',
    defaultMessage: 'DB password'
  },
  direction: {
    id: 'app.containers.editview.direction',
    defaultMessage: 'Floor Storage Destination'
  },
  kallesoeDataPlanerAllowanceInfo: {
    id: 'kallesoeDataPlanerAllowanceInfo-info',
    defaultMessage: 'We need this to send lamella data to Kallesoe. Enable the allowance on the Kallesoe panel'
  },
  staggered: {
    id: 'app.containers.editControlOrder.staggered',
    defaultMessage: 'Staggered'
  },
  beamWidthFinal: {
    id: 'app.containers.editControlOrder.beamWidthFinal',
    defaultMessage: 'Final Beam Width'
  },
  beamThicknessFinal: {
    id: 'app.containers.editControlOrder.beamThicknessFinal',
    defaultMessage: 'Final Beam Thickness'
  },
  allStacksInStorage: {
    id: 'app.containers.editControlOrder.allStacksInStorage',
    defaultMessage: 'All Stacks In Storage'
  },
  assignedPress: {
    id: 'app.containers.editControlOrder.assignedPress',
    defaultMessage: 'Assigned Press'
  },
  doneOnHyper: {
    id: 'app.containers.editControlOrder.doneOnHyper',
    defaultMessage: 'Done On HyperPress'
  },
  fullyOffHyper: {
    id: 'app.containers.editControlOrder.fullyOffHyper',
    defaultMessage: 'Fully Off HyperPress'
  },
  camberedRadius: {
    id: 'app.containers.editControlOrder.camberedRadius',
    defaultMessage: 'Cambered Radius'
  },
  cambered: {
    id: 'app.containers.editControlOrder.cambered',
    defaultMessage: 'Cambered'
  },
  useLKS: {
    id: 'app.containers.editControlOrder.useLKS',
    defaultMessage: 'Use LKS'
  },
  clipsWarning: {
    id: 'app.containers.editOrder.clipsWarning',
    defaultMessage: 'Warning: This order has shoe positions at 3200 mm or above. Clips will need to be removed.'
  },
  flowStats: {
    id: 'app.containers.FlowStats',
    defaultMessage: 'Flow Stats'
  },
  lineEfficiency: {
    id: 'app.containers.lineEfficiency',
    defaultMessage: 'Line Efficiency'
  },
  indicatorLidar: {
    id: 'app.components.SideMenu.indicatorLidar',
    defaultMessage: 'Lidar'
  },
  packageSettings: {
    id: 'app.packageSettings',
    defaultMessage: 'Package Settings'
  },
  floorStorage: {
    id: 'app.components.SideMenu.floorStorage',
    defaultMessage: 'Floor Storage'
  },
  sevenLevelStorage: {
    id: 'app.components.SideMenu.sevenLevelStorage',
    defaultMessage: '7-level storage'
  },
  rotoPress: {
    id: 'app.components.SideMenu.rotoPress',
    defaultMessage: 'Rotopress'
  },
  zPressStartTime: {
    id: 'app.containers.Tableview.zPressStartTime',
    defaultMessage: 'ZPress Start Time'
  },
  zPressEndTime: {
    id: 'app.containers.Tableview.zPressEndTime',
    defaultMessage: 'ZPress End Time'
  },
  layeretages: {
    id: 'app.components.SideMenu.rotoPress',
    defaultMessage: 'Layer Etages'
  },
  lineStatisticsViewer: {
    id: 'app.containers.FlowStats',
    defaultMessage: 'Line Statistics'
  },
  autoOperation: {
    id: 'app.containers.MachineTitles.autoOperation',
    defaultMessage: 'Auto operation'
  },
  allowanceNewDataRCAfterMovable: {
    id: 'app.containers.Sanding.allowanceNewDataRCAfterMovable',
    defaultMessage: 'Allowance new data RC after movable'
  },

  allowanceNewDataRCatChains: {
    id: 'app.containers.Sanding.allowanceNewDataRCatChains',
    defaultMessage: 'Allowance new data RC at chains'
  },

  allowanceNewDataBTWChains: {
    id: 'app.containers.Sanding.allowanceNewDataBTWChains',
    defaultMessage: 'Allowance new data between chains'
  },

  allowanceNewDataBeforeImeas: {
    id: 'app.containers.Sanding.allowanceNewDataBeforeImeas',
    defaultMessage: 'Allowance new data before IMEAS'
  },

  allowanceNewDataAfterImeas: {
    id: 'app.containers.Sanding.allowanceNewDataAfterImeas',
    defaultMessage: 'Allowance new data after IMEAS'
  },

  newDataOKRCAfterMovable: {
    id: 'app.containers.Sanding.newDataOKRCAfterMovable',
    defaultMessage: 'New data OK RC after movable'
  },

  newDataOKRCatChains: {
    id: 'app.containers.Sanding.newDataOKRCatChains',
    defaultMessage: 'New data OK RC at chains'
  },

  newDataOKBTWChains: {
    id: 'app.containers.Sanding.newDataOKBTWChains',
    defaultMessage: 'New data OK between chains'
  },

  newDataOKBeforeImeas: {
    id: 'app.containers.Sanding.newDataOKBeforeImeas',
    defaultMessage: 'New data OK before IMEAS'
  },

  newDataOKAfterImeas: {
    id: 'app.containers.Sanding.newDataOKAfterImeas',
    defaultMessage: 'New data OK after IMEAS'
  },

  newDataRCAfterMovable: {
    id: 'app.containers.Sanding.newDataRCAfterMovable',
    defaultMessage: 'New data RC after movable'
  },

  newDataRCatChains: {
    id: 'app.containers.Sanding.newDataRCatChains',
    defaultMessage: 'New data RC at chains'
  },

  newDataBTWChains: {
    id: 'app.containers.Sanding.newDataBTWChains',
    defaultMessage: 'New data between chains'
  },

  newDataBeforeImeas: {
    id: 'app.containers.Sanding.newDataBeforeImeas',
    defaultMessage: 'New data before IMEAS'
  },

  newDataAfterImeas: {
    id: 'app.containers.Sanding.newDataAfterImeas',
    defaultMessage: 'New data after IMEAS'
  },

  panelAfterMovable: {
    id: 'app.containers.Sanding.panelAfterMovable',
    defaultMessage: 'RC after movable'
  },

  panelAtCrossroad: {
    id: 'app.containers.Sanding.panelAtCrossroad',
    defaultMessage: 'RC at chains'
  },

  panelBTW: {
    id: 'app.containers.Sanding.panelBTW',
    defaultMessage: 'Between chains'
  },

  panelBeforeImeas: {
    id: 'app.containers.Sanding.panelBeforeImeas',
    defaultMessage: 'Before IMEAS'
  },

  panelAfterImeas: {
    id: 'app.containers.Sanding.panelAfterImeas',
    defaultMessage: 'After IMEAS'
  },

  ordersInProducing: {
    id: 'app.containers.editview.activeOrders',
    defaultMessage: 'Producing'
  },

  ordersInDone: {
    id: 'app.containers.editview.doneOrders',
    defaultMessage: 'Done'
  },
  sandingComplete: {
    id: 'app.containers.Sanding.sandingComplete',
    defaultMessage: 'Sanding complete'
  },
  noAutoA12: {
    id: 'app.globalMessages.errors.noAutoA12',
    defaultMessage: 'No Auto A12'
  },
  noAutoA11: {
    id: 'app.globalMessages.errors.noAutoA11',
    defaultMessage: 'No Auto A11'
  },
  noAutoA15: {
    id: 'app.globalMessages.errors.noAutoA15',
    defaultMessage: 'No Auto A15'
  },
  stratoplanNotInPos: {
    id: 'app.globalMessages.errors.stratoplanNotInPos',
    defaultMessage: 'Stratoplan Not In Pos'
  },
  noAutoA13: {
    id: 'app.globalMessages.errors.noAutoA13',
    defaultMessage: 'No Auto A13'
  },
  noAutoA14: {
    id: 'app.globalMessages.errors.noAutoA14',
    defaultMessage: 'No Auto A14'
  },
  noPacketAtKiptisch: {
    id: 'app.globalMessages.errors.noPacketAtKiptisch',
    defaultMessage: 'No Packet At Kiptisch'
  },
  differentLenghtAtDestacking: {
    id: 'app.globalMessages.errors.differentLenghtAtDestacking',
    defaultMessage: 'Different Lenght At Destacking'
  },
  doubleBoardAfterMulda: {
    id: 'app.globalMessages.errors.doubleBoardAfterMulda',
    defaultMessage: 'Double Board After Mulda'
  },
  woodStuckInStratoplan: {
    id: 'app.globalMessages.errors.woodStuckInStratoplan',
    defaultMessage: 'Wood Stuck In Stratoplan'
  },
  noDataAtPacketNo1: {
    id: 'app.globalMessages.errors.noDataAtPacketNo1',
    defaultMessage: 'No Data At Packet No 1'
  },
  powerfeedNotInPos: {
    id: 'app.globalMessages.errors.powerfeedNotInPos',
    defaultMessage: 'Powerfeed Not In Pos'
  },
  destackingDisabledAtKiptisch: {
    id: 'app.globalMessages.errors.destackingDisabledAtKiptisch',
    defaultMessage: 'Destacking Disabled At Kiptisch'
  },
  areaA14Error: {
    id: 'app.globalMessages.errors.areaA14Error',
    defaultMessage: 'Area A14 Error'
  },
  areaA13Error: {
    id: 'app.globalMessages.errors.areaA13Error',
    defaultMessage: 'Area A13 Error'
  },
  pfNotReady: {
    id: 'app.globalMessages.errors.pfNotReady',
    defaultMessage: 'PF Not Ready'
  },
  areaA11Error: {
    id: 'app.globalMessages.errors.areaA11Error',
    defaultMessage: 'Area A11 Error'
  },
  areaA12Error: {
    id: 'app.globalMessages.errors.areaA12Error',
    defaultMessage: 'Area A12 Error'
  },
  noShafts: {
    id: 'app.globalMessages.errors.noShafts',
    defaultMessage: 'No Shafts'
  },
  noExtraction: {
    id: 'app.globalMessages.errors.noExtraction',
    defaultMessage: 'No Extraction'
  },
  feedNotReady: {
    id: 'app.globalMessages.errors.feedNotReady',
    defaultMessage: 'Feed Not Ready'
  },
  boardErrorInMagazin: {
    id: 'app.globalMessages.errors.boardErrorInMagazin',
    defaultMessage: 'Board Error In Magazin'
  },
  ssMaxTorque: {
    id: 'app.globalMessages.errors.ssMaxTorque',
    defaultMessage: 'SS Max Torque'
  },
  areaA21Error: {
    id: 'app.globalMessages.errors.areaA21Error',
    defaultMessage: 'Area A21 Error'
  },
  areaA22Error: {
    id: 'app.globalMessages.errors.areaA22Error',
    defaultMessage: 'Area A22 Error'
  },
  woodStuckOnBelt: {
    id: 'app.globalMessages.errors.woodStuckOnBelt',
    defaultMessage: 'Wood Stuck On Belt'
  },
  a32Error: {
    id: 'app.globalMessages.errors.a32Error',
    defaultMessage: 'A32 Error'
  },
  singlingTurnedOff: {
    id: 'app.globalMessages.errors.singlingTurnedOff',
    defaultMessage: 'Singling Turned Off'
  },
  a31Error: {
    id: 'app.globalMessages.errors.a31Error',
    defaultMessage: 'A31 Error'
  },
  storageEmptyingStoped: {
    id: 'app.globalMessages.errors.storageEmptyingStoped',
    defaultMessage: 'Storage Emptying Stoped'
  },
  zerolineError: {
    id: 'app.globalMessages.errors.zerolineError',
    defaultMessage: 'Zeroline Error'
  },
  'Manual Emptying': {
    id: 'app.globalMessages.errors.Manual Emptying',
    defaultMessage: 'Manual Emptying'
  },
  accelerationBeltsError: {
    id: 'app.globalMessages.errors.accelerationBeltsError',
    defaultMessage: 'Acceleration Belts Error'
  },
  ejectedBoardsFull: {
    id: 'app.globalMessages.errors.ejectedBoardsFull',
    defaultMessage: 'Ejected Boards Full'
  },
  allingmentError: {
    id: 'app.globalMessages.errors.allingmentError',
    defaultMessage: 'Allingment Error'
  },
  carpetError: {
    id: 'app.globalMessages.errors.carpetError',
    defaultMessage: 'Carpet Error'
  },
  storageFull: {
    id: 'app.globalMessages.errors.storageFull',
    defaultMessage: 'Storage Full'
  },
  pcStorageFull: {
    id: 'app.globalMessages.errors.pcStorageFull',
    defaultMessage: 'PC Storage Full'
  },
  boardMissmatchError: {
    id: 'app.globalMessages.errors.boardMissmatchError',
    defaultMessage: 'Board Missmatch Error'
  },
  singlingFull: {
    id: 'app.globalMessages.errors.singlingFull',
    defaultMessage: 'Singling Full'
  },
  remaError: {
    id: 'app.globalMessages.errors.remaError',
    defaultMessage: 'REMA Error'
  },
  remaData: {
    id: 'app.globalMessages.errors.remaData',
    defaultMessage: 'Rema Data'
  },
  lidarData: {
    id: 'app.globalMessages.lidarData',
    defaultMessage: 'Lidar Data'
  },
  etagesVisualization: {
    id: 'app.globalMessages.etagesVisualization',
    defaultMessage: 'Etages Calculator'
  },
  a33Error: {
    id: 'app.globalMessages.errors.a33Error',
    defaultMessage: 'A33 Error'
  },
  a34Error: {
    id: 'app.globalMessages.errors.a34Error',
    defaultMessage: 'A34 Error'
  },
  printerError: {
    id: 'app.globalMessages.errors.printerError',
    defaultMessage: 'Printer Error'
  },
  a42Error: {
    id: 'app.globalMessages.errors.a42Error',
    defaultMessage: 'A42 Error'
  },
  a41Error: {
    id: 'app.globalMessages.errors.a41Error',
    defaultMessage: 'A41 Error'
  },
  changeLatsError: {
    id: 'app.globalMessages.errors.changeLatsError',
    defaultMessage: 'Change Lats Error'
  },
  latsEmptyError: {
    id: 'app.globalMessages.errors.latsEmptyError',
    defaultMessage: 'Lats Empty Error'
  },
  packPositionError: {
    id: 'app.globalMessages.errors.packPositionError',
    defaultMessage: 'Pack Position Error'
  },
  fromm3Error: {
    id: 'app.globalMessages.errors.fromm3Error',
    defaultMessage: 'Fromm 3 Error'
  },
  autoA56Off: {
    id: 'app.globalMessages.errors.autoA56Off',
    defaultMessage: 'Auto A56 Off'
  },
  autoA55Off: {
    id: 'app.globalMessages.errors.autoA55Off',
    defaultMessage: 'Auto A55 Off'
  },
  autoA54Off: {
    id: 'app.globalMessages.errors.autoA54Off',
    defaultMessage: 'Auto A54 Off'
  },
  cgvError: {
    id: 'app.globalMessages.errors.cgvError',
    defaultMessage: 'CGV Error'
  },
  autoA51Off: {
    id: 'app.globalMessages.errors.autoA51Off',
    defaultMessage: 'Auto A51 Off'
  },
  autoA57Off: {
    id: 'app.globalMessages.errors.autoA57Off',
    defaultMessage: 'Auto A57 Off'
  },
  fromm1Error: {
    id: 'app.globalMessages.errors.fromm1Error',
    defaultMessage: 'Fromm 1 Error'
  },
  autoA52Off: {
    id: 'app.globalMessages.errors.autoA52Off',
    defaultMessage: 'Auto A52 Off'
  },
  newDimensionConfirmationBeforeFromm1: {
    id: 'app.globalMessages.errors.newDimensionConfirmationBeforeFromm1',
    defaultMessage: 'New Dimension Confirmation Before Fromm 1'
  },
  fromm2Error: {
    id: 'app.globalMessages.errors.fromm2Error',
    defaultMessage: 'Fromm 2 Error'
  },
  autoA53Off: {
    id: 'app.globalMessages.errors.autoA53Off',
    defaultMessage: 'Auto A53 Off'
  },
  noAllowanceForPackageTransitToFromm1: {
    id: 'app.globalMessages.errors.noAllowanceForPackageTransitToFromm1',
    defaultMessage: 'No Allowance For Package Transit To Fromm 1'
  },
  noDataAtP1BeforeTurnTable: {
    id: 'app.globalMessages.errors.noDataAtP1BeforeTurnTable',
    defaultMessage: 'No Data At P1 Before Turn Table'
  },
  'autoA55.1Off': {
    id: 'app.globalMessages.errors.autoA55.1Off',
    defaultMessage: 'Auto A55.1 Off'
  },
  autoA51Error: {
    id: 'app.globalMessages.errors.autoA51Error',
    defaultMessage: 'Auto A51 Error'
  },
  autoA52Error: {
    id: 'app.globalMessages.errors.autoA52Error',
    defaultMessage: 'Auto A52 Error'
  },
  autoA53Error: {
    id: 'app.globalMessages.errors.autoA53Error',
    defaultMessage: 'Auto A53 Error'
  },
  autoA54Error: {
    id: 'app.globalMessages.errors.autoA54Error',
    defaultMessage: 'Auto A54 Error'
  },
  autoA55Error: {
    id: 'app.globalMessages.errors.autoA55Error',
    defaultMessage: 'Auto A55 Error'
  },
  autoA56Error: {
    id: 'app.globalMessages.errors.autoA56Error',
    defaultMessage: 'Auto A56 Error'
  },
  autoA57Error: {
    id: 'app.globalMessages.errors.autoA57Error',
    defaultMessage: 'Auto A57 Error'
  },
  errorOnTurnTable: {
    id: 'app.globalMessages.errors.errorOnTurnTable',
    defaultMessage: 'Error On Turn Table'
  },
  manualStrapingWithCyclop: {
    id: 'app.globalMessages.errors.manualStrapingWithCyclop',
    defaultMessage: 'Manual Straping With Cyclop'
  },
  'autoA55.1Error': {
    id: 'app.globalMessages.errors.autoA55.1Error',
    defaultMessage: 'Auto A55.1 Error'
  },
  error9: {
    id: 'app.globalMessages.errors.error9',
    defaultMessage: 'Error 9'
  },
  error10: {
    id: 'app.globalMessages.errors.error10',
    defaultMessage: 'Error 10'
  },
  error11: {
    id: 'app.globalMessages.errors.error11',
    defaultMessage: 'Error 11'
  },
  error12: {
    id: 'app.globalMessages.errors.error12',
    defaultMessage: 'Error 12'
  },
  error13: {
    id: 'app.globalMessages.errors.error13',
    defaultMessage: 'Error 13'
  },
  error14: {
    id: 'app.globalMessages.errors.error14',
    defaultMessage: 'Error 14'
  },
  error15: {
    id: 'app.globalMessages.errors.error15',
    defaultMessage: 'Error 15'
  },
  error16: {
    id: 'app.globalMessages.errors.error16',
    defaultMessage: 'Error 16'
  },
  error17: {
    id: 'app.globalMessages.errors.error17',
    defaultMessage: 'Error 17'
  },
  error18: {
    id: 'app.globalMessages.errors.error18',
    defaultMessage: 'Error 18'
  },
  error19: {
    id: 'app.globalMessages.errors.error19',
    defaultMessage: 'Error 19'
  },
  error20: {
    id: 'app.globalMessages.errors.error20',
    defaultMessage: 'Error 20'
  },
  error21: {
    id: 'app.globalMessages.errors.error21',
    defaultMessage: 'Error 21'
  },
  error22: {
    id: 'app.globalMessages.errors.error22',
    defaultMessage: 'Error 22'
  },
  error23: {
    id: 'app.globalMessages.errors.error23',
    defaultMessage: 'Error 23'
  },
  error24: {
    id: 'app.globalMessages.errors.error24',
    defaultMessage: 'Error 24'
  },
  lunchTime: {
    id: 'app.globalMessages.errors.lunchTime',
    defaultMessage: 'Lunch Time'
  },
  syncPackages: {
    id: 'app.globalMessages.errors.syncPackages',
    defaultMessage: 'Sync packages'
  },
  wait: {
    id: 'app.containers.Sanding.wait',
    defaultMessage: 'Wait'
  },
  toRCatChains: {
    id: 'app.containers.Sanding.toRCatChains',
    defaultMessage: 'To RC at chains'
  },
  toBTWChains: {
    id: 'app.containers.Sanding.toBTWChains',
    defaultMessage: 'To between chains'
  },
  toMakkonStorage: {
    id: 'app.containers.Sanding.toMakkonStorage',
    defaultMessage: 'To Makkon storage'
  },
  toRepairStation: {
    id: 'app.containers.Sanding.toRepairStation',
    defaultMessage: 'To repair station'
  },
  toBeforeImeas: {
    id: 'app.containers.Sanding.toBeforeImeas',
    defaultMessage: 'To before IMEAS'
  },
  toAfterImeas: {
    id: 'app.containers.Sanding.toAfterImeas',
    defaultMessage: 'To after IMEAS'
  },
  toCNC: {
    id: 'app.containers.Sanding.toCNC',
    defaultMessage: 'To CNC'
  },
  userManager: {
    id: 'app.containers.UserManager.userManager',
    defaultMessage: 'User Manager'
  },
  forceLogoutMessage: {
    id: 'app.containers.UserManager.forceLogoutMessage',
    defaultMessage: 'Your account has been signed in on another terminal. You will be logged out in 5 seconds.'
  },
  exemptFromSession: {
    id: 'app.containers.UserManager.exemptFromSession',
    defaultMessage: 'Exempt From Session'
  },
  deleteUser: {
    id: 'app.containers.UserManager.deleteUser',
    defaultMessage: 'Delete User'
  },
  testCut: {
    id: 'app.containers.editView.testCut',
    defaultMessage: 'Test Cut Enabled'
  },
  testCutThreshold: {
    id: 'app.containers.editView.testCutThreshold',
    defaultMessage: 'Test Cut Threshold In Meters'
  },
  statisticsSpeedUnavailable: {
    id: 'app.globalMessages.statisticsSpeedUnavailable',
    defaultMessage: 'Not enough data to calculate this speed.'
  },
  statisticsDefaultLedinekExplanation: {
    id: 'app.globalMessages.statisticsDefaultLedinekExplanation',
    defaultMessage:
      'Stopped time without a stop entry counts as a Ledinek stop by default. This time stays in net production time and lowers efficiency and actual avg. capacity. In the selected timeframe: {minutes} minutes counted as Ledinek by default.'
  },
  statisticsDefaultLedinekTime: {
    id: 'app.globalMessages.statisticsDefaultLedinekTime',
    defaultMessage: '({time} by default)'
  },
  statisticsDefaultLedinekGraph: {
    id: 'app.globalMessages.statisticsDefaultLedinekGraph',
    defaultMessage: 'Ledinek by default: {minutes} min. No stop entry recorded; this time is included in efficiency and actual avg. capacity.'
  },
  statisticsActualCapacityCalculation: {
    id: 'app.globalMessages.statisticsActualCapacityCalculation',
    defaultMessage: 'Total linear meters produced divided by net production time.'
  },
  statisticsCapacityEfficiencyCalculation: {
    id: 'app.globalMessages.statisticsCapacityEfficiencyCalculation',
    defaultMessage: 'actual avg. capacity / expected avg. capacity => efficiency [%]'
  },
  statisticsSpeedMinutesCalculation: {
    id: 'app.globalMessages.statisticsSpeedMinutesCalculation',
    defaultMessage:
      '{kind, select, actual {Output produced} other {Output expected}} ÷ time counted{conversion}. Stops that are not Ledinek are not counted.\nExample: {total} {outputUnit} ÷ {minutes} min{conversion} = {speed} {speedUnit}.'
  },
  statisticsSpeedReadingsCalculation: {
    id: 'app.globalMessages.statisticsSpeedReadingsCalculation',
    defaultMessage: 'Add the recorded speeds and divide by the number of readings.\nExample: {total} ÷ {readings} = {speed} {speedUnit}.'
  },
  statisticsEfficiencyCalculation: {
    id: 'app.globalMessages.statisticsEfficiencyCalculation',
    defaultMessage: 'Output produced ÷ output expected x 100, after the selected exclusions.\nExample: {actual} {outputUnit} ÷ {expected} {outputUnit} × 100 = {efficiency}%.'
  },
  statisticsEfficiencyUnavailable: {
    id: 'app.globalMessages.statisticsEfficiencyUnavailable',
    defaultMessage: 'No expected output is available to compare with production.'
  },
  statisticsExpectedSpeedCalculation: {
    id: 'app.globalMessages.statisticsExpectedSpeedCalculation',
    defaultMessage:
      'Expected speed uses the contract capacity, scaled to the actual board cross-section (width x thickness) on the finger jointer. When average board length is below {referenceLength} mm, capacity is scaled down accordingly. \nExamples:\n50 x {minWidth} mm → {minAreaSpeed} m/h\n50 × {maxWidth} mm → {maxAreaSpeed} m/h\nFor an average board length of 2400 mm:\n2400 ÷ {referenceLength} = {lengthPercent}%\n50 × {minWidth} mm: {minAreaSpeed} m/h × {lengthPercent}% = {minTarget} m/h\n50 × {maxWidth} mm: {maxAreaSpeed} m/h × {lengthPercent}% = {maxTarget} m/h'
  },
  statisticsExpectedSpeedExample: {
    id: 'app.globalMessages.statisticsExpectedSpeedExample',
    defaultMessage: '({width} x {thickness} mm): {base} m/h x min({averageLength} ÷ {referenceLength}, 1) = {target} m/h.'
  },
  statisticsEffectiveTimeCalculation: {
    id: 'app.globalMessages.statisticsEffectiveTimeCalculation',
    defaultMessage: 'Time from the first to the last production of each day, including gaps. {example}'
  },
  statisticsEffectiveTimeExample: {
    id: 'app.globalMessages.statisticsEffectiveTimeExample',
    defaultMessage: '\nExample: {start}-{end} = {minutes} min.'
  },
  statisticsNetTimeCalculation: {
    id: 'app.globalMessages.statisticsNetTimeCalculation',
    defaultMessage: 'Time from first to last production - excluded stops, added across the selected days.\nExample: {effective} min - {excluded} min = {net} min net.'
  },
  statisticsProductionTimeCalculation: {
    id: 'app.globalMessages.statisticsProductionTimeCalculation',
    defaultMessage: 'Time of the first and last lamella produced on the finger jointer. Total time is the time between them; net time removes excluded stops.'
  },
  statisticsProductionTimeDurations: {
    id: 'app.globalMessages.statisticsProductionTimeDurations',
    defaultMessage: 'Total: {total} · Available For Production: {net}'
  },
  statisticsProductionTimeSum: {
    id: 'app.globalMessages.statisticsProductionTimeSum',
    defaultMessage: 'Sum — Total: {total} · Net: {net}'
  },
  statisticsProductionTimeExample: {
    id: 'app.globalMessages.statisticsProductionTimeExample',
    defaultMessage: 'Example: {start}-{end}= {effective} min; minus {excluded} min excluded = {net} min net.'
  },
  statisticsNoProduction: {
    id: 'app.globalMessages.statisticsNoProduction',
    defaultMessage: 'No production recorded.'
  },
  statisticsXcutLength: {
    id: 'app.globalMessages.statisticsXcutLength',
    defaultMessage: 'Average Xcut length'
  },
  statisticsLastXcutLength: {
    id: 'app.globalMessages.statisticsLastXcutLength',
    defaultMessage: 'Last recorded Xcut length'
  },
  statisticsDimensions: {
    id: 'app.globalMessages.statisticsDimensions',
    defaultMessage: 'Dimensions (W × T)'
  },
  statisticsLastDimensions: {
    id: 'app.globalMessages.statisticsLastDimensions',
    defaultMessage: 'Last recorded dimensions (W × T)'
  },
  statisticsXcutDescription: {
    id: 'app.globalMessages.statisticsXcutDescription',
    defaultMessage: 'Average board length entering the finger jointer.'
  },
  statisticsTimeframeCalculation: {
    id: 'app.globalMessages.statisticsTimeframeCalculation',
    defaultMessage: 'Time between the selected start and end.\nExample: {range} = {minutes} min.'
  },
  statisticsRunningMetersDescription: {
    id: 'app.globalMessages.statisticsRunningMetersDescription',
    defaultMessage: 'Total linear meters produced in the selected timeframe.'
  },
  statisticsProductionStartDescription: {
    id: 'app.globalMessages.statisticsProductionStartDescription',
    defaultMessage: 'The first recorded production of each selected day.'
  },
  statisticsProductionEndDescription: {
    id: 'app.globalMessages.statisticsProductionEndDescription',
    defaultMessage: 'The last recorded production of each selected day.'
  },
  statisticsBestHourCalculation: {
    id: 'app.globalMessages.statisticsBestHourCalculation',
    defaultMessage: '60-minute period with the most linear meters produced each day.{example}'
  },
  statisticsBestHourExample: {
    id: 'app.globalMessages.statisticsBestHourExample',
    defaultMessage: '\nExample: {start}-{end} produced {meters} m.'
  },
  statisticsOverviewEfficiencyCalculation: {
    id: 'app.globalMessages.statisticsOverviewEfficiencyCalculation',
    defaultMessage: 'Average efficiency of the areas with an expected production target.\nExample: ({values}) ÷ {count} = {efficiency}%.'
  },
  statisticsOutputUnits: {
    id: 'app.globalMessages.statisticsOutputUnits',
    defaultMessage: 'units'
  },
  statisticsSpeedUnits: {
    id: 'app.globalMessages.statisticsSpeedUnits',
    defaultMessage: 'units/min'
  },
  statisticsProductionDataLoading: {
    id: 'app.globalMessages.statisticsProductionDataLoading',
    defaultMessage: 'Loading production data…'
  }
});
